/* eslint-disable no-multiple-empty-lines */
/* eslint-disable spaced-comment */

const RTODetailsData = [
  {
    Number: '-',
    City: '-',
    State: '-',
    Phone: '-',
    Email: '-',
    Address: '-',
  },
  {
    Number: 'AP-02',
    City: 'Anantapur',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Hindupur, Anantapur, Andhra Pradesh - 515201',
  },
  {
    Number: 'AP-09',
    City: 'Hyderabad Central',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Khairatabad, Hyderabad, Andhra Pradesh - 500022',
  },
  {
    Number: 'AP-08',
    City: 'Guntur',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Guntur, Andhra Pradesh',
  },
  {
    Number: 'AP-05',
    City: 'Kakinada',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kakinada, East Godavari, Andhra Pradesh - 533001',
  },
  {
    Number: 'AP-33',
    City: 'Gajuwaka',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Gajuwaka, Andhra Pradesh',
  },
  {
    Number: 'AP-202',
    City: 'GUNTAKAL',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'GUNTAKAL, Andhra Pradesh',
  },
  {
    Number: 'AP-12',
    City: 'Hyderabad South',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kisanbagh, Hyderabad, Telangana - 500064',
  },
  {
    Number: 'AP-14',
    City: 'HYDERABAD',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'HYDERABAD, Andhra Pradesh',
  },
  {
    Number: 'AP-06',
    City: 'Kakinada',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kakinada, East Godavari, Andhra Pradesh - 533001',
  },
  {
    Number: 'AP-39',
    City: 'ANDHRA PRADESH',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'ANDHRA PRADESH, Andhra Pradesh',
  },
  {
    Number: 'AP-07',
    City: 'Guntur',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Guntur, Andhra Pradesh',
  },
  {
    Number: 'AP-03',
    City: 'Chittoor',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Tirupati, Chittoor, Andhra Pradesh - 517501',
  },
  {
    Number: 'AP-21',
    City: 'Kurnool',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Adoni, Kurnool, Andhra Pradesh',
  },
  {
    Number: 'AP-20',
    City: 'Khammam',
    State: 'Andhra Pradesh',
    Phone: '+91-8742-228534',
    Email: '-',
    Address: 'Khammam,Telangana - 507001',
  },
  {
    Number: 'AP-01',
    City: 'Mancherial',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Mancherial, Adilabad, Telangana - 504208',
  },
  {
    Number: 'AP-25',
    City: 'NIZAMABAD',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'NIZAMABAD, Andhra Pradesh',
  },
  {
    Number: 'AP-37',
    City: 'Eluru',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Eluru, Andhra Pradesh',
  },
  {
    Number: 'AP-04',
    City: 'Kadapa',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Proddatur, Kadapa, Andhra Pradesh - 516360',
  },
  {
    Number: 'AP-24',
    City: 'Nalgonda',
    State: 'Andhra Pradesh',
    Phone: '+91-8682-244346',
    Email: '-',
    Address: 'Nalgonda, Telangana - 508247',
  },
  {
    Number: 'AP-11',
    City: 'Hyderabad East',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Malakpet, Hyderabad, Telangana - 500036',
  },
  {
    Number: 'AP-427',
    City: 'MVI DARSI',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'MVI DARSI, Andhra Pradesh',
  },
  {
    Number: 'AP-402',
    City: 'UNIT OFFICE TADIPATRI',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE TADIPATRI, Andhra Pradesh',
  },
  {
    Number: 'AP-26',
    City: 'Nellore',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Nellore, Andhra Pradesh',
  },
  {
    Number: 'AP-705',
    City: 'UNIT OFFICE RAVULAPALEM',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE RAVULAPALEM, Andhra Pradesh',
  },
  {
    Number: 'AP-23',
    City: 'MEDAK',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'MEDAK, Andhra Pradesh',
  },
  {
    Number: 'AP-10',
    City: 'Hyderabad North',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Secunderabad, Hyderabad, Telangana - 500003',
  },
  {
    Number: 'AP-22',
    City: 'Mahbubnagar',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mahbubnagar, Telangana - 509125',
  },
  {
    Number: 'AP-31',
    City: 'Visakhapatnam',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Visakhapatnam, Andhra Pradesh',
  },
  {
    Number: 'AP-27',
    City: 'Ongole',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ongole, Andhra Pradesh',
  },
  {
    Number: 'AP-18',
    City: 'Vijayawada',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Vijayawada, Andhra Pradesh',
  },
  {
    Number: 'AP-32',
    City: 'Visakhapatnam',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Visakhapatnam, Andhra Pradesh',
  },
  {
    Number: 'AP-30',
    City: 'Srikakulam',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Srikakulam, Andhra Pradesh',
  },
  {
    Number: 'AP-35',
    City: 'Vizianagaram',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Vizianagaram, Andhra Pradesh',
  },
  {
    Number: 'AP-707',
    City: 'UNIT OFFICE TENALI',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE TENALI, Andhra Pradesh',
  },
  {
    Number: 'AP-36',
    City: 'WARANGAL',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'WARANGAL, Andhra Pradesh',
  },
  {
    Number: 'AP-29',
    City: 'Ranga Reddy',
    State: 'Andhra Pradesh',
    Phone: '+91-8413-23393051',
    Email: '-',
    Address: 'Ranga Reddy, Telangana - 500074',
  },
  {
    Number: 'AP-16',
    City: 'Vijayawada',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Vijayawada, Andhra Pradesh',
  },
  {
    Number: 'AP-316',
    City: 'NANDIGAMA',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'NANDIGAMA, Andhra Pradesh',
  },
  {
    Number: 'AP-13',
    City: 'Hyderabad West',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Tolichowki, Hyderabad, Telangana - 500008',
  },
  {
    Number: 'AP-616',
    City: 'JAGGAYYAPET',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'JAGGAYYAPET, Andhra Pradesh',
  },
  {
    Number: 'AP-416',
    City: 'NUZVID',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'NUZVID, Andhra Pradesh',
  },
  {
    Number: 'AP-28',
    City: 'Ranga Reddy',
    State: 'Andhra Pradesh',
    Phone: '+91-8413-23393051',
    Email: '-',
    Address: 'Ranga Reddy, Telangana - 500074',
  },
  {
    Number: 'AP-43',
    City: 'KATHIPUDI',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'KATHIPUDI, Andhra Pradesh',
  },
  {
    Number: 'AP-516',
    City: 'VUYYURU',
    State: 'Andhra Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'VUYYURU, Andhra Pradesh',
  },
  //Arunachal Pradesh
  {
    Number: 'AR-08',
    City: 'Along',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Along, West Siang, Arunachal Pradesh - 791001',
  },
  {
    Number: 'AR-20',
    City: 'Namsai',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Arunachal Pardesh',
  },
  {
    Number: 'AR-11',
    City: 'Lohit',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Tezu, Lohit, Arunachal Pradesh - 792001',
  },
  {
    Number: 'AR-07',
    City: 'Daporijo',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Daporijo, Upper Subansiri, Arunachal Pradesh - 791122',
  },
  {
    Number: 'AR-10',
    City: 'Anini',
    State: 'Arunachal Pradesh',
    Phone: '3801-222222',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Anini, Debang Valley, Arunachal Pradesh - 792101',
  },
  {
    Number: 'AR-09',
    City: 'Pasighat',
    State: 'Arunachal Pradesh',
    Phone: '+91-368-2222340',
    Email: '-',
    Address: 'Pasighat, East Siang, Arunachal Pradesh - 791102',
  },
  {
    Number: 'AR-17',
    City: 'ANJAW DISTRICT',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'ANJAW DISTRICT, Arunanchal Pradesh',
  },
  {
    Number: 'AR-13',
    City: 'Khonsa',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Khonsa, Tirap, Arunachal Pradesh - 792130',
  },
  {
    Number: 'AR-26',
    City: 'Shiyomi',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Arunachal Pardesh',
  },
  {
    Number: 'AR-15',
    City: 'Kurung Kumey',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kurung Kumey, Arunachal Pradesh - 791118',
  },
  {
    Number: 'AR-05',
    City: 'Seppa',
    State: 'Arunachal Pradesh',
    Phone: '3787-222576',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Seppa ,East Kameng, Arunachal Pradesh - 790102',
  },
  {
    Number: 'AR-01',
    City: 'Itanagar',
    State: 'Arunachal Pradesh',
    Phone: '+91-360-2245028',
    Email: '-',
    Address: 'Itanagar, Arunachal Pradesh - 791111',
  },
  {
    Number: 'AR-02',
    City: 'Itanagar',
    State: 'Arunachal Pradesh',
    Phone: '+91-360-2245028',
    Email: '-',
    Address: 'Itanagar, Arunachal Pradesh - 791111',
  },
  {
    Number: 'AR-04',
    City: 'Bomdila',
    State: 'Arunachal Pradesh',
    Phone: '+91-3782-222075',
    Email: '-',
    Address: 'Bomdila, West Kamenga, Arunachal Pradesh - 790001',
  },
  {
    Number: 'AR-14',
    City: 'Yingkiong',
    State: 'Arunachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Yingkiong, Upper Siang, Arunachal Pradesh - 791002',
  },
  {
    Number: 'AR-03',
    City: 'Tawang',
    State: 'Arunachal Pradesh',
    Phone: '3794-222221',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Tawang, Arunachal Pradesh - 790104',
  },
  {
    Number: 'AR-16',
    City: 'Roing',
    State: 'Arunachal Pradesh',
    Phone: '3803-222223',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Roing, Lower Dibang Valley, Arunachal Pradesh - 792110',
  },
  {
    Number: 'AR-06',
    City: 'Ziro',
    State: 'Arunachal Pradesh',
    Phone: '3788-224255',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Ziro, Lower Subansiri, Arunachal Pradesh - 791120',
  },
  {
    Number: 'AR-12',
    City: 'Changlang',
    State: 'Arunachal Pradesh',
    Phone: '3808-222221',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Changlang, Arunachal Pradesh - 792122',
  },
  //Assam

  {
    Number: 'AS-33',
    City: 'Charaideo',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-28',
    City: 'Baska',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-15',
    City: 'Barpeta',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Barpeta, Assam - 781301',
  },
  {
    Number: 'AS-05',
    City: 'Golaghat',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Golaghat, Assam - 785621',
  },
  {
    Number: 'AS-12',
    City: 'Sonitpur',
    State: 'Assam',
    Phone: '371-2231063',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Tezpur, Sonitpur, Assam - 784001',
  },
  {
    Number: 'AS-23',
    City: 'Tinsukia',
    State: 'Assam',
    Phone: '374-2330692',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Tinsukia, Assam - 786125',
  },
  {
    Number: 'AS-03',
    City: 'Jorhat',
    State: 'Assam',
    Phone: '376-2320287',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jorhat, Assam - 785001',
  },
  {
    Number: 'AS-13',
    City: 'Darrang',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Mangaldoi, Darrang, Assam - 784125',
  },
  {
    Number: 'AS-34',
    City: 'South Salmara',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-16',
    City: 'Kokrajhar',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kokrajhar, Assam - 783370',
  },
  {
    Number: 'AS-07',
    City: 'Lakhimpur',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Lakhimpur, Assam - 787001',
  },
  {
    Number: 'AS-18',
    City: 'Goalpara',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Goalpara ,Assam - 783101',
  },
  {
    Number: 'AS-22',
    City: 'Dhemaji',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dhemaji, Assam - 787058',
  },
  {
    Number: 'AS-01',
    City: 'Guwahati - Kamrup',
    State: 'Assam',
    Phone: '361-2544160',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Guwahati, Kamrup, Assam - 781001',
  },
  {
    Number: 'AS-19',
    City: 'Bongaigaon',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bongaigaon, Assam - 783390',
  },
  {
    Number: 'AS-09',
    City: 'Diphu, Karbi',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Diphu, Karbi Anglong,Assam - 782460',
  },
  {
    Number: 'AS-27',
    City: 'Udalguri',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-20',
    City: 'Guwahati',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Guwahati, Assam',
  },
  {
    Number: 'AS-21',
    City: 'Morigaon',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Morigaon, Assam - 782105',
  },
  {
    Number: 'AS-08',
    City: 'Dima Hasao',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dima Hasao, Assam - 788931',
  },
  {
    Number: 'AS-04',
    City: 'Sibsagar',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sibsagar, Assam - 785640',
  },
  {
    Number: 'AS-02',
    City: 'Nagaon',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Nagaon, Assam - 782001',
  },
  {
    Number: 'AS-10',
    City: 'Karimganj',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Karimganj, Assam - 788710',
  },
  {
    Number: 'AS-06',
    City: 'Dibrugarh',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dibrugarh, Assam - 786001',
  },
  {
    Number: 'AS-11',
    City: 'Silchar',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Silchar, Cachar, Assam - 788001',
  },
  {
    Number: 'AS-26',
    City: 'Chirang',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Chirang, Assam - 783385',
  },
  {
    Number: 'AS-24',
    City: 'Hailakandi',
    State: 'Assam',
    Phone: '384-4222671',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Hailakandi, Assam - 788155',
  },
  {
    Number: 'AS-29',
    City: 'Majuli',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-31',
    City: 'Hojai',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-32',
    City: 'Biswanath Chariali',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-25',
    City: 'Kamrup(Rural)',
    State: 'Assam',
    Phone: '-',
    Email: '-',
    Address: 'Assam',
  },
  {
    Number: 'AS-17',
    City: 'Dhubri',
    State: 'Assam',
    Phone: '366-2220374',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dhubri, Assam - 783301',
  },
  {
    Number: 'AS-14',
    City: 'Nalbari',
    State: 'Assam',
    Phone: '362-4223076',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Nalbari, Assam - 781335',
  },
  // Bihar

  {
    Number: 'BR-38',
    City: 'Araria',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Araria, Bihar - 854311',
  },
  {
    Number: 'BR-53',
    City: 'Lakhisarai',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Lakhisarai, Bihar - 811311',
  },
  {
    Number: 'BR-26',
    City: 'Aurangabad',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Aurangabad, Bihar - 824101',
  },
  {
    Number: 'BR-51',
    City: 'Banka',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Banka, Bihar - 813101',
  },
  {
    Number: 'BR-02',
    City: 'Gaya',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Gaya, Bihar - 823001',
  },
  {
    Number: 'BR-47',
    City: 'KODERMA',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'KODERMA, Bihar',
  },
  {
    Number: 'BR-57',
    City: 'Rohtas',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Rohtas, Bihar - 802212',
  },
  {
    Number: 'BR-08',
    City: 'Munger',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jamalpur, Munger, Bihar - 811214',
  },
  {
    Number: 'BR-20',
    City: 'BOKARO DISAMBIG',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'BOKARO DISAMBIG, Bihar',
  },
  {
    Number: 'BR-46',
    City: 'Jamui',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jamui, Bihar - 811305',
  },
  {
    Number: 'BR-27',
    City: 'Nawada',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Nawada, Bihar - 805130',
  },
  {
    Number: 'BR-35',
    City: 'SAHEBGANJ',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'SAHEBGANJ, Bihar',
  },
  {
    Number: 'BR-21',
    City: 'Nalanda',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Nalanda, Bihar - 803101',
  },
  {
    Number: 'BR-19',
    City: 'Saharsa',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Saharsa, Bihar - 852201',
  },
  {
    Number: 'BR-16',
    City: 'JAMSHEDPUR',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'JAMSHEDPUR, Bihar',
  },
  {
    Number: 'BR-43',
    City: 'Madhepura',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Madhepura, Bihar - 852113',
  },
  {
    Number: 'BR-01',
    City: 'Patna',
    State: 'Bihar',
    Phone: '612-2237131',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Chajju Bagh, Patna, Bihar - 800001',
  },
  {
    Number: 'BR-50',
    City: 'Supaul',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Supaul, Bihar - 852131',
  },
  {
    Number: 'BR-09',
    City: 'Begusarai',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Begusarai, Bihar - 851101',
  },
  {
    Number: 'BR-05',
    City: 'Motihari',
    State: 'Bihar',
    Phone: '6252-232714',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Motihari, East Champaran, Bihar - 845401',
  },
  {
    Number: 'BR-22',
    City: 'Bettiah',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bettiah, West Champaran, Bihar - 845438',
  },
  {
    Number: 'BR-56',
    City: 'Arwal',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Arwal, Bihar - 824115',
  },
  {
    Number: 'BR-24',
    City: 'Dehri',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dehri, Rohtas, Bihar - 821307',
  },
  {
    Number: 'BR-03',
    City: 'Bhojpur',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bhojpur, Bihar - 802301',
  },
  {
    Number: 'BR-17',
    City: 'DHANBAD',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'DHANBAD, Bihar',
  },
  {
    Number: 'BR-55',
    City: 'Sheohar',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sheohar, Bihar - 843329',
  },
  {
    Number: 'BR-25',
    City: 'Jehanabad',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jehanabad, Bihar - 804408',
  },
  {
    Number: 'BR-34',
    City: 'Khagaria',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Khagaria, Bihar - 848203',
  },
  {
    Number: 'BR-37',
    City: 'Kishanganj',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kishanganj, Bihar - 855107',
  },
  {
    Number: 'BR-10',
    City: 'Bhagalpur',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bhagalpur, Bihar - 812001',
  },
  {
    Number: 'BR-31',
    City: 'Vaishali',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Vaishali, Bihar - 844114',
  },
  {
    Number: 'BR-32',
    City: 'Madhubani',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Madhubani, Bihar - 847211',
  },
  {
    Number: 'BR-44',
    City: 'Buxar',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Buxar, Bihar - 802101',
  },
  {
    Number: 'BR-18',
    City: 'CHAIBASSA',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'CHAIBASSA, Bihar',
  },
  {
    Number: 'BR-14',
    City: 'RANCHI',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'RANCHI, Bihar',
  },
  {
    Number: 'BR-07',
    City: 'Darbhanga',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Darbhanga, Bihar - 846004',
  },
  {
    Number: 'BR-30',
    City: 'Sitamarhi',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sitamarhi, Bihar - 843315',
  },
  {
    Number: 'BR-45',
    City: 'Bhabua',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kaimur, Bhabua, Bihar - 821101',
  },
  {
    Number: 'BR-11',
    City: 'Purnia',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Purnia, Bihar - 854301',
  },
  {
    Number: 'BR-06',
    City: 'Muzaffarpur',
    State: 'Bihar',
    Phone: '621-2244792',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Muzaffarpur, Bihar - 842001',
  },
  {
    Number: 'BR-33',
    City: 'Samastipur',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Samastipur, Bihar - 848101',
  },
  {
    Number: 'BR-04',
    City: 'Chapra',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Chapra, Saran, Bihar - 841301',
  },
  {
    Number: 'BR-29',
    City: 'Siwan',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Siwan, Bihar - 841226',
  },
  {
    Number: 'BR-15',
    City: 'PALAMU',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'PALAMU, Bihar',
  },
  {
    Number: 'BR-52',
    City: 'Sheikhpura',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sheikhpura, Bihar - 811103',
  },
  {
    Number: 'BR-39',
    City: 'Katihar',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Katihar, Bihar - 854105',
  },
  {
    Number: 'BR-28',
    City: 'Gopalganj',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Gopalganj, Bihar - 841428',
  },
  {
    Number: 'BR-13',
    City: 'Hazaribagh',
    State: 'Bihar',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Hazaribagh, Jharkhand - 825301',
  },
  //Chandigarh
  {
    Number: 'CH-01',
    City: 'Chandigarh',
    State: 'Chandigarh',
    Phone: '+91-172-2700341',
    Email: '[email protected]',
    Address: 'Sector 17, Chandigarh - 160017',
  },
  {
    Number: 'CH-02',
    City: 'CHANDIGARH DISTR',
    State: 'Chandigarh',
    Phone: '-',
    Email: '-',
    Address: 'CHANDIGARH DISTR, Chandigarh',
  },
  {
    Number: 'CH-03',
    City: 'CHANDIGARH DISTR',
    State: 'Chandigarh',
    Phone: '-',
    Email: '-',
    Address: 'CHANDIGARH DISTR, Chandigarh',
  },
  {
    Number: 'CH-04',
    City: 'CHANDIGARH DISTR',
    State: 'Chandigarh',
    Phone: '-',
    Email: '-',
    Address: 'CHANDIGARH DISTR, Chandigarh',
  },
  //Chhattisgarh

  {
    Number: 'CG-15',
    City: 'Ambikapur',
    State: 'Chhattisgarh',
    Phone: '+91-7774-220725',
    Email: '-',
    Address: 'Ambikapur, Chhattisgarh - 497001',
  },
  {
    Number: 'CG-11',
    City: 'Janjgir-Champa',
    State: 'Chhattisgarh',
    Phone: '+91-7807-224055',
    Email: '-',
    Address: 'Janjgir-Champa, Chhattisgarh - 495671',
  },
  {
    Number: 'CG-16',
    City: 'Baikunthpur',
    State: 'Chhattisgarh',
    Phone: '+91-7836-296313',
    Email: '-',
    Address: 'Baikunthpur, Koriya, Chhattisgarh - 497335',
  },
  {
    Number: 'CG-21',
    City: 'Narayanpur',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Narayanpur, Chhattisgarh - 494661',
  },
  {
    Number: 'CG-30',
    City: 'Balrampur',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Balrampur, Surguja, Chhattisgarh - 497119',
  },
  {
    Number: 'CG-28',
    City: 'Mungeli',
    State: 'Chhattisgarh',
    Phone: '+91-7752-402080',
    Email: '-',
    Address: 'Mungeli, Bilaspur, Chhattisgarh - 495334',
  },
  {
    Number: 'CG-12',
    City: 'Korba',
    State: 'Chhattisgarh',
    Phone: '+91-7759-228751',
    Email: '-',
    Address: 'Korba, Chhattisgarh - 495677',
  },
  {
    Number: 'CG-26',
    City: 'Sukma',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Sukma, Dantewada, Chhattisgarh - 494111',
  },
  {
    Number: 'CG-20',
    City: 'Bijapur',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Bijapur, Chhattisgarh - 494447',
  },
  {
    Number: 'CG-01',
    City: 'Gvnr CHATTISGARH',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Gvnr CHATTISGARH, Chhattisgarh',
  },
  {
    Number: 'CG-02',
    City: 'Govt CHATTISGARH',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Govt CHATTISGARH, Chhattisgarh',
  },
  {
    Number: 'CG-19',
    City: 'Kanker',
    State: 'Chhattisgarh',
    Phone: '+91-7868-241261',
    Email: '-',
    Address: 'Kanker, Chhattisgarh - 494336',
  },
  {
    Number: 'CG-07',
    City: 'Durg',
    State: 'Chhattisgarh',
    Phone: '+91-788-2324815',
    Email: '-',
    Address: 'Durg, Chhattisgarh - 490001',
  },
  {
    Number: 'CG-29',
    City: 'Surajpur',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Surajpur, Surguja, Chhattisgarh - 497229',
  },
  {
    Number: 'CG-22',
    City: 'Bemetara',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Bemetara, Chhattisgarh - 491335',
  },
  {
    Number: 'CG-25',
    City: 'Bemetara',
    State: 'Chhattisgarh',
    Phone: '+91-788-2324815',
    Email: '-',
    Address: 'Bemetara, Durg, Chhattisgarh - 491335',
  },
  {
    Number: 'CG-05',
    City: 'Dhamtari',
    State: 'Chhattisgarh',
    Phone: '+91-7722-238006',
    Email: '-',
    Address: 'Dhamtari, Chhattisgarh - 493770',
  },
  {
    Number: 'CG-06',
    City: 'Mahasamund',
    State: 'Chhattisgarh',
    Phone: '+91-7723-224697',
    Email: '-',
    Address: 'Mahasamund, Chhattisgarh - 493554',
  },
  {
    Number: 'CG-18',
    City: 'Dantewada',
    State: 'Chhattisgarh',
    Phone: '+91-7856-252653',
    Email: '-',
    Address: 'Dantewada, Chhattisgarh - 494552',
  },
  {
    Number: 'CG-04',
    City: 'Raipur',
    State: 'Chhattisgarh',
    Phone: '+91-771-2563155',
    Email: '-',
    Address: 'Telibandha, Raipur, Chattisgarh - 492006',
  },
  {
    Number: 'CG-14',
    City: 'Jashpur',
    State: 'Chhattisgarh',
    Phone: '+91-7763-220916',
    Email: '-',
    Address: 'Jashpur, Chhattisgarh - 496331',
  },
  {
    Number: 'CG-24',
    City: 'Baloda Bazar',
    State: 'Chhattisgarh',
    Phone: '+91-771-2563155',
    Email: '-',
    Address: 'Baloda Bazar, Raipur, Chhattisgarh - 493332',
  },
  {
    Number: 'CG-08',
    City: 'Rajnandgaon',
    State: 'Chhattisgarh',
    Phone: '+91-7744-223659',
    Email: '-',
    Address: 'Rajnandgaon, Chhattisgarh - 491441',
  },
  {
    Number: 'CG-10',
    City: 'Bilaspur',
    State: 'Chhattisgarh',
    Phone: '+91-7752-402080',
    Email: '-',
    Address: 'Bilaspur, Chhattisgarh - 495001',
  },
  {
    Number: 'CG-23',
    City: 'Mungeli',
    State: 'Chhattisgarh',
    Phone: '7752-402080',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Mungeli, Bilaspur, Chhattisgarh - 495334',
  },
  {
    Number: 'CG-99',
    City: 'State Transport Authority',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Chhattisgarh',
  },
  {
    Number: 'CG-09',
    City: 'Kabirdham',
    State: 'Chhattisgarh',
    Phone: '+91-7741-233556',
    Email: '-',
    Address: 'Kabirdham, Chhattisgarh - 491336',
  },
  {
    Number: 'CG-03',
    City: 'CHATTISGARH',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Raipur, Chhattisgarh',
  },
  {
    Number: 'CG-27',
    City: 'Kondagaon',
    State: 'Chhattisgarh',
    Phone: '-',
    Email: '-',
    Address: 'Kondagaon, Bastar, Chhattisgarh - 494226',
  },
  {
    Number: 'CG-13',
    City: 'Raigarh',
    State: 'Chhattisgarh',
    Phone: '+91-7762-225026',
    Email: '-',
    Address: 'Raigarh, Chhattisgarh - 496551',
  },
  //Delhi

  {
    Number: 'DL-06',
    City: 'Central Delhi - Sarai Kale Khan',
    State: 'Delhi',
    Phone: '+91-11-24351100',
    Email: '-',
    Address: 'Sarai Kale Khan, Delhi',
  },
  {
    Number: 'DL-05',
    City: 'East Delhi - Loni Road',
    State: 'Delhi',
    Phone: '+91-11-22813475',
    Email: '-',
    Address: 'Loni Road, Shahdara, East Delhi, Delhi - 110032',
  },
  {
    Number: 'DL-18',
    City: 'Ghaziabad due to the NCR',
    State: 'Delhi',
    Phone: 'NIL',
    Email: '-',
    Address: 'Ghaziabad, Uttar Pradesh – 201002',
  },
  {
    Number: 'DL-07',
    City: 'East Delhi - Mayur Vihar',
    State: 'Delhi',
    Phone: '+91-11-22753800',
    Email: '-',
    Address: 'Mayur Vihar, East Delhi, Delhi - 110091',
  },
  {
    Number: 'DL-01',
    City: 'North Delhi - Mall Road',
    State: 'Delhi',
    Phone: '+91-11-23819191 / 92',
    Email: '-',
    Address: 'Mall Road, North Delhi, Delhi - 110007',
  },
  {
    Number: 'DL-02',
    City: 'New Delhi - Tilak Marg',
    State: 'Delhi',
    Phone: '+91-11-23378886 / 77',
    Email: '-',
    Address: 'Tilak Marg, New Delhi - 110001',
  },
  {
    Number: 'DL-17',
    City: 'Noida due to the NCR',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'Noida, Uttar Pradesh - 201301',
  },
  {
    Number: 'DL-2C',
    City: 'I P DEPOT',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'I P DEPOT, Delhi',
  },
  {
    Number: 'DL-7C',
    City: 'MAYUR VIHAR',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'MAYUR VIHAR, Delhi',
  },
  {
    Number: 'DL-16',
    City: 'Faridabad due to the NCR',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'Faridabad, Haryana - 121001',
  },
  {
    Number: 'DL-04',
    City: 'West Delhi - Janakpuri',
    State: 'Delhi',
    Phone: '+91-11-25551618 / 25531002',
    Email: '-',
    Address: 'Janakpuri, West Delhi, Delhi - 110058',
  },
  {
    Number: 'DL-9C',
    City: 'PALAM',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'PALAM, Delhi',
  },
  {
    Number: 'DL-6C',
    City: 'SARAI KALE KH',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'SARAI KALE KH, Delhi',
  },
  {
    Number: 'DL-15',
    City: 'Gurgaon due to the NCR',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'Gurgaon, Haryana - 122001',
  },
  {
    Number: 'DL-51',
    City: 'Rajpur Road',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'Delhi',
  },
  {
    Number: 'DL-14',
    City: 'Sonipat due to the NCR',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'Sonipat, Haryana - 131001',
  },
  {
    Number: 'DL-09',
    City: 'South West Delhi - Janakpuri / Palam',
    State: 'Delhi',
    Phone: '+91-11-25624064 / 25163615',
    Email: '-',
    Address: 'Palam, Janakpuri, Delhi - 110058',
  },
  {
    Number: 'DL-13',
    City: 'East Delhi - Surajmal Vihar / Shahdara',
    State: 'Delhi',
    Phone: '+91-11-22383900',
    Email: '-',
    Address: 'Surajmal Vihar, East Delhi, Delhi - 110092',
  },
  {
    Number: 'DL-8C',
    City: 'WazirPur/AshokVihar',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'WazirPur/AshokVihar, Delhi',
  },
  {
    Number: 'DL-3C',
    City: 'SHEKH SARAI',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'SHEKH SARAI, Delhi',
  },
  {
    Number: 'DL-12',
    City: 'South West Delhi - Vasant Vihar',
    State: 'Delhi',
    Phone: '+91-11-26146498',
    Email: '-',
    Address: 'Vasant Vihar, South West Delhi, Delhi - 110057',
  },
  {
    Number: 'DL-4C',
    City: 'RAJA GARDEN',
    State: 'Delhi',
    Phone: '-',
    Email: '-',
    Address: 'RAJA GARDEN, Delhi',
  },
  {
    Number: 'DL-11',
    City: 'North West Delhi - Rohini',
    State: 'Delhi',
    Phone: '+91-11-27563535',
    Email: '-',
    Address: 'Rohini, North West Delhi, Delhi - 110085',
  },
  {
    Number: 'DL-03',
    City: 'South Delhi - Sheikh Sarai',
    State: 'Delhi',
    Phone: '+91-11-29259800 / 29253535',
    Email: '-',
    Address: 'DDA Market, Sheikh Sarai, South Delhi, Delhi - 110017',
  },
  {
    Number: 'DL-10',
    City: 'West Delhi - Raja Garden',
    State: 'Delhi',
    Phone: '+91-11-25163616',
    Email: '-',
    Address: 'Raja Garden, Delhi - 110027',
  },
  //Goa
  {
    Number: 'GA-04',
    City: 'Bicholim',
    State: 'Goa',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bicholim, North Goa, Goa - 403504',
  },
  {
    Number: 'GA-01',
    City: 'North Goa',
    State: 'Goa',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Panaji, North Goa, Goa - 403001',
  },
  {
    Number: 'GA-06',
    City: 'Vasco Da Gama',
    State: 'Goa',
    Phone: '832-2515100',
    Email: '-',
    Address:
      'The Regional Transport Officer ( RTO ), Goia Building, Above Tea Corner, Vasco Da Gama, South Goa, Goa - 403802',
  },
  {
    Number: 'GA-05',
    City: 'Ponda',
    State: 'Goa',
    Phone: '832-2312749',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Ponda, North Goa, Goa - 403401',
  },
  {
    Number: 'GA-10',
    City: 'Canacona',
    State: 'Goa',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Canacona, South Goa, Goa - 403702',
  },
  {
    Number: 'GA-12',
    City: 'Dharbandora',
    State: 'Goa',
    Phone: '-',
    Email: '-',
    Address: 'Dharbandora, South Goa, Goa - 403406',
  },
  {
    Number: 'GA-07',
    City: 'Panaji',
    State: 'Goa',
    Phone: '+91-832-2438288',
    Email: '-',
    Address: 'KTC Complex, Panaji, North Goa, Goa - 403001',
  },
  {
    Number: 'GA-08',
    City: 'Margao',
    State: 'Goa',
    Phone: '+91-832-2730019',
    Email: '-',
    Address: 'Osia Complex, Spdo Arcade, Near New Fish Market, Bus Stand, Margao,Goa - 403601',
  },
  {
    Number: 'GA-11',
    City: 'Pernem',
    State: 'Goa',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Pernem, North Goa, Goa - 403512',
  },
  {
    Number: 'GA-09',
    City: 'Quepem',
    State: 'Goa',
    Phone: '832-2664411',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Quepem, South Goa, Goa - 403705',
  },
  {
    Number: 'GA-03',
    City: 'Mapusa',
    State: 'Goa',
    Phone: '+91-832-2250254',
    Email: '-',
    Address: 'Mian Road, Mapusa, North Goa, Goa - 403507',
  },
  {
    Number: 'GA-02',
    City: 'South Goa',
    State: 'Goa',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Margao, South Goa, Goa - 403601',
  },
  //Gujarat

  {
    Number: 'GJ-01',
    City: 'Ahmedabad',
    State: 'Gujarat',
    Phone: '+91-79-27559696',
    Email: '-',
    Address: 'Subhash Bridge, Sabarmati, Ahmedabad, Gujarat - 380027',
  },
  {
    Number: 'GJ-30',
    City: 'Aahwa',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Gujrat',
  },
  {
    Number: 'GJ-33',
    City: 'Aravalli - Modasa',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Modasa, Aravalli, Gujarat - 383315',
  },
  {
    Number: 'GJ-19',
    City: 'Bardoli',
    State: 'Gujarat',
    Phone: '+91-2622-223457',
    Email: '-',
    Address: 'Opposite Power House, Octroy Naka, Bardoli, Surat, Gujarat - 344601',
  },
  {
    Number: 'GJ-32',
    City: 'Botad',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Botad, Bhavnagar, Gujarat - 364710',
  },
  {
    Number: 'GJ-11',
    City: 'Junagadh',
    State: 'Gujarat',
    Phone: '+91-285-2657609',
    Email: '-',
    Address: 'Majevadi Darvaja, Junagadh, Gujarat - 362001',
  },
  {
    Number: 'GJ-21',
    City: 'Navsari',
    State: 'Gujarat',
    Phone: '+91-2638-250525',
    Email: '-',
    Address: 'Italva, Navsari, Gujarat - 396445',
  },
  {
    Number: 'GJ-03',
    City: 'Rajkot',
    State: 'Gujarat',
    Phone: '+91-281-2703366',
    Email: '-',
    Address: 'Near Market Yard, Rajkot, Gujarat - 360001',
  },
  {
    Number: 'GJ-09',
    City: 'Himmatnagar',
    State: 'Gujarat',
    Phone: '+91-2772-222597',
    Email: '-',
    Address: 'Savgadh Vijapur Road, Himatnagar, Sabarkantha, Gujarat - 383001',
  },
  {
    Number: 'GJ-10',
    City: 'Jamnagar',
    State: 'Gujarat',
    Phone: '+91-288-2672100',
    Email: '-',
    Address: 'Lal Bangla Compound, Jamnagar, Gujarat - 388005',
  },
  {
    Number: 'GJ-18',
    City: 'Gandhinagar',
    State: 'Gujarat',
    Phone: '+91-79232-40954',
    Email: '-',
    Address: 'Near G0 Circle, Gandhinagar, Gujarat - 382421',
  },
  {
    Number: 'GJ-38',
    City: 'Gir Somnath - Veraval',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Veraval, Rajkot, Gujarat - 360024',
  },
  {
    Number: 'GJ-12',
    City: 'Kuch-Bhuj',
    State: 'Gujarat',
    Phone: '+91-2832-251566',
    Email: '-',
    Address: 'Madhaper Road, Near Military Hospital, Kuch-Bhuj, Gujarat - 370000',
  },
  {
    Number: 'GJ-16',
    City: 'Bharuch',
    State: 'Gujarat',
    Phone: '+91-2642-240653',
    Email: '-',
    Address: 'Nandevan Chockdi, Bharuch, Gujarat - 392001',
  },
  {
    Number: 'GJ-24',
    City: 'Patan',
    State: 'Gujarat',
    Phone: '+91-2766-223100',
    Email: '-',
    Address: 'GIDC Astet Building, Near Navjivan Hotel, Sidhpur Cross Road,Patan, Gujarat - 384265',
  },
  {
    Number: 'GJ-02',
    City: 'Mehsana',
    State: 'Gujarat',
    Phone: '+91-2762-226947',
    Email: '-',
    Address: 'Near Khari Nadi, Palavasna Highway, Mahesana, Gujarat - 384002',
  },
  {
    Number: 'GJ-17',
    City: 'Godhara',
    State: 'Gujarat',
    Phone: '+91-2672-242724',
    Email: '-',
    Address: 'Near Commerce College, Godhra, Panchmahal, Gujarat - 389001',
  },
  {
    Number: 'GJ-27',
    City: 'Ahmedabad East (Vastral)',
    State: 'Gujarat',
    Phone: '+91-79-27559695',
    Email: '-',
    Address: 'Mahadev Nagar Tekra, Vastral, Ahmedabad, Gujarat - 380023',
  },
  {
    Number: 'GJ-36',
    City: 'Morbi',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Morbi, Rajkot, Gujarat - 363641',
  },
  {
    Number: 'GJ-31',
    City: 'Gandhidham',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Gandhidham, Kachchh, Gujarat - 370201',
  },
  {
    Number: 'GJ-14',
    City: 'Amreli',
    State: 'Gujarat',
    Phone: '+91-2792-223313',
    Email: '-',
    Address: 'MS Building, Rajmahel Compound, Rajula, Amreli, Gujarat - 365001',
  },
  {
    Number: 'GJ-37',
    City: 'Chhota Udaipur',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Chhota Udaipur, Vadodara, Gujarat - 391165',
  },
  {
    Number: 'GJ-20',
    City: 'Dahod',
    State: 'Gujarat',
    Phone: '+91-2673-243200',
    Email: '-',
    Address: 'Dharbada Chockdi, Highway Bypass, Dahod, Gujarat - 389051',
  },
  {
    Number: 'GJ-34',
    City: 'Dwarka',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Dwarka, Jamnagar, Gujarat - 361335',
  },
  {
    Number: 'GJ-05',
    City: 'Surat City',
    State: 'Gujarat',
    Phone: '+91-261-2464902',
    Email: '-',
    Address: 'Ring Road, Nanpura, Surat, Gujarat - 385001',
  },
  {
    Number: 'GJ-04',
    City: 'Bhavnagar',
    State: 'Gujarat',
    Phone: '+91-278-2424004',
    Email: '-',
    Address: 'Dhanechi Vadla, Bhavnagar, Gujarat - 364003',
  },
  {
    Number: 'GJ-23',
    City: 'Anand',
    State: 'Gujarat',
    Phone: '+91-2692-264800',
    Email: '-',
    Address: 'Sevasadan Ground, DSP Office, Borsad Chockdi, Anand, Gujarat -388001',
  },
  {
    Number: 'GJ-9',
    City: 'SABARKANTHA',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'SABARKANTHA, Gujrat',
  },
  {
    Number: 'GJ-25',
    City: 'Porbandar (Sudamapuri)',
    State: 'Gujarat',
    Phone: '+91-286-2222215',
    Email: '-',
    Address: 'Opposite DSP Office, New Kuvara, Vadia Road, Porbandar, Gujarat -360575',
  },
  {
    Number: 'GJ-07',
    City: 'Nadiad',
    State: 'Gujarat',
    Phone: '+91-268-2550213',
    Email: '-',
    Address: 'Mile Road, Nadiad, Kheda, Gujarat - 387001',
  },
  {
    Number: 'GJ-13',
    City: 'Surendranagar',
    State: 'Gujarat',
    Phone: '+91-2752-283152',
    Email: '-',
    Address: 'C Block, MS Building, Khorali Road, Surendranagar, Gujarat - 363001',
  },
  {
    Number: 'GJ-15',
    City: 'Valsad',
    State: 'Gujarat',
    Phone: '+91-2632-226622',
    Email: '-',
    Address: 'Atakpardi, Dharanpur Road, Valsad, Gujarat - 369001',
  },
  {
    Number: 'GJ-26',
    City: 'Vyara',
    State: 'Gujarat',
    Phone: '+91-2626-223390',
    Email: '-',
    Address: 'Panvadi, Bhenskatri Road, Vyara, Gujarat - 394650',
  },
  {
    Number: 'GJ-08',
    City: 'Palanpur',
    State: 'Gujarat',
    Phone: '+91-2742-252370',
    Email: '-',
    Address: 'Balaram Road, Highway, Palanpur, Banaskatha, Gujarat - 385001',
  },
  {
    Number: 'GJ-29',
    City: 'PARTS OF VADODAR',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'PARTS OF VADODAR, Gujrat',
  },
  {
    Number: 'GJ-35',
    City: 'Mahisagar - Lunavada',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'Lunavada, Mahisagar, Gujarat - 389230',
  },
  {
    Number: 'GJ-28',
    City: 'PARTS OF SURAT',
    State: 'Gujarat',
    Phone: '-',
    Email: '-',
    Address: 'PARTS OF SURAT, Gujrat',
  },
  {
    Number: 'GJ-06',
    City: 'Vadodara City',
    State: 'Gujarat',
    Phone: '+91-265-2561130',
    Email: '-',
    Address: 'Near Varasiya Road, Vadodra, Gujarat - 390006',
  },
  //Haryana
  {
    Number: 'HR-07',
    City: 'Kurukshetra',
    State: 'Haryana',
    Phone: '+91-1744-220032',
    Email: '-',
    Address: 'Kurukshetra, Haryana - 136118',
  },
  {
    Number: 'HR-29',
    City: 'Ballabgarh',
    State: 'Haryana',
    Phone: '+91-129-2304500',
    Email: '-',
    Address: 'Ballabgarh, Faridabad, Haryana - 121004',
  },
  {
    Number: 'HR-67',
    City: 'Panipat',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Panipat, Haryana - 132103',
  },
  {
    Number: 'HR-53',
    City: 'Adampur',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Adampur, Hisar, Haryana - 125052',
  },
  {
    Number: 'HR-77',
    City: 'Beri',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Beri, Jhajjar, Haryana - 124201',
  },
  {
    Number: 'HR-65',
    City: 'Kurukshetra',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kurukshetra, Haryana - 136118',
  },
  {
    Number: 'HR-22',
    City: 'Fatehabad',
    State: 'Haryana',
    Phone: '+91-1667-230011',
    Email: '-',
    Address: 'Fatehabad, Haryana - 125050',
  },
  {
    Number: 'HR-40',
    City: 'Assandh',
    State: 'Haryana',
    Phone: '+91-1749-278334',
    Email: '-',
    Address: 'Assandh, Karnal, Haryana - 132039',
  },
  {
    Number: 'HR-42',
    City: 'Ganaur',
    State: 'Haryana',
    Phone: '1264-2460810',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Ganaur, Sonipat, Haryana - 131101',
  },
  {
    Number: 'HR-98',
    City: 'Badshahpur',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Tehsil Badshahpur, opp Boom Plaza, Sushant Lok III, Sector 57, Gurgaon-122003',
  },
  {
    Number: 'HR-33',
    City: 'Safidon',
    State: 'Haryana',
    Phone: '+91-1686-262050',
    Email: '-',
    Address: 'Safidon, Jind, Haryana - 126112',
  },
  {
    Number: 'HR-81',
    City: 'Bawal',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bawal, Mahendragarh, Haryana - 123501',
  },
  {
    Number: 'HR-19',
    City: 'Charkhi Dadri',
    State: 'Haryana',
    Phone: '+91-1250-220053',
    Email: '-',
    Address: 'Charkhi Dadri, Bhiwani, Haryana - 127306',
  },
  {
    Number: 'HR-26',
    City: 'Gurgaon (North)',
    State: 'Haryana',
    Phone: '+91-124-2321808 / 2224444',
    Email: '-',
    Address: 'Gurgaon (North), Haryana - 122018',
  },
  {
    Number: 'HR-28',
    City: 'Ferozepur Jhirka',
    State: 'Haryana',
    Phone: '+91-1268-277222',
    Email: '-',
    Address: 'Ferozepur Jhirka, Gurgaon, Haryana - 122104',
  },
  {
    Number: 'HR-97',
    City: 'Ladwa',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-20',
    City: 'Hisar',
    State: 'Haryana',
    Phone: '+91-1662-232798',
    Email: '-',
    Address: 'Hisar, Haryana - 125001',
  },
  {
    Number: 'HR-18',
    City: 'Loharu',
    State: 'Haryana',
    Phone: '+91-1252-258227',
    Email: '-',
    Address: 'Loharu, Bhiwani, Haryana - 127201',
  },
  {
    Number: 'HR-61',
    City: 'Bhiwani',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Bhiwani, Haryana - 127021',
  },
  {
    Number: 'HR-56',
    City: 'Jind',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jind, Haryana - 126102',
  },
  {
    Number: 'HR-31',
    City: 'Jind',
    State: 'Haryana',
    Phone: '+91-1681-269103',
    Email: '-',
    Address: 'Jind, Haryana - 126102',
  },
  {
    Number: 'HR-58',
    City: 'Jagadhari - Yamuna Nagar',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Jagadhari, Yamuna Nagar, Haryana - 135001',
  },
  {
    Number: 'HR-02',
    City: 'Jagadhri - Yamuna Nagar',
    State: 'Haryana',
    Phone: '+91-1732-237805',
    Email: '-',
    Address: 'Jagadhri, Yamuna Nagar, Haryana - 135003',
  },
  {
    Number: 'HR-82',
    City: 'Kanina',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-11',
    City: 'Gohana',
    State: 'Haryana',
    Phone: '+91-1263-252049',
    Email: '-',
    Address: 'Gohana, Sonepat, Haryana - 131301',
  },
  {
    Number: 'HR-09',
    City: 'Guhla',
    State: 'Haryana',
    Phone: '1743-221234',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Guhla, Kaithal, Haryana - 136035',
  },
  {
    Number: 'HR-74',
    City: 'Mewat (Nuh)',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Mewat (Nuh), Gurgaon, Haryana - 122107',
  },
  {
    Number: 'HR-03',
    City: 'Panchkula',
    State: 'Haryana',
    Phone: '+91-172-2561685',
    Email: '-',
    Address: 'Panchkula, Haryana - 134109',
  },
  {
    Number: 'HR-80',
    City: 'Barwala',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Barwala, Hisar, Haryana - 134118',
  },
  {
    Number: 'HR-75',
    City: 'Indri',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Indri, Karnal, Haryana - 132041',
  },
  {
    Number: 'HR-93',
    City: 'Sdm Punhana',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-39',
    City: 'Hisar',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Hisar, Haryana - 125001',
  },
  {
    Number: 'HR-68',
    City: 'Panchkula',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Panchkula, Haryana - 134109',
  },
  {
    Number: 'HR-51',
    City: 'Faridabad',
    State: 'Haryana',
    Phone: '+91-129-2227868',
    Email: '-',
    Address: 'Faridabad, Haryana - 121001',
  },
  {
    Number: 'HR-70',
    City: 'Chandigarh',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Chandigarh, Haryana - 160017',
  },
  {
    Number: 'HR-63',
    City: 'Jhajjar',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jhajjar, Haryana - 124507',
  },
  {
    Number: 'HR-13',
    City: 'Bahadurgarh',
    State: 'Haryana',
    Phone: '+91-1276-230306',
    Email: '-',
    Address: 'Bahadurgarh, Jhajjar, Haryana - 124507',
  },
  {
    Number: 'HR-10',
    City: 'Sonepat',
    State: 'Haryana',
    Phone: '+91-130-2222100',
    Email: '-',
    Address: 'Sonepat, Haryana - 131001',
  },
  {
    Number: 'HR-89',
    City: 'Sdm Badli',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-16',
    City: 'Bhiwani',
    State: 'Haryana',
    Phone: '+91-1664-242101',
    Email: '-',
    Address: 'Bhiwani, Haryana - 127021',
  },
  {
    Number: 'HR-46',
    City: 'Rohtak',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Rohtak, Haryana - 124001',
  },
  {
    Number: 'HR-35',
    City: 'Narnaul',
    State: 'Haryana',
    Phone: '+91-1282-251153',
    Email: '-',
    Address: 'Narnaul, Mahendragarh, Haryana - 123001',
  },
  {
    Number: 'HR-30',
    City: 'Palwal',
    State: 'Haryana',
    Phone: '+91-1275-252700',
    Email: '-',
    Address: 'Palwal, Faridabad, Haryana - 121102',
  },
  {
    Number: 'HR-45',
    City: 'Karnal',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Karnal, Haryana - 132001',
  },
  {
    Number: 'HR-43',
    City: 'Kosli',
    State: 'Haryana',
    Phone: '+91-1259-275106',
    Email: '-',
    Address: 'Kosli, Rewari, Haryana - 123302',
  },
  {
    Number: 'HR-64',
    City: 'Kaithal',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kaithal, Haryana - 136027',
  },
  {
    Number: 'HR-04',
    City: 'Naraingarh',
    State: 'Haryana',
    Phone: '+91-1734-284008',
    Email: '-',
    Address: 'Naraingarh, Ambala, Haryana - 134201',
  },
  {
    Number: 'HR-37',
    City: 'Ambala',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Ambala, Haryana - 133001',
  },
  {
    Number: 'HR-08',
    City: 'Kaithal',
    State: 'Haryana',
    Phone: '+91-1746-234220',
    Email: '-',
    Address: 'Kaithal, Haryana - 136027',
  },
  {
    Number: 'HR-88',
    City: 'Sdm Badhra',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-44',
    City: 'Ellenabad',
    State: 'Haryana',
    Phone: '+91-1698-220287',
    Email: '-',
    Address: 'Ellenabad, Sirsa, Haryana - 125102',
  },
  {
    Number: 'HR-32',
    City: 'Narwana',
    State: 'Haryana',
    Phone: '1684-240130',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Narwana, Jind, Haryana - 126115',
  },
  {
    Number: 'HR-99',
    City: 'RAMPURA PHUL',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'RAMPURA PHUL, Haryana',
  },
  {
    Number: 'HR-84',
    City: 'Rta Charki Dadri',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-94',
    City: 'Sdm Kalanwali',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-72',
    City: 'Gurgaon (South)',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Gurgaon (South), Haryana - 122018',
  },
  {
    Number: 'HR-36',
    City: 'Rewari',
    State: 'Haryana',
    Phone: '+91-1274-222270',
    Email: '-',
    Address: 'Rewari, Haryana - 123302',
  },
  {
    Number: 'HR-25',
    City: 'Dabwali',
    State: 'Haryana',
    Phone: '+91-1668-222997',
    Email: '-',
    Address: 'Dabwali, Haryana - 125104',
  },
  {
    Number: 'HR-87',
    City: 'Sdm Badkhal',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-60',
    City: 'Samalkha',
    State: 'Haryana',
    Phone: '+91-180-2571100',
    Email: '-',
    Address: 'Samalkha, Panipat, Haryana - 132101',
  },
  {
    Number: 'HR-50',
    City: 'Hodal',
    State: 'Haryana',
    Phone: '1275-235836',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Hodal, Faridabad, Haryana - 121106',
  },
  {
    Number: 'HR-41',
    City: 'Pehowa',
    State: 'Haryana',
    Phone: '+91-1741-220448',
    Email: '-',
    Address: 'Pehowa, Kurukshetra, Haryana - 136128',
  },
  {
    Number: 'HR-71',
    City: 'Bilaspur',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bilaspur, Gurgaon, Haryana - 135102',
  },
  {
    Number: 'HR-79',
    City: 'Kharkhoda',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kharkhoda, Sonipat, Haryana - 131402',
  },
  {
    Number: 'HR-90',
    City: 'Sdm Uchana',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-34',
    City: 'Mahendragarh',
    State: 'Haryana',
    Phone: '1285-220228',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Mahendragarh, Haryana - 123001',
  },
  {
    Number: 'HR-55',
    City: 'Gurgaon',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Gurgaon, Haryana - 122001',
  },
  {
    Number: 'HR-38',
    City: 'Faridabad',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Faridabad, Haryana - 121001',
  },
  {
    Number: 'HR-59',
    City: 'Ratia',
    State: 'Haryana',
    Phone: '+91-1697-251700',
    Email: '-',
    Address: 'Ratia, Fatehabad, Haryana - 125051',
  },
  {
    Number: 'HR-49',
    City: 'Kalka',
    State: 'Haryana',
    Phone: '1733-220500',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Kalka, Panchkula, Haryana - 133302',
  },
  {
    Number: 'HR-52',
    City: 'Hatin',
    State: 'Haryana',
    Phone: '+91-1275-261480 / 81',
    Email: '-',
    Address: 'Hatin, Haryana - 121102',
  },
  {
    Number: 'HR-14',
    City: 'Jhajjar',
    State: 'Haryana',
    Phone: '+91-1251-269017',
    Email: '-',
    Address: 'Jhajjar, Haryana - 124507',
  },
  {
    Number: 'HR-57',
    City: 'Sirsa',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sirsa, Haryana - 125055',
  },
  {
    Number: 'HR-83',
    City: 'Kalayat',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-62',
    City: 'Fatehabad',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Fatehabad, Haryana - 125120',
  },
  {
    Number: 'HR-17',
    City: 'Siwani',
    State: 'Haryana',
    Phone: '+91-1255-277222',
    Email: '-',
    Address: 'Siwani, Bhiwani, Haryana - 127046',
  },
  {
    Number: 'HR-15',
    City: 'Meham',
    State: 'Haryana',
    Phone: '+91-1257-233148',
    Email: '-',
    Address: 'Meham, Haryana - 124112',
  },
  {
    Number: 'HR-48',
    City: 'Tosham',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Tosham, Bhiwani, Haryana - 127040',
  },
  {
    Number: 'HR-96',
    City: 'Rla Tauru',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-21',
    City: 'Hansi',
    State: 'Haryana',
    Phone: '1663-254074',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Hansi, Hisar Haryana - 125042',
  },
  {
    Number: 'HR-92',
    City: 'Sdm Radaur',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-86',
    City: 'Sdm Narnaund',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-76',
    City: 'Pataudi',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Pataudi, Gurgaon, Haryana - 122503',
  },
  {
    Number: 'HR-54',
    City: 'Ambala-Barara',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Barara, Ambala, Haryana - 133201',
  },
  {
    Number: 'HR-05',
    City: 'Karnal',
    State: 'Haryana',
    Phone: '+91-184-2267701',
    Email: '-',
    Address: 'Karnal, Haryana - 132001',
  },
  {
    Number: 'HR-27',
    City: 'Nuh',
    State: 'Haryana',
    Phone: '+91-1267-271201',
    Email: '-',
    Address: 'Nuh, Gurgaon, Haryana - 122107',
  },
  {
    Number: 'HR-73',
    City: 'Palwal',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Palwal, Faridabad, Haryana - 121102',
  },
  {
    Number: 'HR-06',
    City: 'Panipat',
    State: 'Haryana',
    Phone: '+91-180-2651303',
    Email: '-',
    Address: 'Panipat, Haryana - 132103',
  },
  {
    Number: 'HR-69',
    City: 'Sonipat',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sonipat, Haryana - 131001',
  },
  {
    Number: 'HR-47',
    City: 'Rewari',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Rewari, Haryana - 123401',
  },
  {
    Number: 'HR-66',
    City: 'Narnaul',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Narnaul, Mahendragarh, Haryana - 123001',
  },
  {
    Number: 'HR-85',
    City: 'Sdm Ambala Cantonment',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-91',
    City: 'Sdm Gharaunda',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  {
    Number: 'HR-01',
    City: 'Ambala',
    State: 'Haryana',
    Phone: '+91-171-2530350',
    Email: '-',
    Address: 'Ambala, Haryana - 133001',
  },
  {
    Number: 'HR-24',
    City: 'Sirsa',
    State: 'Haryana',
    Phone: '+91-1666-247345',
    Email: '-',
    Address: 'Sirsa, Haryana - 125055',
  },
  {
    Number: 'HR-23',
    City: 'Tohana',
    State: 'Haryana',
    Phone: '+91-1692-230280',
    Email: '-',
    Address: 'Tohana, Fatehabad, Haryana - 125120',
  },
  {
    Number: 'HR-12',
    City: 'Rohtak',
    State: 'Haryana',
    Phone: '+91-1262-252101',
    Email: '-',
    Address: 'Rohtak, Haryana - 124001',
  },
  {
    Number: 'HR-78',
    City: 'Shahabad',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Shahabad, Kurukshetra, Haryana - 136135',
  },
  {
    Number: 'HR-95',
    City: 'Sdm Sampla',
    State: 'Haryana',
    Phone: '-',
    Email: '-',
    Address: 'Haryana',
  },
  //Himachal pradesh
  {
    Number: 'HP-57',
    City: 'Chowari',
    State: 'Himachal Pradesh',
    Phone: '+91-1899-266455',
    Email: '[email protected]',
    Address: 'Bhattiyat, Chamba, Himachal Pradesh - 176302',
  },
  {
    Number: 'HP-67',
    City: 'Hamirpur',
    State: 'Himachal Pradesh',
    Phone: '+91-1972-221330',
    Email: '[email protected]',
    Address: 'Hamirpur, Himachal Pradesh - 177001',
  },
  {
    Number: 'HP-53',
    City: 'Baijnath',
    State: 'Himachal Pradesh',
    Phone: '+91-1894-263656',
    Email: '[email protected]',
    Address: 'Baijnath, Kangra, Himachal Pradesh - 176125',
  },
  {
    Number: 'HP-19',
    City: 'Amb',
    State: 'Himachal Pradesh',
    Phone: '+91-1976-261203',
    Email: '[email protected]',
    Address: 'Amb, Una, Himachal Pradesh - 177203',
  },
  {
    Number: 'HP-36',
    City: 'Dehra',
    State: 'Himachal Pradesh',
    Phone: '+91-1970-233102',
    Email: '[email protected]',
    Address: 'Dehra, Kangra, Himachal Pradesh - 177101',
  },
  {
    Number: 'HP-70',
    City: 'BILASPUR HP',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'BILASPUR HP, Himanchal Pradesh',
  },
  {
    Number: 'HP-21',
    City: 'Barsar',
    State: 'Himachal Pradesh',
    Phone: '+91-1972-288045',
    Email: '[email protected]',
    Address: 'Barsar, Hamirpur, Himachal Pradesh - 174305',
  },
  {
    Number: 'HP-04',
    City: 'Dharamsala',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dharamsala, Kangra, Himachal Pradesh - 176215',
  },
  {
    Number: 'HP-30',
    City: 'Karsog',
    State: 'Himachal Pradesh',
    Phone: '+91-1907-222236',
    Email: '[email protected]',
    Address: 'Karsog, Mandi, Himachal Pradesh - 175011',
  },
  {
    Number: 'HP-12',
    City: 'Nalagarh',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Nalagarh, Solan, Himachal Pradesh - 174101',
  },
  {
    Number: 'HP-48',
    City: 'Chamba',
    State: 'Himachal Pradesh',
    Phone: '+91-1899-222278',
    Email: '[email protected]',
    Address: 'Chmaba, Himachal Pradesh - 176310',
  },
  {
    Number: 'HP-60',
    City: 'HAMIRPUR',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'HAMIRPUR, Himanchal Pradesh',
  },
  {
    Number: 'HP-22',
    City: 'Hamirpur',
    State: 'Himachal Pradesh',
    Phone: '+91-1972-224304',
    Email: '[email protected]',
    Address: 'Hamirpur, Himachal Pradesh - 177001',
  },
  {
    Number: 'HP-97',
    City: 'Rla Indora',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-25',
    City: 'Kalpa',
    State: 'Himachal Pradesh',
    Phone: '+91-1786-222253',
    Email: '[email protected]',
    Address: 'Kalpa, Kinnaur, Himachal Pradesh - 172108',
  },
  {
    Number: 'HP-29',
    City: 'Jogindernagar',
    State: 'Himachal Pradesh',
    Phone: '+91-1908-223895',
    Email: '[email protected]',
    Address: 'Jogindernagar, Mandi, Himachal Pradesh - 175015',
  },
  {
    Number: 'HP-13',
    City: 'Kandaghat',
    State: 'Himachal Pradesh',
    Phone: '+91-1792-256100',
    Email: '[email protected]',
    Address: 'Kandaghat, Solan, Himachal Pradesh - 173215',
  },
  {
    Number: 'HP-06',
    City: 'Rampur',
    State: 'Himachal Pradesh',
    Phone: '+91-1782-233002',
    Email: '[email protected]',
    Address: 'Rampur, Shimla, Himachal Pradesh - 172001',
  },
  {
    Number: 'HP-46',
    City: 'Bharmour',
    State: 'Himachal Pradesh',
    Phone: '+91-1895-225027',
    Email: '[email protected]',
    Address: 'Bharmaur, Chamba, Himachal Pradesh - 176315',
  },
  {
    Number: 'HP-32',
    City: 'Gohar (Mandi)',
    State: 'Himachal Pradesh',
    Phone: '+91-1907-250262',
    Email: '[email protected]',
    Address: 'Gohar, Mandi, Himachal Pradesh - 175029',
  },
  {
    Number: 'HP-98',
    City: 'Kasauli',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kasauli, Himachal Pradesh',
  },
  {
    Number: 'HP-37',
    City: 'Palampur',
    State: 'Himachal Pradesh',
    Phone: '+91-1894-230595',
    Email: '[email protected]',
    Address: 'Palampur, Kangra, Himachal Pradesh - 176061',
  },
  {
    Number: 'HP-24',
    City: 'Rla Bilaspur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-85',
    City: 'Rla Shillai',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-76',
    City: 'Rla Paddhar',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-78',
    City: 'Bangana',
    State: 'Himachal Pradesh',
    Phone: '+91-1975-263060',
    Email: '-',
    Address: 'Una, Himachal Pradesh - 174304',
  },
  {
    Number: 'HP-68',
    City: 'Rto Dharamshala',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-43',
    City: 'Rla Udaipur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-65',
    City: 'Rto Mandi',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-11',
    City: 'Arki',
    State: 'Himachal Pradesh',
    Phone: '+91-1796-220666',
    Email: '[email protected]',
    Address: 'Arki, Solan, Himachal Pradesh - 173208',
  },
  {
    Number: 'HP-23',
    City: 'Ghumarwin',
    State: 'Himachal Pradesh',
    Phone: '+91-1978-255227',
    Email: '[email protected]',
    Address: 'Ghumarwin, Bilaspur, Himachal Pradesh - 174021',
  },
  {
    Number: 'HP-08',
    City: 'Chopal',
    State: 'Himachal Pradesh',
    Phone: '1783-260014',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Chopal, Shimla, Himachal Pradesh - 171211',
  },
  {
    Number: 'HP-83',
    City: 'Rla Jawalaji',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-77',
    City: 'Dodra Kawar',
    State: 'Himachal Pradesh',
    Phone: '+91-1781-272001',
    Email: '[email protected]',
    Address: 'Dodra Kawar, Shimla, Himachal Pradesh - 171221',
  },
  {
    Number: 'HP-27',
    City: 'Rla Pooh',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-73',
    City: 'Rto Chamba',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-14',
    City: 'Solan',
    State: 'Himachal Pradesh',
    Phone: '1792-223707',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Solan, Himachal Pradesh - 173212',
  },
  {
    Number: 'HP-91',
    City: 'Rla Shri Naina Devi Ji Swarghat',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-62',
    City: 'DodraKwar',
    State: 'Himachal Pradesh',
    Phone: '+91-',
    Email: '-',
    Address: 'Dodra, Shimla, Himachal Pradesh - 171221',
  },
  {
    Number: 'HP-81',
    City: 'Rla Salooni',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-90',
    City: 'Rla Shahpur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-47',
    City: 'Dalhousie',
    State: 'Himachal Pradesh',
    Phone: '01899242122',
    Email: '[email protected]',
    Address: 'Dalhousie, Chamba, Himachal Pradesh - 176304',
  },
  {
    Number: 'HP-20',
    City: 'Una',
    State: 'Himachal Pradesh',
    Phone: '+91-1975-223621',
    Email: '[email protected]',
    Address: 'Una, Himachal Pradesh - 174303',
  },
  {
    Number: 'HP-93',
    City: 'Rto Baddi(Nalagarh)',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-18',
    City: 'Rla Nahan',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-94',
    City: 'Rla Nagrota Bagwan',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-15',
    City: 'Parwanoo',
    State: 'Himachal Pradesh',
    Phone: '+91-1792-233165',
    Email: '[email protected]',
    Address: 'Parwanoo, Solan, Himachal Pradesh - 173220',
  },
  {
    Number: 'HP-40',
    City: 'Rla Kangra',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-39',
    City: 'Dharamshala',
    State: 'Himachal Pradesh',
    Phone: '+91-1892-223315',
    Email: '[email protected]',
    Address: 'Dharamshala, Kangra, Himachal Pradesh - 176215',
  },
  {
    Number: 'HP-84',
    City: 'Rla Sujanpur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-72',
    City: 'Rto Una',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-95',
    City: 'Rla Kumarsain',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-50',
    City: 'SHIMLA (AUTO)',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'SHIMLA (AUTO), Himanchal Pradesh',
  },
  {
    Number: 'HP-87',
    City: 'Rla Thunag',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-07',
    City: 'Shimla',
    State: 'Himachal Pradesh',
    Phone: '177-2808950',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Parivahan Bhawan, Shimla, Himachal Pradesh - 171004',
  },
  {
    Number: 'HP-66',
    City: 'Rto Kullu',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-79',
    City: 'Rla Sangrah',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-42',
    City: 'Rla Kelang',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-45',
    City: 'Pangi',
    State: 'Himachal Pradesh',
    Phone: '+91-1897-222222',
    Email: '[email protected]',
    Address: 'Pangi, Chamba, Himachal Pradesh - 172107',
  },
  {
    Number: 'HP-49',
    City: 'Rla Banjar',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-16',
    City: 'Rajgarh',
    State: 'Himachal Pradesh',
    Phone: '+91-1799-221034',
    Email: '[email protected]',
    Address: 'Rajgarh, Sirmaur, Himachal Pradesh - 173101',
  },
  {
    Number: 'HP-35',
    City: 'Anni',
    State: 'Himachal Pradesh',
    Phone: '+91-1904-253344',
    Email: '[email protected]',
    Address: 'Ani, Kullu, Himachal Pradesh - 172026',
  },
  {
    Number: 'HP-56',
    City: 'Jaisinghpur',
    State: 'Himachal Pradesh',
    Phone: '+91-1894-228111',
    Email: '[email protected]',
    Address: 'Jaisinghpur, Kangra, Himachal Pradesh - 176095',
  },
  {
    Number: 'HP-10',
    City: 'Rohru',
    State: 'Himachal Pradesh',
    Phone: '+91-1781-240009',
    Email: '[email protected]',
    Address: 'Rohru, Shimla, Himachal Pradesh - 171207',
  },
  {
    Number: 'HP-69',
    City: 'Rto Bilaspur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-96',
    City: 'Rla Dheera',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-52',
    City: 'Shimla (Rural)',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Shimla, Himachal Pradesh - 171001',
  },
  {
    Number: 'HP-02',
    City: 'SHIMLA',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'SHIMLA, Himanchal Pradesh',
  },
  {
    Number: 'HP-71',
    City: 'Rto Nahan',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-28',
    City: 'Sarkaghat',
    State: 'Himachal Pradesh',
    Phone: '+91-1905-230042',
    Email: '[email protected]',
    Address: 'Sarkaghat, Mandi, Himachal Pradesh - 175024',
  },
  {
    Number: 'HP-82',
    City: 'Rla Balh',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-09',
    City: 'Theog',
    State: 'Himachal Pradesh',
    Phone: '1783-238502',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Theog, Shimla, Himachal Pradesh - 171201',
  },
  {
    Number: 'HP-59',
    City: 'SOLAN',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'SOLAN, Himanchal Pradesh',
  },
  {
    Number: 'HP-01',
    City: 'SHIMLA',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'SHIMLA, Himanchal Pradesh',
  },
  {
    Number: 'HP-33',
    City: 'Rla Mandi',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-31',
    City: 'Sundernagar',
    State: 'Himachal Pradesh',
    Phone: '+91-1907-266001',
    Email: '[email protected]',
    Address: 'Sundernagar, Mandi, Himachal Pradesh - 175019',
  },
  {
    Number: 'HP-38',
    City: 'Rla Nurpur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-61',
    City: 'KULLU',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'KULLU, Himanchal Pradesh',
  },
  {
    Number: 'HP-80',
    City: 'Rla Haroli',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-64',
    City: 'Rto Solan',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-63',
    City: 'Shimla',
    State: 'Himachal Pradesh',
    Phone: '+91-177-2658379',
    Email: '[email protected]',
    Address: 'Shimla, Himachal Pradesh - 171004',
  },
  {
    Number: 'HP-26',
    City: 'Rla Nichar',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-05',
    City: 'Mandi',
    State: 'Himachal Pradesh',
    Phone: '1905-235171',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Mandi, Himachal Pradesh - 175001',
  },
  {
    Number: 'HP-41',
    City: 'Rla Kaza',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-51',
    City: 'SHIMLA - URBAN',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'SHIMLA - URBAN, Himanchal Pradesh',
  },
  {
    Number: 'HP-86',
    City: 'Rla Dharampur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-92',
    City: 'Rto Rampur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pradesh',
  },
  {
    Number: 'HP-55',
    City: 'Nadaun',
    State: 'Himachal Pradesh',
    Phone: '+91-1972-232511',
    Email: '[email protected]',
    Address: 'Nadaun, Hamirpur, Himachal Pradesh - 177033',
  },
  {
    Number: 'HP-74',
    City: 'Rla Bhoranj',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-44',
    City: 'Rla Churah',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-03',
    City: 'Shimla - Urban',
    State: 'Himachal Pradesh',
    Phone: '+91-177-2657007',
    Email: '[email protected]',
    Address: 'Shimla, Himachal Pradesh - 171001',
  },
  {
    Number: 'HP-54',
    City: 'Jawali',
    State: 'Himachal Pradesh',
    Phone: '+91-1893-264310',
    Email: '[email protected]',
    Address: 'Jawali, Kangra, Himachal Pradesh - 176023',
  },
  {
    Number: 'HP-58',
    City: 'Manali',
    State: 'Himachal Pradesh',
    Phone: '+91-1902-254100',
    Email: '[email protected]',
    Address: 'Manali, Kullu, Himachal Pradesh - 175131',
  },
  {
    Number: 'HP-88',
    City: 'Rla Fathepur',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-17',
    City: 'Paonta Sahib',
    State: 'Himachal Pradesh',
    Phone: '+91-1704-224100',
    Email: '[email protected]',
    Address: 'Paonta Sahib, Sirmaur, Himachal Pradesh - 173025',
  },
  {
    Number: 'HP-89',
    City: 'Rla Jhandutta',
    State: 'Himachal Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Himachal Pardesh',
  },
  {
    Number: 'HP-34',
    City: 'Kullu',
    State: 'Himachal Pradesh',
    Phone: '+91-1902-222596',
    Email: '[email protected]',
    Address: 'Kullu, Himachal Pradesh - 175101',
  },
  //Jharkhand
  {
    Number: 'JH-09',
    City: 'Bokaro Steel City',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Bokaro Steel City, Jharkhand - 827001',
  },
  {
    Number: 'JH-06',
    City: 'Chaibasa',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Chaibasa, West Singhbhum, Jharkhand - 833201',
  },
  {
    Number: 'JH-17',
    City: 'Godda',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Godda, Jharkhand - 814154',
  },
  {
    Number: 'JH-23',
    City: 'Khunti',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Jharkhand',
  },
  {
    Number: 'JH-01',
    City: 'Ranchi',
    State: 'Jharkhand',
    Phone: '+91-651-2443608 / 2444044',
    Email: '-',
    Address: 'HEC Colony, Sector-2, Near Sahid Maidan, Dhurwa, Ranchi - 834004',
  },
  {
    Number: 'JH-13',
    City: 'Chatra',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Chatra, Jharkhand - 825401',
  },
  {
    Number: 'JH-19',
    City: 'Latehar',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Latehar, Jharkhand - 829204',
  },
  {
    Number: 'JH-03',
    City: 'Daltonganj',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Daltonganj, Palamau, Jharkhand - 822101',
  },
  {
    Number: 'JH-24',
    City: 'Ramgarh',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Jharkhand',
  },
  {
    Number: 'JH-10',
    City: 'Dhanbad',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Dhanbad, Jharkhand - 826001',
  },
  {
    Number: 'JH-04',
    City: 'Dumka',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Dumka, Jharkhand - 814145',
  },
  {
    Number: 'JH-21',
    City: 'Jamtara',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Jamtara, Jharkhand - 815354',
  },
  {
    Number: 'JH-14',
    City: 'Garhwa',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Garhwa, Jharkhand - 822114',
  },
  {
    Number: 'JH-16',
    City: 'Pakur',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Pakur, Jharkhand - 816104',
  },
  {
    Number: 'JH-12',
    City: 'Koderma',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Koderma, arkhand - 825318',
  },
  {
    Number: 'JH-05',
    City: 'Jamshedpur',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Jamshedpur, East Singhbhum, Jharkhand - 831001',
  },
  {
    Number: 'JH-07',
    City: 'Gumla',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Gumla, Jharkhand - 835207',
  },
  {
    Number: 'JH-18',
    City: 'Sahibganj',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Sahibganj, Jharkhand - 816101',
  },
  {
    Number: 'JH-11',
    City: 'Giridih',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Giridih, Jharkhand - 815301',
  },
  {
    Number: 'JH-08',
    City: 'Lohardaga',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Lohardaga, Jharkhand - 835213',
  },
  {
    Number: 'JH-15',
    City: 'Deoghar',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Deoghar, Jharkhand - 814112',
  },
  {
    Number: 'JH-20',
    City: 'Simdega',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Simdega, Jharkhand - 835226',
  },
  {
    Number: 'JH-22',
    City: 'Saraikela - Kharsawan',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'Saraikela-Kharsawan, Jharkhand - 832401',
  },
  {
    Number: 'JH-02',
    City: 'Hazaribagh / Ramgarh',
    State: 'Jharkhand',
    Phone: '-',
    Email: '-',
    Address: 'NH 100, CTS Colony, Hazaribagh, Jharkhand - 825301',
  },
  //Karnataka
  {
    Number: 'KA-03',
    City: 'Bangalore East - Indiranagar',
    State: 'Karnataka',
    Phone: '+91-80-25253726',
    Email: '[email protected]',
    Address: '2nd Floor, BDA Complex, Indiranagar, Bangalore - 560038',
  },
  {
    Number: 'KA-41',
    City: 'Jnanabharathi',
    State: 'Karnataka',
    Phone: '+91-80-28602500',
    Email: '[email protected]',
    Address: 'Kenchenahalli Grama, Jnanabharati, RVCE Post, Mysore Road,Bangalore - 560060',
  },
  {
    Number: 'KA-01',
    City: 'Bangalore Central - Koramangala',
    State: 'Karnataka',
    Phone: '+91-80-25533525',
    Email: '[email protected]',
    Address: 'BDA Complex, 3rd Block, Koramangala, Bangalore - 560034',
  },
  {
    Number: 'KA-34',
    City: 'Bellary',
    State: 'Karnataka',
    Phone: '+91-8392-240048',
    Email: '[email protected]',
    Address: 'Bellary Hospet Road, Contonment, Bellary - 583103',
  },
  {
    Number: 'KA-22',
    City: 'Belgaum',
    State: 'Karnataka',
    Phone: '+91-831-2465503',
    Email: '[email protected]',
    Address: 'Sangolli Rayanna Circle, PB Road, RTO Office Compound, Shivanagar,Belgaum - 590016',
  },
  {
    Number: 'KA-43',
    City: 'Devanahalli',
    State: 'Karnataka',
    Phone: '+91-80-27681999',
    Email: '[email protected]',
    Address: 'Vijayapura Road, Devenahalli, Bangalore - 560300',
  },
  {
    Number: 'KA-31',
    City: 'Sirsi',
    State: 'Karnataka',
    Phone: '+91-8384-233090',
    Email: '[email protected]',
    Address: 'Choukimutt Road, Sirsi, Uttara Kannada - 581401',
  },
  {
    Number: 'KA-46',
    City: 'Sakaleshpura Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-14',
    City: 'Shimoga',
    State: 'Karnataka',
    Phone: '+91-8182-222209',
    Email: '[email protected]',
    Address: 'Sowlang Road, Old DC Office Compound, Shimoga - 577201',
  },
  {
    Number: 'KA-04',
    City: 'Bangalore North - Yeshwanthpur',
    State: 'Karnataka',
    Phone: '+91-80-23376039',
    Email: '[email protected]',
    Address: 'Railway Station Road, Yeswanthapura, Bangalore - 560022',
  },
  {
    Number: 'KA-08',
    City: 'K G F Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-35',
    City: 'Hospet',
    State: 'Karnataka',
    Phone: '+91-8394-230766',
    Email: '[email protected]',
    Address: 'Near Harihara Road, Amaravathi, Hospet - 583201',
  },
  {
    Number: 'KA-48',
    City: 'Jamkhandi',
    State: 'Karnataka',
    Phone: '+91-8353-238040',
    Email: '[email protected]',
    Address: 'Sri Deepak Basavaraj Katagis Building, APMC Yard, Jamakhandi,Bagalkot - 587301',
  },
  {
    Number: 'KA-69',
    City: 'Ramdurga Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-49',
    City: 'Gokak',
    State: 'Karnataka',
    Phone: '+91-8332-224727',
    Email: '[email protected]',
    Address: 'Gokak, Belgaum - 591307',
  },
  {
    Number: 'KA-64',
    City: 'Madhugiri - Tumkur District',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Madhugiri, Tumkur - 572132',
  },
  {
    Number: 'KA-42',
    City: 'Ramanagara',
    State: 'Karnataka',
    Phone: '+91-80-27273471',
    Email: '[email protected]',
    Address: 'Near Ghousia College, Mysore Road, Ramanagara - 562159',
  },
  {
    Number: 'KA-59',
    City: 'Chandapura, Bengaluru Rto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-68',
    City: 'Ranibennur Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-07',
    City: 'Kolar',
    State: 'Karnataka',
    Phone: '+91-8152-222039',
    Email: '[email protected]',
    Address: 'Goripet Main Road, Kolar - 563101',
  },
  {
    Number: 'KA-53',
    City: 'Krishnarajapuram',
    State: 'Karnataka',
    Phone: '+91-80-2561795',
    Email: '[email protected]',
    Address: 'Bhattarahalli, Old Madras Road, KR Puram, Bangalore - 560049',
  },
  {
    Number: 'KA-26',
    City: 'Gadag',
    State: 'Karnataka',
    Phone: '+91-8372-237078',
    Email: '[email protected]',
    Address: 'Jodamaruthi Temple Street, Hubli Dharwad Road, Gadag, Dharwad -582101',
  },
  {
    Number: 'KA-71',
    City: 'ATHANI',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'ATHANI, Karnataka',
  },
  {
    Number: 'KA-54',
    City: 'Nagamangala',
    State: 'Karnataka',
    Phone: '+91-8234-285598',
    Email: '[email protected]',
    Address: 'Nagamangala, Mandya - 571432',
  },
  {
    Number: 'KA-18',
    City: 'Chickmagalur',
    State: 'Karnataka',
    Phone: '+91-8262-220366',
    Email: '[email protected]',
    Address: 'ML Vasudeva Murthy Building, Hosmane Extn, Chickmagalur - 577101',
  },
  {
    Number: 'KA-66',
    City: 'Tarikere, Chikkamagaluru Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-47',
    City: 'Honnavar',
    State: 'Karnataka',
    Phone: '+91-8387-236536',
    Email: '[email protected]',
    Address: 'VG Pai Building, Near NH 7, Honnavara Kumata Road, Honnavara,Uttara Kannada - 581334',
  },
  {
    Number: 'KA-50',
    City: 'Yalahanka',
    State: 'Karnataka',
    Phone: '+91-80-28561366',
    Email: '[email protected]',
    Address: '3rd Cross, Karantaka Housing Board Commercial Complex, Sector-B,Yelahanka New Town, Bangalore - 560106',
  },
  {
    Number: 'KA-12',
    City: 'Madikeri',
    State: 'Karnataka',
    Phone: '+91-8272-225785',
    Email: '[email protected]',
    Address: 'Sunny Side, General Thimmaiah Road, Madeikeri, Kodagu - 571201',
  },
  {
    Number: 'KA-56',
    City: 'Basavakalyan',
    State: 'Karnataka',
    Phone: '+91-8481-256996',
    Email: '[email protected]',
    Address: 'Basavakalyana, Sastapura Bangare, NH 9, Basavakalyana, Bidar -585327',
  },
  {
    Number: 'KA-40',
    City: 'Chikkaballapur',
    State: 'Karnataka',
    Phone: '+91-8156-263053',
    Email: '[email protected]',
    Address: 'Bangalore Road, Chikkaballapura - 562101',
  },
  {
    Number: 'KA-15',
    City: 'Sagara',
    State: 'Karnataka',
    Phone: '+91-8183-226276',
    Email: '[email protected]',
    Address: 'New BH Road, Vinobha Nagar, Sagar, Shimoga - 577401',
  },
  {
    Number: 'KA-61',
    City: 'MARATHALLI',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'MARATHALLI, Karnataka',
  },
  {
    Number: 'KA-30',
    City: 'Karwar Rto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-67',
    City: 'Chintamani Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-11',
    City: 'Mandya Rto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-70',
    City: 'Bantwala Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-51',
    City: 'Electronics City',
    State: 'Karnataka',
    Phone: '+91-80-26482851',
    Email: '[email protected]',
    Address: 'BTM 4 Stage, 2nd Block, Next to KEB Sub Station, NearDeverachikkanahalli Bus Stop, Bangalore - 560076',
  },
  {
    Number: 'KA-65',
    City: 'Dandeli',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Dandeli - 581325',
  },
  {
    Number: 'KA-55',
    City: 'Mysore East',
    State: 'Karnataka',
    Phone: '+91-821-2330364',
    Email: '[email protected]',
    Address: 'Vani Vilas Road, Near Hardwick School, Mysore - 570019',
  },
  {
    Number: 'KA-39',
    City: 'Bhalki Arto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-09',
    City: 'Mysore West',
    State: 'Karnataka',
    Phone: '+91-821-2330364',
    Email: '[email protected]',
    Address: 'Vanivilas Road, Near Haardwick High School, Mysore West, Mysore -570001',
  },
  {
    Number: 'KA-17',
    City: 'Davangere',
    State: 'Karnataka',
    Phone: '+91-8912-259848',
    Email: '[email protected]',
    Address: 'Devaraj URS Layout, Davanagere - 577001',
  },
  {
    Number: 'KA-37',
    City: 'Koppal',
    State: 'Karnataka',
    Phone: '+91-8539-220829',
    Email: '[email protected]',
    Address: 'APMC Yaard, Koppal - 583231',
  },
  {
    Number: 'KA-05',
    City: 'Bangalore South - Jayanagar',
    State: 'Karnataka',
    Phone: '+91-80-26630989',
    Email: '[email protected]',
    Address: 'Jayanagar Shopping Complex, 4th Block, Jayanagar, Bangalore -560011',
  },
  {
    Number: 'KA-63',
    City: 'Hubli',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Near Vishwabharati School, Muneshwarnagar, Unkal Hubli, Hubli -580031',
  },
  {
    Number: 'KA-36',
    City: 'Raichur',
    State: 'Karnataka',
    Phone: '+91-8532-223329',
    Email: '[email protected]',
    Address: 'Near KSRTC Depot, Mantralaya Road, Raichur - 584101',
  },
  {
    Number: 'KA-19',
    City: 'Mangalore',
    State: 'Karnataka',
    Phone: '+91-824-2446266',
    Email: '[email protected]',
    Address: 'Hampanakatte, Nehru Maidhan Road, East AB Shetty Circle, Mangalore- 575001',
  },
  {
    Number: 'KA-27',
    City: 'Haveri',
    State: 'Karnataka',
    Phone: '+91-8375-232299',
    Email: '[email protected]',
    Address: 'MS Kurubagonda Building, Hukkerimatt Road, Haveri - 581110',
  },
  {
    Number: 'KA-24',
    City: 'Bailhongal Rto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-33',
    City: 'Yadgir',
    State: 'Karnataka',
    Phone: '+91-8473-252580',
    Email: '[email protected]',
    Address: 'Near KSRTC Bus Depot, Station Area, Yadagiri - 585201',
  },
  {
    Number: 'KA-02',
    City: 'Bangalore West - Rajajinagar',
    State: 'Karnataka',
    Phone: '+91-80-23324388',
    Email: '[email protected]',
    Address: 'Rajajinagar Shopping Complex, Bangalore - 560010',
  },
  {
    Number: 'KA-10',
    City: 'Chamarajanagar Rto',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'Karnataka',
  },
  {
    Number: 'KA-45',
    City: 'Hunsur',
    State: 'Karnataka',
    Phone: '+91-822-2252699',
    Email: '[email protected]',
    Address: 'Cauvery Irrigation Nigama, HRBC Building, Hunsur, Mysore - 571105',
  },
  {
    Number: 'KA-29',
    City: 'Bagalkot',
    State: 'Karnataka',
    Phone: '+91-8354-201394',
    Email: '[email protected]',
    Address: 'Station Road Extention Area, Navanagar, Bagalkot - 577101',
  },
  {
    Number: 'KA-62',
    City: 'SURATHKAL',
    State: 'Karnataka',
    Phone: '-',
    Email: '-',
    Address: 'SURATHKAL, Karnataka',
  },
  {
    Number: 'KA-20',
    City: 'Udupi',
    State: 'Karnataka',
    Phone: '+91-820-2521437',
    Email: '[email protected]',
    Address: 'Padmasali Sabagraha Kattada, Mulki Road, Adi Udupi, Udupi - 576103',
  },
  {
    Number: 'KA-32',
    City: 'Gulbarga',
    State: 'Karnataka',
    Phone: '+91-8472-248805',
    Email: '[email protected]',
    Address: 'Rjapur Cross, Sedam Road, Gulbarga - 585105',
  },
  {
    Number: 'KA-38',
    City: 'Bidar',
    State: 'Karnataka',
    Phone: '+91-8482-226361',
    Email: '[email protected]',
    Address: 'Near Airforce Gate, Bidar - 585401',
  },
  {
    Number: 'KA-16',
    City: 'Chitradurga',
    State: 'Karnataka',
    Phone: '+91-8194-230457',
    Email: '[email protected]',
    Address: 'NH-4, Deviation Road, Chitradurga - 577501',
  },
  {
    Number: 'KA-23',
    City: 'Chikkodi',
    State: 'Karnataka',
    Phone: '+91-8338-272241',
    Email: '[email protected]',
    Address: 'Mahalingapura Road, Mahaveeranagar Extn, Chikkodi, Belgam - 591201',
  },
  {
    Number: 'KA-28',
    City: 'Bijapur',
    State: 'Karnataka',
    Phone: '+91-8352-276218',
    Email: '[email protected]',
    Address: 'Bagalkot Road, Bijapur - 586101',
  },
  {
    Number: 'KA-06',
    City: 'Tumkur',
    State: 'Karnataka',
    Phone: '+91-816-2278473',
    Email: '[email protected]',
    Address: 'BH Road, Tumkur - 572101',
  },
  {
    Number: 'KA-21',
    City: 'Puttur',
    State: 'Karnataka',
    Phone: '+91-8251-230729',
    Email: '[email protected]',
    Address: 'Puttur, Dakshina Kannada - 574201',
  },
  {
    Number: 'KA-13',
    City: 'Hassan',
    State: 'Karnataka',
    Phone: '+91-8172-240660',
    Email: '[email protected]',
    Address: 'B Kathihalli, Arasikere Road, Hassan - 573201',
  },
  {
    Number: 'KA-25',
    City: 'Dharwad',
    State: 'Karnataka',
    Phone: '+91-836-2233929',
    Email: '[email protected]',
    Address: 'Naavanagar Post, Hubli Dharwad Road, Dharwad - 580001',
  },
  {
    Number: 'KA-44',
    City: 'Tiptur',
    State: 'Karnataka',
    Phone: '+91-8134-254799',
    Email: '[email protected]',
    Address: 'Revenue Dept. Employees Society Building, Honnavara Road, Tiptur,Tumkur - 572201',
  },
  {
    Number: 'KA-52',
    City: 'Nelamangala',
    State: 'Karnataka',
    Phone: '+91-80-7722286',
    Email: '[email protected]',
    Address: '9th Cross, Subash Road, Nelamangala, Bangalore - 562123',
  },
  //Kerala
  {
    Number: 'KL-15',
    City: 'Kerala',
    State: 'Kerala',
    Phone: '+91-471-2471011',
    Email: '[email protected]',
    Address: 'Transport Bhavan, Near Attukal Shopping Complex, Thiruvananthapuram- 695023',
  },
  {
    Number: 'KL-26',
    City: 'Adoor',
    State: 'Kerala',
    Phone: '+91-4734-227475',
    Email: '[email protected]',
    Address: '3rd Floor, Revenue Tower, Adoor, Pathanamthitta - 691523',
  },
  {
    Number: 'KL-71',
    City: 'ambur',
    State: 'Kerala',
    Phone: '+91-4931-226008',
    Email: '[email protected]',
    Address: 'Railway Station Road, Chandakkunnu, ambur, Malappuram - 679330',
  },
  {
    Number: 'KL-49',
    City: 'Alathur',
    State: 'Kerala',
    Phone: '+91-492-2224909',
    Email: '[email protected]',
    Address: '2nd Floor, Vyapara Bhavan, Main Road, Alathoor, Palakkad - 678541',
  },
  {
    Number: 'KL-10',
    City: 'Malappuram',
    State: 'Kerala',
    Phone: '+91-483-2734924',
    Email: '[email protected]',
    Address: 'Lottery Rd, Midill Hill, Up Hill, Malappuram - 676505',
  },
  {
    Number: 'KL-82',
    City: 'CHANDAYAMANGALAM',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'CHANDAYAMANGALAM, Kerala',
  },
  {
    Number: 'KL-08',
    City: 'Thrissur',
    State: 'Kerala',
    Phone: '+91-487-2360262',
    Email: '[email protected]',
    Address: 'Thrissur - 680001',
  },
  {
    Number: 'KL-27',
    City: 'Thiruvalla',
    State: 'Kerala',
    Phone: '+91-469-2635577',
    Email: '[email protected]',
    Address: 'Revenue Tower, Opposite Police station, Thiruvalla, Pathanamthitta- 689101',
  },
  {
    Number: 'KL-33',
    City: 'Changanassery',
    State: 'Kerala',
    Phone: '+91-481-2411930',
    Email: '[email protected]',
    Address: '3rd Floor, Revneue Tower, Changanassery, Kottayam - 686101',
  },
  {
    Number: 'KL-12',
    City: 'Wayanad',
    State: 'Kerala',
    Phone: '+91-4936-202607',
    Email: '[email protected]',
    Address: 'Civil Station, Kalpetta, Wayanad - 673122',
  },
  {
    Number: 'KL-61',
    City: 'Kunnathur',
    State: 'Kerala',
    Phone: '+91-476-2852273',
    Email: '[email protected]',
    Address: 'Kunnathur, Kollam - 690540',
  },
  {
    Number: 'KL-47',
    City: 'Kodungallur',
    State: 'Kerala',
    Phone: '+91-480-2807666',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Kodungalloor, Thrissur - 680664',
  },
  {
    Number: 'KL-83',
    City: 'KONNI',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'KONNI, Kerala',
  },
  {
    Number: 'KL-85',
    City: 'RAMANATTUKARA',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'RAMANATTUKARA, Kerala',
  },
  {
    Number: 'KL-70',
    City: 'Chittur',
    State: 'Kerala',
    Phone: '+91-492-3227677',
    Email: '[email protected]',
    Address: 'Chittur, Tattamangalam, Palakkad - 678101',
  },
  {
    Number: 'KL-73',
    City: 'Sulthanbathery Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-13',
    City: 'Kannur',
    State: 'Kerala',
    Phone: '+91-497-2700566',
    Email: '[email protected]',
    Address: 'Civil Station, Kannur - 670102',
  },
  {
    Number: 'KL-63',
    City: 'Angamaly',
    State: 'Kerala',
    Phone: '+91-484-2456333',
    Email: '[email protected]',
    Address: 'Angamaly, Ernakulam - 683572',
  },
  {
    Number: 'KL-22',
    City: 'Kazhakuttom Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-46',
    City: 'Guruvayur',
    State: 'Kerala',
    Phone: '+91-487-2551666',
    Email: '[email protected]',
    Address: '9/128, Manjulal Shopping Complex, Kizhakke Nada, Guruvayoor,Thrissur - 680101',
  },
  {
    Number: 'KL-68',
    City: 'Devikulam Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-17',
    City: 'Muvattupuzha',
    State: 'Kerala',
    Phone: '+91-485-2837177',
    Email: '[email protected]',
    Address: 'Muvattupuzha, Ernakulam - 686661',
  },
  {
    Number: 'KL-29',
    City: 'Kayamkulam',
    State: 'Kerala',
    Phone: '+91-479-2447760',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Kayamkulam, Alappuzha - 690502',
  },
  {
    Number: 'KL-20',
    City: 'Neyyattinkara',
    State: 'Kerala',
    Phone: '+91-471-2223643',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Neyyattinkara, Thiruvananthapuram - 695121',
  },
  {
    Number: 'KL-74',
    City: 'Kattakada Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-69',
    City: 'Udumbanchola',
    State: 'Kerala',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Udumbanchola, Idukki - 685554',
  },
  {
    Number: 'KL-66',
    City: 'Kuttanadu',
    State: 'Kerala',
    Phone: '+91-479-2706060',
    Email: '[email protected]',
    Address: 'Angamaly, Ernakulam - 683572',
  },
  {
    Number: 'KL-09',
    City: 'Palakkad',
    State: 'Kerala',
    Phone: '+91-4+91-2505741',
    Email: '[email protected]',
    Address: 'Civil Station, Palakkad - 678002',
  },
  {
    Number: 'KL-86',
    City: 'PAYYANUR',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'PAYYANUR, Kerala',
  },
  {
    Number: 'KL-60',
    City: 'Kanhangad',
    State: 'Kerala',
    Phone: '+91-467-2207766',
    Email: '[email protected]',
    Address: 'Near Town Hall, Kanjangad, Kasargod - 671315',
  },
  {
    Number: 'KL-45',
    City: 'Irinjalakuda',
    State: 'Kerala',
    Phone: '+91-480-2825666',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Iringalakkuda, Thrissur - 680121',
  },
  {
    Number: 'KL-25',
    City: 'Punalur',
    State: 'Kerala',
    Phone: '+91-475-2228420',
    Email: '[email protected]',
    Address: 'Nellipally, Punalur, Kollam - 691305',
  },
  {
    Number: 'KL-54',
    City: 'Ponnani',
    State: 'Kerala',
    Phone: '+91-494-2667511',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Ponnani, Malappuram - 679583',
  },
  {
    Number: 'KL-07',
    City: 'Ernakulam',
    State: 'Kerala',
    Phone: '+91-484-2422246',
    Email: '[email protected]',
    Address: '2 Floor, A 3 Block, Civil Station, Kakkanad, Ernakulam - 682030',
  },
  {
    Number: 'KL-21',
    City: 'Nedumangad',
    State: 'Kerala',
    Phone: '+91-472-2813177',
    Email: '[email protected]',
    Address: 'Nedumangad Town Rd, Nedumangad, Thiruvananthapuram - 695541',
  },
  {
    Number: 'KL-42',
    City: 'North Paravur',
    State: 'Kerala',
    Phone: '+91-484-2442522',
    Email: '[email protected]',
    Address: 'Abdul Jaleel Mar Gregorious Memorial Shopping Complex,Perumpadanna, North parur, Ernakulam - 683513',
  },
  {
    Number: 'KL-37',
    City: 'Vandiperiyar',
    State: 'Kerala',
    Phone: '+91-4869-252733',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Peerumedu, Idukki - 685531',
  },
  {
    Number: 'KL-19',
    City: 'Parassala',
    State: 'Kerala',
    Phone: '+91-471-2626400',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Parassala, Thiruvananthapuram - 695502',
  },
  {
    Number: 'KL-76',
    City: 'Nanmanda Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-16',
    City: 'Attingal',
    State: 'Kerala',
    Phone: '+91-470-2626400',
    Email: '[email protected]',
    Address: 'Ansar Complex, T B Junction, Attingal, Thiruvananthapuram - 695101',
  },
  {
    Number: 'KL-01',
    City: 'Thiruvananthapuram',
    State: 'Kerala',
    Phone: '+91-471-2469223',
    Email: '[email protected]',
    Address: '1st Floor, Transport Bhavan, East Fort, Thiruvananthapuram Fort,Thiruvananthapuram - 695023',
  },
  {
    Number: 'KL-51',
    City: 'Ottappalam',
    State: 'Kerala',
    Phone: '+91-466-2247064',
    Email: '[email protected]',
    Address: 'SBI Building, Opp: Muncipal Bus Stand, Ottappalam, Palakkad -679101',
  },
  {
    Number: 'KL-65',
    City: 'Thirurangadi Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-84',
    City: 'KONDOTTY',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'KONDOTTY, Kerala',
  },
  {
    Number: 'KL-56',
    City: 'Koyilandi',
    State: 'Kerala',
    Phone: '+91-495-2623215',
    Email: '[email protected]',
    Address: 'Meethalekandi Complex, Koyilandi, Kozhikode - 673305',
  },
  {
    Number: 'KL-62',
    City: 'Ranni',
    State: 'Kerala',
    Phone: '+91-473-5228866',
    Email: '[email protected]',
    Address: 'Ranni, Pathanamthitta - 689672',
  },
  {
    Number: 'KL-32',
    City: 'Cherthala',
    State: 'Kerala',
    Phone: '+91-478-2816248',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Cherthala, Alappuzha - 688524',
  },
  {
    Number: 'KL-44',
    City: 'Kothamangalam Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-78',
    City: 'Iritty Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-30',
    City: 'Chengannur',
    State: 'Kerala',
    Phone: '+91-479-2450800',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Chengannoor, Alappuzha - 689121',
  },
  {
    Number: 'KL-43',
    City: 'Mattancherry',
    State: 'Kerala',
    Phone: '+91-484-2229200',
    Email: '[email protected]',
    Address: 'Hybron Building, West Karuvelipady, Mattancherry, Ernakulam -682005',
  },
  {
    Number: 'KL-57',
    City: 'Koduvally',
    State: 'Kerala',
    Phone: '+91-495-2210280',
    Email: '[email protected]',
    Address: 'Koduvally Post, Kozhikode - 673572',
  },
  {
    Number: 'KL-52',
    City: 'Pattambi',
    State: 'Kerala',
    Phone: '+91-466-2214182',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Pattambi, Palakkad - 679303',
  },
  {
    Number: 'KL-03',
    City: 'Pathanamthitta',
    State: 'Kerala',
    Phone: '+91-473-2322426',
    Email: '[email protected]',
    Address: 'Stadium Junction, Kaipatoor Pathanamthitta Road, Pathanamthitta -689645',
  },
  {
    Number: 'KL-64',
    City: 'Chalakkudy',
    State: 'Kerala',
    Phone: '+91-480-2700064',
    Email: '[email protected]',
    Address: '2nd Floor, Mini Civil Station, NH 47 Bye Pass, Chalakudi, Thrissur- 680307',
  },
  {
    Number: 'KL-39',
    City: 'Thripunithura',
    State: 'Kerala',
    Phone: '+91-484-2774166',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Tripunithura, Ernakulam - 682301',
  },
  {
    Number: 'KL-72',
    City: 'Mananthavady',
    State: 'Kerala',
    Phone: '+91-4935-227972',
    Email: '[email protected]',
    Address: 'Mananthavady, Wayanad - 670645',
  },
  {
    Number: 'KL-23',
    City: 'Karunagapally',
    State: 'Kerala',
    Phone: '+91-476-2625041',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Karunagappally, Kollam - 690518',
  },
  {
    Number: 'KL-40',
    City: 'Perumbavoor',
    State: 'Kerala',
    Phone: '+91-484-2525573',
    Email: '[email protected]',
    Address: 'Perumbavoor, Ernakulam',
  },
  {
    Number: 'KL-04',
    City: 'Alappuzha',
    State: 'Kerala',
    Phone: '+91-477-2253160',
    Email: '[email protected]',
    Address: 'Civil Station, Alappuzha - 688001',
  },
  {
    Number: 'KL-31',
    City: 'Mavelikara',
    State: 'Kerala',
    Phone: '+91-479-2306200',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Mavelikkara, Alappuzha - 690101',
  },
  {
    Number: 'KL-28',
    City: 'Mallappally',
    State: 'Kerala',
    Phone: '+91-469-2681900',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Mallappally, Pathanamthitta - 689585',
  },
  {
    Number: 'KL-38',
    City: 'Thodupuzha',
    State: 'Kerala',
    Phone: '+91-4862-225564',
    Email: '[email protected]',
    Address: 'Prakash Building, Muvattupuzha Road, Thodupuzha, Idukki - 685584',
  },
  {
    Number: 'KL-11',
    City: 'Kozhikode',
    State: 'Kerala',
    Phone: '+91-495-2371705',
    Email: '[email protected]',
    Address: 'Ground Floor, Calicut Civil Station, Kozhikode - 673020',
  },
  {
    Number: 'KL-59',
    City: 'Thaliparamba',
    State: 'Kerala',
    Phone: '+91-460-2206580',
    Email: '[email protected]',
    Address: 'Katti Complex, Manna, Thaliparamba, Kannur - 670141',
  },
  {
    Number: 'KL-50',
    City: 'Mannarghat Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-79',
    City: 'Vellarikundu Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-53',
    City: 'Perinthalmanna',
    State: 'Kerala',
    Phone: '+91-4933-220856',
    Email: '[email protected]',
    Address: 'Padippura Buildings, Kozhikkode Road, Perinthalmanna, Malappuram -679322',
  },
  {
    Number: 'KL-18',
    City: 'Vadakara',
    State: 'Kerala',
    Phone: '+91-496-2526234',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Vadakara, Kozhikode - 673101',
  },
  {
    Number: 'KL-99',
    City: 'Tc Office Sta Office',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-67',
    City: 'Uzhavoor',
    State: 'Kerala',
    Phone: '+91-4822-249967',
    Email: '[email protected]',
    Address: 'Near SBT, Uzhavoor, Kottayam - 686634',
  },
  {
    Number: 'KL-35',
    City: 'Pala',
    State: 'Kerala',
    Phone: '+91-482-2216455',
    Email: '[email protected]',
    Address: '186/C, Ward No 15, Chettimattom, Pala, Kottayam - 686575',
  },
  {
    Number: 'KL-77',
    City: 'Perambra Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-06',
    City: 'Idukki Rto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-75',
    City: 'Thriprayar Srto',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'Kerala',
  },
  {
    Number: 'KL-48',
    City: 'Wadakkancherry',
    State: 'Kerala',
    Phone: '+91-4884-233666',
    Email: '[email protected]',
    Address: 'Souhruda Arcade, Near Taluk Office, Wadakkancherry, Thrissur -680582',
  },
  {
    Number: 'KL-02',
    City: 'Kollam',
    State: 'Kerala',
    Phone: '+91-474-2793499',
    Email: '[email protected]',
    Address: 'Kollam Civil Station, Kollam - 691013',
  },
  {
    Number: 'KL-24',
    City: 'Kottarakara',
    State: 'Kerala',
    Phone: '+91-474-2455699',
    Email: '[email protected]',
    Address: 'Polachira Building, Market Junction, Kottarakkara, Kollam - 691506',
  },
  {
    Number: 'KL-36',
    City: 'Vaikom',
    State: 'Kerala',
    Phone: '+91-4829-224141',
    Email: '[email protected]',
    Address: 'Muncipal Building, Kochukavala, Vaikkom, Kottayam - 686141',
  },
  {
    Number: 'KL-55',
    City: 'Tirur',
    State: 'Kerala',
    Phone: '+91-494-2423700',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Tirur, Malappuram - 676101',
  },
  {
    Number: 'KL-81',
    City: 'VARKALA',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'VARKALA, Kerala',
  },
  {
    Number: 'KL-14',
    City: 'Kasargode',
    State: 'Kerala',
    Phone: '+91-4994-255290',
    Email: '[email protected]',
    Address: 'Civil Station, Vidya Nagar, Kasaragod - 671123',
  },
  {
    Number: 'KL-34',
    City: 'Kanjirappally',
    State: 'Kerala',
    Phone: '+91-4828-223090',
    Email: '[email protected]',
    Address: 'Mangalappady Building, Attikkal, Ponkunnam, Kanjirappally, Kottayam- 686506',
  },
  {
    Number: 'KL-80',
    City: 'PATHANAPURAM',
    State: 'Kerala',
    Phone: '-',
    Email: '-',
    Address: 'PATHANAPURAM, Kerala',
  },
  {
    Number: 'KL-41',
    City: 'Aluva',
    State: 'Kerala',
    Phone: '+91-484-2622006',
    Email: '[email protected]',
    Address: 'Mini Civil Station, Aluva, Ernakulam - 683101',
  },
  {
    Number: 'KL-58',
    City: 'Thalassery',
    State: 'Kerala',
    Phone: '+91-490-2327300',
    Email: '[email protected]',
    Address: '3rd Floor, Hindustan Tower, Near Town Hall, Thalassery, Kannur -670104',
  },
  //Lakshadweep islands
  {
    Number: 'LD-02',
    City: 'AGATTI',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'AGATTI, Lakshadweep',
  },
  {
    Number: 'LD-06',
    City: 'KILTAN',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'KILTAN, Lakshadweep',
  },
  {
    Number: 'LD-04',
    City: 'ANDROTH',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'ANDROTH, Lakshadweep',
  },
  {
    Number: 'LD-01',
    City: 'KAVARATTI',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'KAVARATTI, Lakshadweep',
  },
  {
    Number: 'LD-05',
    City: 'KADMAT',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'KADMAT, Lakshadweep',
  },
  {
    Number: 'LD-03',
    City: 'AMINI',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'AMINI, Lakshadweep',
  },
  {
    Number: 'LD-07',
    City: 'KALPENI',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'KALPENI, Lakshadweep',
  },
  {
    Number: 'LD-08',
    City: 'Kalpeni',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'Kalpeni, Lakshadweep - 682557',
  },
  {
    Number: 'LD-09',
    City: 'MINICOY',
    State: 'Lakshadweep Islands',
    Phone: '-',
    Email: '-',
    Address: 'MINICOY, Lakshadweep',
  },
  // Madhya pradesh
  {
    Number: 'MP-41',
    City: 'Dewas',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Dewas, Madhya Pradesh',
  },
  {
    Number: 'MP-25',
    City: 'JAGDALPUR / SHEO',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'JAGDALPUR / SHEO, Madhya Pradesh',
  },
  {
    Number: 'MP-20',
    City: 'Jabalpur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Jabalpur, Madhya Pradesh',
  },
  {
    Number: 'MP-12',
    City: 'Khandwa',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Khandwa, Madhya Pradesh',
  },
  {
    Number: 'MP-68',
    City: 'Burhanpur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Burhanpur, Madhya Pradesh',
  },
  {
    Number: 'MP-22',
    City: 'Seoni',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Seoni, Madhya Pradesh',
  },
  {
    Number: 'MP-54',
    City: 'Umariya',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Umariya Madhya pradesh',
  },
  {
    Number: 'MP-37',
    City: 'Sehore',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sehore, Madhya Pradesh',
  },
  {
    Number: 'MP-15',
    City: 'Sagar',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sagar, Madhya Pradesh',
  },
  {
    Number: 'MP-08',
    City: 'Guna',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Guna, Madhya Pradesh',
  },
  {
    Number: 'MP-23',
    City: 'RAIPUR (C.G.)',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'RAIPUR (C.G.), Madhya Pradesh',
  },
  {
    Number: 'MP-21',
    City: 'Katni',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Katni, Madhya Pradesh',
  },
  {
    Number: 'MP-02',
    City: 'M.P. GOVERNMENT',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'M.P. GOVERNMENT, Madhya Pradesh',
  },
  {
    Number: 'MP-30',
    City: 'Bhind',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Bhind, Madhya Pradesh',
  },
  {
    Number: 'MP-32',
    City: 'Datia',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Datia, Madhya Pradesh',
  },
  {
    Number: 'MP-51',
    City: 'Mandla',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mandla, Madhya Pradesh',
  },
  {
    Number: 'MP-47',
    City: 'HARDA',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'HARDA, Madhya Pradesh',
  },
  {
    Number: 'MP-39',
    City: 'Rajgarh',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Rajgarh, Madhya Pradesh',
  },
  {
    Number: 'MP-38',
    City: 'Raisen',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Raisen, Madhya Pradesh',
  },
  {
    Number: 'MP-69',
    City: 'Alirajpur (not yet used)',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Alirajpur, Madhya Pradesh',
  },
  {
    Number: 'MP-53',
    City: 'Sidhi',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sidhi, Madhya Pradesh',
  },
  {
    Number: 'MP-46',
    City: 'BARWANI',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'BARWANI, Madhya Pradesh',
  },
  {
    Number: 'MP-18',
    City: 'Shahdol',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Shahdol, Madhya Pradesh',
  },
  {
    Number: 'MP-52',
    City: 'Dindori',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Dindori, Madhya Pradesh',
  },
  {
    Number: 'MP-45',
    City: 'Jhabua',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Jhabua, Madhya Pradesh',
  },
  {
    Number: 'MP-14',
    City: 'Mandasaur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mandasaur, Madhya Pradesh',
  },
  {
    Number: 'MP-42',
    City: 'Shajapur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Shajapur, Madhya Pradesh',
  },
  {
    Number: 'MP-16',
    City: 'Chhatarpur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Chhatarpur, Madhya Pradesh',
  },
  {
    Number: 'MP-66',
    City: 'Singrauli',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Singrauli, Madhya Pradesh',
  },
  {
    Number: 'MP-17',
    City: 'Rewa',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Rewa, Madhya Pradesh',
  },
  {
    Number: 'MP-71',
    City: 'NIWARI',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'NIWARI, Madhya Pradesh',
  },
  {
    Number: 'MP-01',
    City: 'Madhya Pradesh',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: '0',
  },
  {
    Number: 'MP-36',
    City: 'TIKAMGARH',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'TIKAMGARH, Madhya Pradesh',
  },
  {
    Number: 'MP-31',
    City: 'Sheopur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sheopur, Madhya Pradesh',
  },
  {
    Number: 'MP-70',
    City: 'AGAR',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'AGAR, Madhya Pradesh',
  },
  {
    Number: 'MP-19',
    City: 'Satna',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Satna, Madhya Pradesh',
  },
  {
    Number: 'MP-48',
    City: 'Betul',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Betul, Madhya Pradesh',
  },
  {
    Number: 'MP-26',
    City: 'BILASPUR [DISAMB',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'BILASPUR [DISAMB, Madhya Pradesh',
  },
  {
    Number: 'MP-10',
    City: 'Khargone',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Khargone, Madhya Pradesh',
  },
  {
    Number: 'MP-40',
    City: 'Vidisha',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Vidisha, Madhya Pradesh',
  },
  {
    Number: 'MP-28',
    City: 'CHHINDWARA',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'CHHINDWARA, Madhya Pradesh',
  },
  {
    Number: 'MP-65',
    City: 'ANUPPUR',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'ANUPPUR, Madhya Pradesh',
  },
  {
    Number: 'MP-67',
    City: 'Ashoknagar',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ashoknagar, Madhya Pradesh',
  },
  {
    Number: 'MP-43',
    City: 'Ratlam',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ratlam, Madhya Pradesh',
  },
  {
    Number: 'MP-03',
    City: 'M.P. POLICE',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'M.P. POLICE, Madhya Pradesh',
  },
  {
    Number: 'MP-34',
    City: 'Damoh',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Damoh, Madhya Pradesh',
  },
  {
    Number: 'MP-06',
    City: 'Morena',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Morena, Madhya Pradesh',
  },
  {
    Number: 'MP-13',
    City: 'Ujjain',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ujjain, Madhya Pradesh',
  },
  {
    Number: 'MP-07',
    City: 'Gwalior',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Gwalior, Madhya Pradesh',
  },
  {
    Number: 'MP-44',
    City: 'Neemuch',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Neemuch, Madhya Pradesh',
  },
  {
    Number: 'MP-35',
    City: 'Panna',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Panna, Madhya Pradesh',
  },
  {
    Number: 'MP-50',
    City: 'Balaghat',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Balaghat, Madhya Pradesh',
  },
  {
    Number: 'MP-49',
    City: 'Narsinghpur',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Narsinghpur, Madhya Pradesh',
  },
  {
    Number: 'MP-04',
    City: 'Bhopal',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Bhopal, Madhya Pradesh',
  },
  {
    Number: 'MP-33',
    City: 'Shivpuri',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Shivpuri, Madhya Pradesh',
  },
  {
    Number: 'MP-09',
    City: 'Indore',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Indore, Madhya Pradesh',
  },
  {
    Number: 'MP-11',
    City: 'Dhar',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Dhar, Madhya Pradesh',
  },
  {
    Number: 'MP-05',
    City: 'Hoshangabad',
    State: 'Madhya Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Hoshangabad, Madhya Pradesh',
  },
  // Maharashtra
  {
    Number: 'MH-02',
    City: 'Mumbai (West) - Andheri',
    State: 'Maharashtra',
    Phone: '+91-22-26366957 / 26362252',
    Email: '[email protected]',
    Address: 'Ambivali Village, New Manish Nagar, Versova Road, Mumbai - 400053',
  },
  {
    Number: 'MH-16',
    City: 'Ahmednagar',
    State: 'Maharashtra',
    Phone: '+91-241-431530',
    Email: '[email protected]',
    Address: 'Nagar Wanbori Road, Ahmednager - 414001',
  },
  {
    Number: 'MH-31',
    City: 'Nagpur',
    State: 'Maharashtra',
    Phone: '+91-712-2560781',
    Email: '[email protected]',
    Address: 'Opp. Giripeth Post Office, Amravati Road, Nagpur - 440001',
  },
  {
    Number: 'MH-30',
    City: 'Akola',
    State: 'Maharashtra',
    Phone: '+91-724-2459488',
    Email: '[email protected]',
    Address: 'Murtizapurr Road, Near Krishi Nagar, Akola - 444104',
  },
  {
    Number: 'MH-01',
    City: 'Mumbai (South) - Tardeo',
    State: 'Maharashtra',
    Phone: '+91-22-23532337 / 23534600',
    Email: '[email protected]',
    Address: 'Old Bodyguard Lane, Tulsiwadi, Tardeo, Mumbai - 400034',
  },
  {
    Number: 'MH-50',
    City: 'Karad',
    State: 'Maharashtra',
    Phone: '+91-2164-255300 / 255400',
    Email: '[email protected]',
    Address: 'Padali (Kese), Supane, Karad, Satara - 415114',
  },
  {
    Number: 'MH-39',
    City: 'Nandurbar',
    State: 'Maharashtra',
    Phone: '+91-2564-210129',
    Email: '[email protected]',
    Address: 'Shasakiya Dhudh Bhavan, Sakri Road, Nandurbar - 425412',
  },
  {
    Number: 'MH-09',
    City: 'Kolhapur',
    State: 'Maharashtra',
    Phone: '+91-231-663131',
    Email: '[email protected]',
    Address: 'Tarabai Park, Kolhapur - 416003',
  },
  {
    Number: 'MH-28',
    City: 'Buldana',
    State: 'Maharashtra',
    Phone: '+91-7262-242244',
    Email: '[email protected]',
    Address: 'Opp. Malkapur Road, Buldhana - 443001',
  },
  {
    Number: 'MH-14',
    City: 'Pimpri Chinchwad',
    State: 'Maharashtra',
    Phone: '+91-20-27492828',
    Email: '[email protected]',
    Address: 'Purna Complex, A Wing, Opp. Telco Gate, Chikhali Road, PimpariChinchwad, Pune - 411019',
  },
  {
    Number: 'MH-04',
    City: 'Thane',
    State: 'Maharashtra',
    Phone: '+91-22-25343580 / 25363838',
    Email: '[email protected]',
    Address: 'Opp. Central Jail, Thane - 400601',
  },
  {
    Number: 'MH-18',
    City: 'Dhule',
    State: 'Maharashtra',
    Phone: '+91-2562-281351 / 281352',
    Email: '[email protected]',
    Address: 'Dhdh Bhavan, Mohadi Upanagar, NH 3, Mumbai Agra Road, Dhule -424311',
  },
  {
    Number: 'MH-38',
    City: 'Hingoli',
    State: 'Maharashtra',
    Phone: '+91-2456-248048',
    Email: '[email protected]',
    Address: 'Jaiswlsadan, MIDC Limbala Makta, Hingoli - 431513',
  },
  {
    Number: 'MH-03',
    City: 'Mumbai (East) - Ghatkopar',
    State: 'Maharashtra',
    Phone: '+91-22-24036479 / 24036221',
    Email: '[email protected]',
    Address: '3rd Floor, Wadala Truck Terminals, Wadala, Mumbai - 400037',
  },
  {
    Number: 'MH-21',
    City: 'Jalna',
    State: 'Maharashtra',
    Phone: '+91-2482-220929 / 220968',
    Email: '[email protected]',
    Address: 'Nagewadi, Jalna - 431203',
  },
  {
    Number: 'MH-12',
    City: 'Pune',
    State: 'Maharashtra',
    Phone: '+91-20-26058080 / 26058090',
    Email: '[email protected]',
    Address: 'Dr. Ambedkar Raod, Near Sangam Bridge, Pune - 411001',
  },
  {
    Number: 'MH-19',
    City: 'Jalgaon',
    State: 'Maharashtra',
    Phone: '+91-257-2262619',
    Email: '[email protected]',
    Address: 'Adarsh Nagar, Near SP Chowk, Jalgaon - 425001',
  },
  {
    Number: 'MH-05',
    City: 'Kalyan',
    State: 'Maharashtra',
    Phone: '+91-251-2230505',
    Email: '[email protected]',
    Address: 'Sahyadri Nagar, Chikanghar, Near Birla School, Kalyan(W), Thane -421301',
  },
  {
    Number: 'MH-07',
    City: 'Sindhudurg Nagari',
    State: 'Maharashtra',
    Phone: '+91-2362-229050',
    Email: '[email protected]',
    Address: 'Sindhudurg Nagari, Oros, Sindhudurg - 416812',
  },
  {
    Number: 'MH-42',
    City: 'Baramati - Pune',
    State: 'Maharashtra',
    Phone: '+91-2112-243111',
    Email: '[email protected]',
    Address: 'Vidhya Corner, MIDC Circle, Bhigwan Road, Baramati, Pune - 413133',
  },
  {
    Number: 'MH-10',
    City: 'Sangli',
    State: 'Maharashtra',
    Phone: '+91-233-310555',
    Email: '[email protected]',
    Address: 'Madhav Nagar Road, Industrial Estate, Sangli - 416416',
  },
  {
    Number: 'MH-40',
    City: 'Wadi Nagpur',
    State: 'Maharashtra',
    Phone: '+91-712-2630574',
    Email: '[email protected]',
    Address: 'Teka Naka, Kamptee Road, Nagpur - 440014',
  },
  {
    Number: 'MH-11',
    City: 'Satara',
    State: 'Maharashtra',
    Phone: '+91-2162-235888',
    Email: '[email protected]',
    Address: 'Sadar Bazar, Satara - 415001',
  },
  {
    Number: 'MH-17',
    City: 'Shrirampur - Ahmednagar',
    State: 'Maharashtra',
    Phone: '+91-2422-222175 / 223102',
    Email: '[email protected]',
    Address: 'Market Yard, Nevasa Road, Ahemednagar, Shrirampur - 413709',
  },
  {
    Number: 'MH-22',
    City: 'Parbhani',
    State: 'Maharashtra',
    Phone: '+91-2452-291000',
    Email: '[email protected]',
    Address: 'Manvat Road, Parbhani - 431401',
  },
  {
    Number: 'MH-46',
    City: 'Panvel',
    State: 'Maharashtra',
    Phone: '+91-22-27424444',
    Email: '[email protected]',
    Address: 'Central Facility Building, Steel Market, Kalamboli, Panvel, Raigad- 410218',
  },
  {
    Number: 'MH-33',
    City: 'Gadchiroli',
    State: 'Maharashtra',
    Phone: '+91-7132-222195',
    Email: '[email protected]',
    Address: 'New Administrative Building, Near Collector Office Complex,Gadchiroli - 442605',
  },
  {
    Number: 'MH-20',
    City: 'Aurangabad',
    State: 'Maharashtra',
    Phone: '+91-240-2331135 / 2321164',
    Email: '[email protected]',
    Address: 'Railway Station Road, Aurangabad - 431001',
  },
  {
    Number: 'MH-51',
    City: 'Nashik Rural',
    State: 'Maharashtra',
    Phone: '-',
    Email: '-',
    Address: 'Nashik Rural, Maharashtra',
  },
  {
    Number: 'MH-41',
    City: 'Malegaon - Nashik District',
    State: 'Maharashtra',
    Phone: '+91-2554-258850',
    Email: '[email protected]',
    Address: 'Market Yard, Camp Road Malegaon, Nasik - 423105',
  },
  {
    Number: 'MH-48',
    City: 'Vasai - Virar',
    State: 'Maharashtra',
    Phone: '+91-250-2523888',
    Email: '[email protected]',
    Address: 'Chandansar, Virar (E), Vasai, Thane - 401303',
  },
  {
    Number: 'MH-24',
    City: 'Latur',
    State: 'Maharashtra',
    Phone: '+91-2382-242434 / 242435',
    Email: '[email protected]',
    Address: 'Parivahan Bhavan, Bhabhalgaon Road, Latur - 413512',
  },
  {
    Number: 'MH-15',
    City: 'Nashik',
    State: 'Maharashtra',
    Phone: '+91-253-2229005',
    Email: '[email protected]',
    Address: 'Peth Road, Panchvati, Nashik - 422044',
  },
  {
    Number: 'MH-35',
    City: 'Gondia',
    State: 'Maharashtra',
    Phone: '+91-7182-237321',
    Email: '[email protected]',
    Address: 'Fulchur Naka, Fulchurtola, Gondia - 441601',
  },
  {
    Number: 'MH-27',
    City: 'Amravati',
    State: 'Maharashtra',
    Phone: '+91-721-2662032 / 2662606',
    Email: '[email protected]',
    Address: 'Near Collectorate Camp, Amravati - 444602',
  },
  {
    Number: 'MH-47',
    City: 'Borivali',
    State: 'Maharashtra',
    Phone: '+91-22-26366957 / 26362252',
    Email: '[email protected]',
    Address: 'Ambivali Village, New Manish Nagar, Versova Road, Mumbai - 400053',
  },
  {
    Number: 'MH-45',
    City: 'Akluj - Solapur',
    State: 'Maharashtra',
    Phone: '+91-2185-31231',
    Email: '[email protected]',
    Address: 'Tahshil, Malshiras, Solapur - 413101',
  },
  {
    Number: 'MH-13',
    City: 'Solapur',
    State: 'Maharashtra',
    Phone: '+91-217-303099',
    Email: '[email protected]',
    Address: 'Vijapur Road, ST Colony, Sundaram Nagar, Solapur - 413004',
  },
  {
    Number: 'MH-43',
    City: 'Vashi (Sanpada)',
    State: 'Maharashtra',
    Phone: '+91-22-27650701',
    Email: '[email protected]',
    Address: 'T Block, Sector 19B, APMC Market, Vashi, Mumbai - 400705',
  },
  {
    Number: 'MH-25',
    City: 'Osmanabad',
    State: 'Maharashtra',
    Phone: '+91-2472-221555',
    Email: '[email protected]',
    Address: 'MIDC Area, Osmanabad - 413501',
  },
  {
    Number: 'MH-34',
    City: 'Chandrapur',
    State: 'Maharashtra',
    Phone: '+91-712-255372',
    Email: '[email protected]',
    Address: 'Behind LIC Building, Jailnagar Ward, Chandrapur - 442401',
  },
  {
    Number: 'MH-36',
    City: 'Bhandara',
    State: 'Maharashtra',
    Phone: '+91-7184-258165',
    Email: '[email protected]',
    Address: 'Administrative Building, NH 6, Bhandara - 441904',
  },
  {
    Number: 'MH-44',
    City: 'Ambejogai Beed',
    State: 'Maharashtra',
    Phone: '+91-2446-247755',
    Email: '[email protected]',
    Address: 'Yeshwantrao Chavan Chowk, Morewadi, Ambajogai, Beed - 431517',
  },
  {
    Number: 'MH-06',
    City: 'Raigad',
    State: 'Maharashtra',
    Phone: '+91-2143-252234',
    Email: '[email protected]',
    Address: 'Vikas Smruti, Pen Khopoli Road, Utkarsha Nagar, Raigad - 402107',
  },
  {
    Number: 'MH-32',
    City: 'Wardha',
    State: 'Maharashtra',
    Phone: '+91-7152-252400',
    Email: '[email protected]',
    Address: 'Administrative Building, 1st Floor, Sevagram Road, Wardha - 442001',
  },
  {
    Number: 'MH-23',
    City: 'Beed',
    State: 'Maharashtra',
    Phone: '+91-2442-256111',
    Email: '[email protected]',
    Address: 'Jalna Road, Mauje Ghosapuri, Namal Gaon Phata, Beed - 431122',
  },
  {
    Number: 'MH-08',
    City: 'Ratnagiri',
    State: 'Maharashtra',
    Phone: '+91-2352-29444',
    Email: '[email protected]',
    Address: 'Ganesh Nagar, Pomendi Kurd, Kuwarbav, Ratnagiri - 415612',
  },
  {
    Number: 'MH-26',
    City: 'Nanded',
    State: 'Maharashtra',
    Phone: '+91-2462-259900',
    Email: '[email protected]',
    Address: 'Marathwada Ceramic Complex, MIDC Cidco Nanded - 431603',
  },
  {
    Number: 'MH-99',
    City: 'Tc Office',
    State: 'Maharashtra',
    Phone: '-',
    Email: '-',
    Address: 'Maharashtra',
  },
  {
    Number: 'MH-29',
    City: 'Yavatmal',
    State: 'Maharashtra',
    Phone: '+91-7232-255111',
    Email: '[email protected]',
    Address: 'Near Kalamb Chowk, Nagpur Road, Yawatmal, Yavatmal - 445001',
  },
  {
    Number: 'MH-52',
    City: 'Parbhani Rural',
    State: 'Maharashtra',
    Phone: '-',
    Email: '-',
    Address: 'Parbhani Rural, Maharashtra',
  },
  {
    Number: 'MH-49',
    City: 'Nagpur (East) - Bhandara Road',
    State: 'Maharashtra',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Opp. Giripeth Post Office, Nagur - 440001',
  },
  {
    Number: 'MH-37',
    City: 'Washim',
    State: 'Maharashtra',
    Phone: '+91-7252-235244',
    Email: '[email protected]',
    Address: 'College Building, Risod Road Lakhala, Washim - 444505',
  },
  //Manipur
  {
    Number: 'MN-05',
    City: 'Bishnupur',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Bishnupur, Manipur - 795133',
  },
  {
    Number: 'MN-03',
    City: 'Kangpokpi',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Manipur',
  },
  {
    Number: 'MN-04',
    City: 'Thoubal',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Manipur',
  },
  {
    Number: 'MN-02',
    City: 'Churachandpur',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Manipur',
  },
  {
    Number: 'MN-07',
    City: 'Ukhrul',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Manipur',
  },
  {
    Number: 'MN-01',
    City: 'Imphal West',
    State: 'Manipur',
    Phone: '+91-385-2225204',
    Email: '-',
    Address: 'Imphal West, Manipur - 795001',
  },
  {
    Number: 'MN-06',
    City: 'Imphal East',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Manipur',
  },
  {
    Number: 'MN-08',
    City: 'Senapati',
    State: 'Manipur',
    Phone: '-',
    Email: '-',
    Address: 'Manipur',
  },
  // Meghalaya
  {
    Number: 'ML-14',
    City: 'Ampati',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-11',
    City: 'Khliehriat',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-07',
    City: 'Williamnagar',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-04',
    City: 'Jowai',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-03',
    City: 'SHILLONG (COM.)',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'SHILLONG (COM.), Meghalaya',
  },
  {
    Number: 'ML-12',
    City: 'Mawkyrwat',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-99',
    City: 'State Transport Authority',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-10',
    City: 'Nongpoh',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-06',
    City: 'Nongstoin',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-09',
    City: 'Baghmara',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-05',
    City: 'Shillong',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Shillong, East Khasi Hills - 793001',
  },
  {
    Number: 'ML-02',
    City: 'SHILLONG POLICE',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'SHILLONG POLICE, Meghalaya',
  },
  {
    Number: 'ML-13',
    City: 'Resubelpara',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Meghalaya',
  },
  {
    Number: 'ML-08',
    City: 'West Garo Hills',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'Tura, West Garo Hills - 794001',
  },
  {
    Number: 'ML-01',
    City: 'ML GOVERNMENT',
    State: 'Meghalaya',
    Phone: '-',
    Email: '-',
    Address: 'ML GOVERNMENT, Meghalaya',
  },
  //Mizoram
  {
    Number: 'MZ-01',
    City: 'Aizawl',
    State: 'Mizoram',
    Phone: '+91-389-223254',
    Email: '-',
    Address: 'Aizawl, Mizoram',
  },
  {
    Number: 'MZ-04',
    City: 'Champhai',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-08',
    City: 'Mamit',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-09',
    City: 'Aizawl Rural Dto',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-05',
    City: 'Kolasib',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-03',
    City: 'Saiha',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-99',
    City: 'State Transport Authority',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-07',
    City: 'Lawngtlai',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  {
    Number: 'MZ-02',
    City: 'Lunglei',
    State: 'Mizoram',
    Phone: '-',
    Email: '-',
    Address: 'Mizoram',
  },
  //Nagaland
  {
    Number: 'NL-06',
    City: 'Zunheboto Dto',
    State: 'Nagaland',
    Phone: '-',
    Email: '-',
    Address: 'Nagaland',
  },
  {
    Number: 'NL-02',
    City: 'Mokokchung Rto',
    State: 'Nagaland',
    Phone: '-',
    Email: '-',
    Address: 'Nagaland',
  },
  {
    Number: 'NL-08',
    City: 'Phek Dto',
    State: 'Nagaland',
    Phone: '-',
    Email: '-',
    Address: 'Nagaland',
  },
  {
    Number: 'NL-03',
    City: 'Tuensang Dto',
    State: 'Nagaland',
    Phone: '-',
    Email: '-',
    Address: 'Nagaland',
  },
  {
    Number: 'NL-05',
    City: 'Wokha Dto',
    State: 'Nagaland',
    Phone: '-',
    Email: '-',
    Address: 'Nagaland',
  },
  {
    Number: 'NL-01',
    City: 'Kohima',
    State: 'Nagaland',
    Phone: '+91-3866-221315',
    Email: '-',
    Address: 'Secretariat Complex, Kohima, Nagaland - 797001',
  },
  {
    Number: 'NL-04',
    City: 'Mon',
    State: 'Nagaland',
    Phone: '+91-3869-221383',
    Email: '-',
    Address: 'Mon, Nagaland - 798603',
  },
  //Odisha
  {
    Number: 'OR-19',
    City: 'ANGUL',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'ANGUL, Odisa',
  },
  {
    Number: 'OD-19',
    City: 'Angul',
    State: 'Odisha',
    Phone: '+91-6764-232727',
    Email: '-',
    Address: 'Angul, Odisha - 759122',
  },
  {
    Number: 'OD-02',
    City: 'Bhubaneswar',
    State: 'Odisha',
    Phone: '+91-674-2540904',
    Email: '-',
    Address: 'Bhubaneswar, Odisha - 751001',
  },
  {
    Number: 'OD-20',
    City: 'Gajapati',
    State: 'Odisha',
    Phone: '+(91)-6815-224233',
    Email: '-',
    Address: 'Gajapati, Odisha - 761200',
  },
  {
    Number: 'OD-05',
    City: 'Cuttack',
    State: 'Odisha',
    Phone: '+91-671-2607492',
    Email: '-',
    Address: 'Cuttack, Odisha - 753001',
  },
  {
    Number: 'OD-27',
    City: 'BOUDH',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BOUDH, Odisa',
  },
  {
    Number: 'OR-02',
    City: 'BHUBANESWAR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BHUBANESWAR, Odisa',
  },
  {
    Number: 'OR-10',
    City: 'KORAPUT',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'KORAPUT, Odisa',
  },
  {
    Number: 'OD-12',
    City: 'Phulabani Khandamal',
    State: 'Odisha',
    Phone: '+(91)-6842-253654',
    Email: '-',
    Address: 'Phulbani Kandhamal, Odisha - 762001',
  },
  {
    Number: 'OR-04',
    City: 'CHANDIKHOLE',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'CHANDIKHOLE, Odisa',
  },
  {
    Number: 'OR-20',
    City: 'GAJAPATI',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'GAJAPATI, Odisa',
  },
  {
    Number: 'OR-11',
    City: 'MAYURBHANJ',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'MAYURBHANJ, Odisa',
  },
  {
    Number: 'OR-16',
    City: 'SUNDERGARH',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'SUNDERGARH, Odisa',
  },
  {
    Number: 'OR-13',
    City: 'PURI',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'PURI, Odisa',
  },
  {
    Number: 'OR-18',
    City: 'RAYAGADA',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'RAYAGADA, Odisa',
  },
  {
    Number: 'OD-23',
    City: 'Jharsuguda',
    State: 'Odisha',
    Phone: '+91-6645-271040',
    Email: '-',
    Address: 'Jharsuguda, Odisha - 768201',
  },
  {
    Number: 'OR-05',
    City: 'CUTTACK',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'CUTTACK, Odisa',
  },
  {
    Number: 'OR-06',
    City: 'DHENKANAL',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'DHENKANAL, Odisa',
  },
  {
    Number: 'OR-01',
    City: 'BALASORE',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BALASORE, Odisa',
  },
  {
    Number: 'OR-17',
    City: 'BARAGARH',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BARAGARH, Odisa',
  },
  {
    Number: 'OD-22',
    City: 'Bhadrak',
    State: 'Odisha',
    Phone: '+(91)-6784-211335',
    Email: '-',
    Address: 'Bhadrak, Odisha - 756100',
  },
  {
    Number: 'OD-06',
    City: 'Dhenkanal',
    State: 'Odisha',
    Phone: '+91-6762-224424',
    Email: '-',
    Address: 'Dhenkanal, Odisha - 759001',
  },
  {
    Number: 'OD-14',
    City: 'Rourkela',
    State: 'Odisha',
    Phone: '+91-661-2500833',
    Email: '-',
    Address: 'Rourkela, Odisha - 769001',
  },
  {
    Number: 'OD-15',
    City: 'Sambalpur',
    State: 'Odisha',
    Phone: '+91-663-2410371',
    Email: '-',
    Address: 'Sambalpur, Odisha - 768001',
  },
  {
    Number: 'OD-17',
    City: 'Baragarh',
    State: 'Odisha',
    Phone: '+(91)-6646-232697',
    Email: '-',
    Address: 'Bargarh, Orissa - 768028',
  },
  {
    Number: 'OD-21',
    City: 'Jagatsinghpur',
    State: 'Odisha',
    Phone: '+(91)-6724-222755',
    Email: '-',
    Address: 'Jagatsinghpur, Odisha - 754103',
  },
  {
    Number: 'OR-07',
    City: 'GANJAM',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'GANJAM, Odisa',
  },
  {
    Number: 'OD-08',
    City: 'Kalahandi',
    State: 'Odisha',
    Phone: '+91-6670-230545',
    Email: '-',
    Address: 'Kalahandi, Odisha - 766001',
  },
  {
    Number: 'OR-09',
    City: 'KEONJHAR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'KEONJHAR, Odisa',
  },
  {
    Number: 'OR-14',
    City: 'ROURKELA',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'ROURKELA, Odisa',
  },
  {
    Number: 'OD-07',
    City: 'Ganjam',
    State: 'Odisha',
    Phone: '+(91)-6811-263974',
    Email: '-',
    Address: 'Ganjam, Odisha - 760001',
  },
  {
    Number: 'OD-09',
    City: 'Keonjhar',
    State: 'Odisha',
    Phone: '+91-6766-255481',
    Email: '-',
    Address: 'Keonjhar, Odisha - 758001',
  },
  {
    Number: 'OR-12',
    City: 'PHULBANI',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'PHULBANI, Odisa',
  },
  {
    Number: 'OD-18',
    City: 'Rayagada',
    State: 'Odisha',
    Phone: '+(91)-6856-222777',
    Email: '-',
    Address: 'Rayagada, Odisha - 765001',
  },
  {
    Number: 'OD-31',
    City: 'SUBARNAPUR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'SUBARNAPUR, Odisa',
  },
  {
    Number: 'OD-03',
    City: 'Balangir',
    State: 'Odisha',
    Phone: '+91-6652-232424',
    Email: '-',
    Address: 'Balangir, Odisha - 767001',
  },
  {
    Number: 'OD-16',
    City: 'Sundergarh',
    State: 'Odisha',
    Phone: '+(91)-6842-253654',
    Email: '-',
    Address: 'Sundergarh, Odisha - 770001',
  },
  {
    Number: 'OR-24',
    City: 'NAWARANGPUR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'NAWARANGPUR, Odisa',
  },
  {
    Number: 'OD-32',
    City: 'BHANJANAGAR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BHANJANAGAR, Odisa',
  },
  {
    Number: 'OR-26',
    City: 'NUAPADA',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'NUAPADA, Odisa',
  },
  {
    Number: 'OD-10',
    City: 'Koraput',
    State: 'Odisha',
    Phone: '+91-6852-250289',
    Email: '-',
    Address: 'Koraput, Odisha - 764001',
  },
  {
    Number: 'OD-33',
    City: 'Bhubaneswar-II',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'Bhubaneswar-2, Odisha - 751002',
  },
  {
    Number: 'OR-15',
    City: 'SAMBALPUR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'SAMBALPUR, Odisa',
  },
  {
    Number: 'OD-28',
    City: 'DEBAGARH',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'DEBAGARH, Odisa',
  },
  {
    Number: 'OR-03',
    City: 'BOLANGIR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BOLANGIR, Odisa',
  },
  {
    Number: 'OD-30',
    City: 'MALKANGIRI',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'MALKANGIRI, Odisa',
  },
  {
    Number: 'OD-35',
    City: 'TALCHER',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'TALCHER, Odisa',
  },
  {
    Number: 'OR-25',
    City: 'NAYAGARH',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'NAYAGARH, Odisa',
  },
  {
    Number: 'OR-22',
    City: 'BHADRAK',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'BHADRAK, Odisa',
  },
  {
    Number: 'OD-04',
    City: 'Chandikhol',
    State: 'Odisha',
    Phone: '+91-6725-220220',
    Email: '-',
    Address: 'Chandikhol, Odisha - 755044',
  },
  {
    Number: 'OR-08',
    City: 'KALAHANDI',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'KALAHANDI, Odisa',
  },
  {
    Number: 'OD-29',
    City: 'KENDRAPARA',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'KENDRAPARA, Odisa',
  },
  {
    Number: 'OD-01',
    City: 'Balasore',
    State: 'Odisha',
    Phone: '+91-6782-262203',
    Email: '-',
    Address: 'Balasore, Odisha - 756001',
  },
  {
    Number: 'OR-21',
    City: 'JAGATSINGHPUR',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'JAGATSINGHPUR, Odisa',
  },
  {
    Number: 'OD-11',
    City: 'Mayurbhanj',
    State: 'Odisha',
    Phone: '+91-6792-260768',
    Email: '-',
    Address: 'Mayurbhanj, Odisha - 757043',
  },
  {
    Number: 'OD-13',
    City: 'Puri',
    State: 'Odisha',
    Phone: '+91-6752-223478',
    Email: '-',
    Address: 'Puri, Odisha - 752001',
  },
  {
    Number: 'OD-34',
    City: 'Jajpur',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'Jajpur, Odisha - 755001',
  },
  {
    Number: 'OR-23',
    City: 'JHARSUGUDA',
    State: 'Odisha',
    Phone: '-',
    Email: '-',
    Address: 'JHARSUGUDA, Odisa',
  },
  //Puducherry
  {
    Number: 'PY-11',
    City: 'Bahour',
    State: 'Puducherry',
    Phone: '-',
    Email: '-',
    Address: 'Puducherry',
  },
  {
    Number: 'PY-51',
    City: 'Villianur',
    State: 'Puducherry',
    Phone: '-',
    Email: '-',
    Address: 'Puducherry',
  },
  {
    Number: 'PY-03',
    City: 'Mahe',
    State: 'Puducherry',
    Phone: '+91-490-2332560',
    Email: '-',
    Address: 'Mahe, Puducherry - 673310',
  },
  {
    Number: 'PY-99',
    City: 'Check Post',
    State: 'Puducherry',
    Phone: '-',
    Email: '-',
    Address: 'Puducherry',
  },
  {
    Number: 'PY-01',
    City: 'Pondicherry',
    State: 'Puducherry',
    Phone: '+91-413-2280380 / 2280170',
    Email: '-',
    Address: '100 Feet Road, Opposite Bus Stop, Mudaliarpet, Puducherry - 605004',
  },
  {
    Number: 'PY-04',
    City: 'Yanam',
    State: 'Puducherry',
    Phone: '-',
    Email: '-',
    Address: 'Puducherry',
  },
  {
    Number: 'PY-02',
    City: 'Karaikal',
    State: 'Puducherry',
    Phone: '-',
    Email: '-',
    Address: 'Puducherry',
  },
  {
    Number: 'PY-05',
    City: 'Oulgaret',
    State: 'Puducherry',
    Phone: '-',
    Email: '-',
    Address: 'Puducherry',
  },
  // Punjab
  {
    Number: 'PB-15',
    City: 'Abohar Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-72',
    City: 'Patran (Patiala East)',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Patran, Patiala, Punjab - 147105',
  },
  {
    Number: 'PB-66',
    City: 'Nihal Singh Wala',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Nihal Singh Wala, Moga, Punjab - 142046',
  },
  {
    Number: 'PB-83',
    City: 'Dudhan Sadhan Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-81',
    City: 'Majitha Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-31',
    City: 'Mansa',
    State: 'Punjab',
    Phone: '+91-1652-227582',
    Email: '-',
    Address: 'Mansa, Punjab - 151505',
  },
  {
    Number: 'PB-76',
    City: 'Dharamkot Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-01',
    City: 'Chandigarh',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Chandigarh, Punjab - 160017',
  },
  {
    Number: 'PB-57',
    City: 'Bhulath',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Bholath, Kapurthala, Punjab - 144622',
  },
  {
    Number: 'PB-89',
    City: 'Amritsar2 Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-91',
    City: 'Ludhiana East Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-13',
    City: 'Sangrur',
    State: 'Punjab',
    Phone: '+91-1672-234355',
    Email: '-',
    Address: 'Sangrur, Punjab - 148001',
  },
  {
    Number: 'PB-45',
    City: 'Talwandi Sabo Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-21',
    City: 'Dasuya Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-04',
    City: 'Faridkot',
    State: 'Punjab',
    Phone: '+91-1639-250715',
    Email: '-',
    Address: 'Faridkot, Punjab - 151203',
  },
  {
    Number: 'PB-63',
    City: 'Khadoor Sahib',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Khadoor Sahib, Amritsar, Punjab - 143117',
  },
  {
    Number: 'PB-84',
    City: 'Bhawnigarh Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-17',
    City: 'Baba Bakala Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-37',
    City: 'Phillour Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-53',
    City: 'Malout Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-99',
    City: 'Dinanagar Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-44',
    City: 'Sunam Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-11',
    City: 'Patiala',
    State: 'Punjab',
    Phone: '+91-175-2311316',
    Email: '-',
    Address: 'Patiala, Punjab - 147001',
  },
  {
    Number: 'PB-65',
    City: 'Mohali',
    State: 'Punjab',
    Phone: '+91-172-5044506',
    Email: '-',
    Address: 'Mohali, Punjab - 140110',
  },
  {
    Number: 'PB-03',
    City: 'Bathinda',
    State: 'Punjab',
    Phone: '+91-164-2216927',
    Email: '-',
    Address: 'Bathinda, Punjab - 151001',
  },
  {
    Number: 'PB-82',
    City: 'Ahmedgarh Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-06',
    City: 'Gurdaspur',
    State: 'Punjab',
    Phone: '+91-1874-242095',
    Email: '-',
    Address: 'Gurdaspur, Punjab - 143521',
  },
  {
    Number: 'PB-28',
    City: 'Malerkotla Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-41',
    City: 'Sultanpur Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-55',
    City: 'Payal Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-43',
    City: 'Samrala',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Samrala, Ludhiana, Punjab - 141114',
  },
  {
    Number: 'PB-71',
    City: 'Chamkaur Sahib',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Chamkaur Sahib, Rupnagar, Punjab - 140112',
  },
  {
    Number: 'PB-32',
    City: 'Nawanshahr',
    State: 'Punjab',
    Phone: '+91-1823-222660',
    Email: '-',
    Address: 'Nawanshahr, Punjab - 144526',
  },
  {
    Number: 'PB-25',
    City: 'Jagraon Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-79',
    City: 'Kotkapura Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-29',
    City: 'Moga',
    State: 'Punjab',
    Phone: '+91-1636-234327',
    Email: '-',
    Address: 'Moga, Punjab - 142001',
  },
  {
    Number: 'PB-70',
    City: 'Dera Bassi Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-68',
    City: 'Dhar Kalan Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-61',
    City: 'Jalalabad Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-23',
    City: 'Fatehgarh Sahib',
    State: 'Punjab',
    Phone: '+91-1763-232196',
    Email: '-',
    Address: 'Fatehgarh Sahib, Punjab - 140406',
  },
  {
    Number: 'PB-40',
    City: 'Rampura Phul',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Rampura Phul, Bathinda, Punjab - 151103',
  },
  {
    Number: 'PB-52',
    City: 'Bassi Pathana Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-69',
    City: 'Bagha Purana Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-86',
    City: 'Dirba Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-58',
    City: 'Dera Baba Nanak Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-09',
    City: 'Kapurthala',
    State: 'Punjab',
    Phone: '+91-1822-233749',
    Email: '-',
    Address: 'Kapurthala, Punjab - 144601',
  },
  {
    Number: 'PB-22',
    City: 'Fazilka',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Fazilka, Firozpur, Punjab - 152123',
  },
  {
    Number: 'PB-85',
    City: 'Kalanaur Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-07',
    City: 'Hoshiarpur',
    State: 'Punjab',
    Phone: '+91-1882-220311',
    Email: '-',
    Address: 'Hoshiarpur, Punjab - 146001',
  },
  {
    Number: 'PB-08',
    City: 'Jalandhar',
    State: 'Punjab',
    Phone: '+91-181-2224278',
    Email: '-',
    Address: 'Jalandhar, Punjab - 144001',
  },
  {
    Number: 'PB-77',
    City: 'Guru Har Sahai Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-26',
    City: 'Khanna',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Khanna, Ludhiana, Punjab - 141401',
  },
  {
    Number: 'PB-36',
    City: 'Phagwara',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Phagwara, Kapurhala, Punjab - 144401',
  },
  {
    Number: 'PB-90',
    City: 'Jalandhar11 Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-54',
    City: 'Mukerian Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-38',
    City: 'Patti Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-14',
    City: 'Ajnala Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-48',
    City: 'Amloh Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-88',
    City: 'Bhikhiwind Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-24',
    City: 'Garhshankar',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Garhshankar, Hoshiarpur, Punjab - 144527',
  },
  {
    Number: 'PB-12',
    City: 'Ropar Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-59',
    City: 'Dhuri Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-02',
    City: 'Amritsar',
    State: 'Punjab',
    Phone: '+91-183-2565244',
    Email: '-',
    Address: 'Amritsar, Punjab - 143001',
  },
  {
    Number: 'PB-64',
    City: 'Moonak',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Moonak, Sangrur, Punjab - 148033',
  },
  {
    Number: 'PB-87',
    City: 'Morinda Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-39',
    City: 'Rajpura Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-74',
    City: 'Nangal Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-34',
    City: 'Nabha Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-67',
    City: 'Shahkot Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-49',
    City: 'Khamano',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Khamanon, Punjab - 141801',
  },
  {
    Number: 'PB-80',
    City: 'Maur Mandi Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-16',
    City: 'Anandpur Sahib',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Anandpur Sahib, Rupnagar, Punjab - 140118',
  },
  {
    Number: 'PB-42',
    City: 'Samana Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-75',
    City: 'Lehra',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Lehra, Ludhiana, Punjab - 148031',
  },
  {
    Number: 'PB-05',
    City: 'Ferozepur',
    State: 'Punjab',
    Phone: '+91-1632-245118',
    Email: '-',
    Address: 'Ferozepur, Punjab - 152002',
  },
  {
    Number: 'PB-73',
    City: 'Tapa Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-56',
    City: 'Raikot Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-10',
    City: 'Ludhiana',
    State: 'Punjab',
    Phone: '+91-161-2401002',
    Email: '-',
    Address: 'Ludhiana, Punjab - 141001',
  },
  {
    Number: 'PB-33',
    City: 'Nakodar Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-60',
    City: 'Gidderbaha',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Gidderbaha, Muktsar, Punjab - 152101',
  },
  {
    Number: 'PB-62',
    City: 'Jaito Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-19',
    City: 'Barnala',
    State: 'Punjab',
    Phone: '+91-1679-234388',
    Email: '-',
    Address: 'Barnala, Ludhiana, Punjab - 148105',
  },
  {
    Number: 'PB-27',
    City: 'Kharar Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-46',
    City: 'Tarn Taran',
    State: 'Punjab',
    Phone: '+91-1852-225737',
    Email: '-',
    Address: 'Tarn Taran, Amritsar, Punjab - 143401',
  },
  {
    Number: 'PB-20',
    City: 'Balachaur',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Balachaur, Nawanshahr, Punjab - 144521',
  },
  {
    Number: 'PB-51',
    City: 'Sardulgarh Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-50',
    City: 'Budhlada Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-47',
    City: 'Zira Sdm',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Punjab',
  },
  {
    Number: 'PB-30',
    City: 'Muktsar',
    State: 'Punjab',
    Phone: '+91-1633-261468',
    Email: '-',
    Address: 'Muktsar, Punjab - 152026',
  },
  {
    Number: 'PB-35',
    City: 'Pathankot',
    State: 'Punjab',
    Phone: '-',
    Email: '-',
    Address: 'Pathankot, Gurdaspur, Punjab - 145001',
  },
  // Rajasthan
  {
    Number: 'RJ-25',
    City: 'Sawai Madhopur',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Sawai Madhopur, Rajasthan - 322001',
  },
  {},
  {
    Number: 'RJ-38',
    City: 'Abu Road (Sirohi)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Abu Road, Sirohi, Rajasthan - 307026',
  },
  {
    Number: 'RJ-01',
    City: 'Ajmer',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Ajmer, Rajasthan - 305001',
  },
  {
    Number: 'RJ-22',
    City: 'Pali',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Pali, Rajasthan - 306401',
  },
  {
    Number: 'RJ-40',
    City: 'Bhiwadi (Alwar)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Bhiwadi, Alwar, Rajasthan - 301019',
  },
  {
    Number: 'RJ-36',
    City: 'Beawar',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Beawar, Ajmer, Rajasthan - 305901',
  },
  {
    Number: 'RJ-04',
    City: 'Barmer',
    State: 'Rajasthan',
    Phone: '+91-2982-220615',
    Email: '-',
    Address: 'Barmer, Rajasthan - 344001',
  },
  {
    Number: 'RJ-28',
    City: 'Baran',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Baran, Rajasthan - 325215',
  },
  {
    Number: 'RJ-16',
    City: 'Jalore',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Jalore, Rajasthan - 343001',
  },
  {
    Number: 'RJ-35',
    City: 'Pratapgarh',
    State: 'Rajasthan',
    Phone: '01478 - 222530',
    Email: '-',
    Address: 'Dhariyawad Road, Pratapgarh - 312605',
  },
  {
    Number: 'RJ-49',
    City: 'Nohar (Hanumangrah)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Nohar, Hanumangarh, Rajasthan - 335504',
  },
  {
    Number: 'RJ-48',
    City: 'Kekri',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'District Transport Office, Ajmer Road, Kekri, Ajmer',
  },
  {
    Number: 'RJ-32',
    City: 'Kotputli',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Kotputli, Jaipur, Rajasthan - 303108',
  },
  {
    Number: 'RJ-53',
    City: 'Khetri Dto',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Rajasthan',
  },
  {
    Number: 'RJ-20',
    City: 'Kota',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Kota, Rajasthan - 324001',
  },
  {
    Number: 'RJ-13',
    City: 'Sri Ganganagar',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Sri Ganganagar, Rajasthan - 335001',
  },
  {
    Number: 'RJ-27',
    City: 'Udaipur',
    State: 'Rajasthan',
    Phone: '+91-294-2471522',
    Email: '-',
    Address: 'Udaipur, Rajasthan - 313001',
  },
  {
    Number: 'RJ-30',
    City: 'Rajsamand',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Rajsamand, Rajasthan - 313301',
  },
  {
    Number: 'RJ-29',
    City: 'Dausa',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Dausa, Rajasthan - 303303',
  },
  {
    Number: 'RJ-50',
    City: 'Nokha (Bikaner)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Nokha, Bikaner, Rajasthan - 334803',
  },
  {
    Number: 'RJ-15',
    City: 'Jaisalmer',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Jaisalmer, Rajasthan - 345001',
  },
  {
    Number: 'RJ-44',
    City: 'Sujangarh Dto',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Rajasthan',
  },
  {
    Number: 'RJ-34',
    City: 'Karoli',
    State: 'Rajasthan',
    Phone: '07464 - 251020',
    Email: '-',
    Address: 'Mandraial Road, Karoli - 332241',
  },
  {
    Number: 'RJ-02',
    City: 'Alwar',
    State: 'Rajasthan',
    Phone: '+91-144-2731335',
    Email: '-',
    Address: 'Alwar, Rajasthan - 301001',
  },
  {
    Number: 'RJ-24',
    City: 'Sirohi',
    State: 'Rajasthan',
    Phone: '02972 - 221688',
    Email: '-',
    Address: 'Anadara Road, Sirohi - 307001',
  },
  {
    Number: 'RJ-23',
    City: 'Sikar',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Sikar, Rajasthan - 332001',
  },
  {
    Number: 'RJ-52',
    City: 'Shahpura (Jaipur)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Shahpura, Jaipur, Rajasthan - 303103',
  },
  {
    Number: 'RJ-41',
    City: 'Chomu (Jaipur)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Chomu, Jaipur, Rajasthan - 303702',
  },
  {
    Number: 'RJ-19',
    City: 'Jodhpur',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Jodhpur, Rajasthan - 342001',
  },
  {
    Number: 'RJ-17',
    City: 'Jhalawar',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Jhalawar, Rajasthan - 326001',
  },
  {
    Number: 'RJ-12',
    City: 'Dungarpur',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Dungarpur, Rajasthan - 314001',
  },
  {
    Number: 'RJ-11',
    City: 'Dholpur',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Dholpur, Rajasthan - 328001',
  },
  {
    Number: 'RJ-07',
    City: 'Bikaner',
    State: 'Rajasthan',
    Phone: '+91-151-2226981 / 2226983',
    Email: '-',
    Address: 'Bikaner, Rajasthan - 334001',
  },
  {
    Number: 'RJ-14',
    City: 'Jaipur South',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Jaipur, Rajasthan - 302001',
  },
  {
    Number: 'RJ-06',
    City: 'Bhilwara',
    State: 'Rajasthan',
    Phone: '+91-1482-226427',
    Email: '-',
    Address: 'Bhilwara, Rajasthan - 311001',
  },
  {
    Number: 'RJ-45',
    City: 'Jaipur',
    State: 'Rajasthan',
    Phone: '+91-141-2740021 / 2740023',
    Email: '[email protected]',
    Address: 'Parivahan Bhawan, Sahkar Marg, Jaipur, Rajasthan - 302005',
  },
  {
    Number: 'RJ-51',
    City: 'Shahpura (Bhilwara)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Shahpura, Bhilwara, Rajasthan - 311404',
  },
  {
    Number: 'RJ-37',
    City: 'Didwana (Nagaur)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Didwana, Nagaur, Rajasthan - 341303',
  },
  {
    Number: 'RJ-31',
    City: 'Hanumangarh',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Hanumangarh, Rajasthan - 335512',
  },
  {
    Number: 'RJ-43',
    City: 'Phalodi',
    State: 'Rajasthan',
    Phone: '02925 - 222020',
    Email: '-',
    Address: 'District Transport Office, Phalodi IGNP Campus, Phalodi, Dt. Jodhpur - 342301',
  },
  {
    Number: 'RJ-33',
    City: 'Ramganj Mandi (Kota)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Ramganj Mandi, Kota, Rajasthan - 326519',
  },
  {
    Number: 'RJ-39',
    City: 'Balotra (Barmer)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Balotra, Barmer, Rajasthan - 344022',
  },
  {
    Number: 'RJ-47',
    City: 'Dudu (Jaipur)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Dudu, Jaipur, Rajasthan - 303008',
  },
  {
    Number: 'RJ-08',
    City: 'Bundi',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Bundi, Rajasthan - 323001',
  },
  {
    Number: 'RJ-21',
    City: 'Nagaur',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Nagaur, Rajasthan - 341001',
  },
  {
    Number: 'RJ-46',
    City: 'Bhinmal Dto',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Rajasthan',
  },
  {
    Number: 'RJ-42',
    City: 'Kishangarh (Ajmer)',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Kishangarh, Ajmer, Rajasthan - 305801',
  },
  {
    Number: 'RJ-03',
    City: 'Banswara',
    State: 'Rajasthan',
    Phone: '+91-2962-242440',
    Email: '-',
    Address: 'Gandhi Nagar, GPO Circle, Banswara, Rajasthan - 327001',
  },
  {
    Number: 'RJ-10',
    City: 'Churu',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Churu, Rajasthan - 331001',
  },
  {
    Number: 'RJ-05',
    City: 'Bharatpur',
    State: 'Rajasthan',
    Phone: '+91-3484-222511',
    Email: '-',
    Address: 'Bharatpur, Rajasthan - 321203',
  },
  {
    Number: 'RJ-09',
    City: 'Chittaurgarh',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Chittaurgarh, Rajasthan - 312001',
  },
  {
    Number: 'RJ-18',
    City: 'Jhunjhunu',
    State: 'Rajasthan',
    Phone: '-',
    Email: '-',
    Address: 'Jhunjhunu, Rajasthan - 333001',
  },
  //Sikkim
  {
    Number: 'SK-01',
    City: 'Gangtok',
    State: 'Sikkim',
    Phone: '+91-3592-204234',
    Email: '-',
    Address: 'Yatayat Bhawan, Gangtok, East Sikkim, Sikkim - 737101',
  },
  {
    Number: 'SK-02',
    City: 'Gyalsing',
    State: 'Sikkim',
    Phone: '-',
    Email: '-',
    Address: 'Sikkim',
  },
  {
    Number: 'SK-06',
    City: 'Soreng',
    State: 'Sikkim',
    Phone: '-',
    Email: '-',
    Address: 'Sikkim',
  },
  {
    Number: 'SK-04',
    City: 'Jorethang',
    State: 'Sikkim',
    Phone: '+91-3592-204234',
    Email: '-',
    Address: 'Jorethang, South Sikkim, Sikkim - 737121',
  },
  {
    Number: 'SK-07',
    City: 'Pakyong',
    State: 'Sikkim',
    Phone: '-',
    Email: '-',
    Address: 'Sikkim',
  },
  {
    Number: 'SK-08',
    City: 'Singtam, East Sikkim',
    State: 'Sikkim',
    Phone: '-',
    Email: '-',
    Address: 'Sikkim',
  },
  {
    Number: 'SK-05',
    City: 'Namchi',
    State: 'Sikkim',
    Phone: '-',
    Email: '-',
    Address: 'Sikkim',
  },
  // Tamil nadu
  {
    Number: 'TN-12',
    City: 'Poonamalee',
    State: 'Tamil Nadu',
    Phone: '+91-44-26495595',
    Email: '[email protected]',
    Address: 'Bye Pass Road, Poonamallee, Chennai - 600056',
  },
  {
    Number: 'TN-30',
    City: 'Salem West',
    State: 'Tamil Nadu',
    Phone: '+91-427-2225588',
    Email: '[email protected]',
    Address: 'Kondalampatty Bye-Pass, Salem - 636007',
  },
  {
    Number: 'TN-76V',
    City: 'AMBASAMUDRAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'AMBASAMUDRAM, Tamilnadu',
  },
  {
    Number: 'TN-36W',
    City: 'Bhavani',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'Bhavani, Tamilnadu',
  },
  {
    Number: 'TN-01',
    City: 'Chennai Central',
    State: 'Tamil Nadu',
    Phone: '+91-44-26445767 / 26745959',
    Email: '[email protected]',
    Address: 'Anderson Road, Ayanavaram, Chennai - 600023',
  },
  {
    Number: 'TN-55Z',
    City: 'ARANTHANGI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'ARANTHANGI, Tamilnadu',
  },
  {
    Number: 'TN-39',
    City: 'Tiruppur North',
    State: 'Tamil Nadu',
    Phone: '+91-421-2473545',
    Email: '[email protected]',
    Address: 'Kumaran Nagar, Thiruppur, Tamil Nadu - 641063',
  },
  {
    Number: 'TN-82',
    City: 'Mayiladuthurai',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Mayiladuthurai, Nagapattinam - 609001',
  },
  {
    Number: 'TN-30W',
    City: 'OMALUR UO',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'OMALUR UO, Tamil Nadu',
  },
  {
    Number: 'TN-49Y',
    City: 'PATTUKOTTAI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'PATTUKOTTAI, Tamilnadu',
  },
  {
    Number: 'TN-58',
    City: 'Madurai South',
    State: 'Tamil Nadu',
    Phone: '+91-452-2381560',
    Email: '[email protected]',
    Address: 'Madurai, Tamil Nadu - 625010',
  },
  {
    Number: 'TN-52',
    City: 'Sankagiri',
    State: 'Tamil Nadu',
    Phone: '+91-4283-242440',
    Email: '[email protected]',
    Address: 'Sankari, Tamil Nadu - 637003',
  },
  {
    Number: 'TN-73Z',
    City: 'ARAKKONAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'ARAKKONAM, Tamilnadu',
  },
  {
    Number: 'TN-93',
    City: 'METTUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'METTUR, Tamilnadu',
  },
  {
    Number: 'TN-28Z',
    City: 'Rasipuram',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'Rasipuram, Tamilnadu',
  },
  {
    Number: 'TN-46',
    City: 'Perambalur',
    State: 'Tamil Nadu',
    Phone: '4328-224415',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Perambalur, Tamil Nadu - 621220',
  },
  {
    Number: 'TN-66',
    City: 'Coimbatore Central',
    State: 'Tamil Nadu',
    Phone: '+91-422-2248449',
    Email: '[email protected]',
    Address: 'Dr. Balasundaram Road, Coimbatore, Tamil Nadu - 641018',
  },
  {
    Number: 'TN-31',
    City: 'Cuddalore',
    State: 'Tamil Nadu',
    Phone: '+91-4142-290035',
    Email: '[email protected]',
    Address: 'SN Chavadi, Cuddalore, Tamil Nadu - 607001',
  },
  {
    Number: 'TN-23T',
    City: 'GUDIYATHAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'GUDIYATHAM, Tamilnadu',
  },
  {
    Number: 'TN-50Z',
    City: 'MANNARGUDI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'MANNARGUDI, Tamilnadu',
  },
  {
    Number: 'TN-27',
    City: 'SALEM DISTRICT',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'SALEM DISTRICT, Tamilnadu',
  },
  {
    Number: 'TN-19Z',
    City: 'MADURANTAKAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'MADURANTAKAM, Tamilnadu',
  },
  {
    Number: 'TN-67W',
    City: 'ARUPPUKOTTAI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'ARUPPUKOTTAI, Tamilnadu',
  },
  {
    Number: 'TN-40',
    City: 'Mettupalayam',
    State: 'Tamil Nadu',
    Phone: '4254-226330',
    Email: '-',
    Address:
      'The Regional Transport Officer ( RTO ), Suthanthirapuram, Karamadai Road, Mettupalayam, Tamil Nadu - 641301',
  },
  {
    Number: 'TN-79',
    City: 'Sankarankovil',
    State: 'Tamil Nadu',
    Phone: '+91-462-2552555',
    Email: '[email protected]',
    Address: 'Sankarankoil, Tirunelveli, Tamil Nadu - 627719',
  },
  {
    Number: 'TN-22',
    City: 'Meenambakkam',
    State: 'Tamil Nadu',
    Phone: '+91-44-22325555 / 22319008',
    Email: '[email protected]',
    Address: 'Alandur, Meenambakkam, Chennai - 600016',
  },
  {
    Number: 'TN-24',
    City: 'Krishnagiri',
    State: 'Tamil Nadu',
    Phone: '4343-231444',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Collectorate Campus, Krishnagiri, Tamil Nadu - 635001',
  },
  {
    Number: 'TN-43Z',
    City: 'GUDALUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'GUDALUR, Tamilnadu',
  },
  {
    Number: 'TN-19',
    City: 'Chengalpattu',
    State: 'Tamil Nadu',
    Phone: '+91-44-27430776',
    Email: '[email protected]',
    Address: 'Anna Nagar, Chengalpattu, Chennai - 603001',
  },
  {
    Number: 'TN-61',
    City: 'Ariyalur',
    State: 'Tamil Nadu',
    Phone: '4329-228004',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Ariyalur Main Road, Ariyalur - 621704',
  },
  {
    Number: 'TN-86',
    City: 'Erode Wes',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Erode West, Tamil Nadu - 638001',
  },
  {
    Number: 'TN-59',
    City: 'Madurai North',
    State: 'Tamil Nadu',
    Phone: '+91-452-2569181',
    Email: '[email protected]',
    Address: 'Melur Road, Madurai - 625007',
  },
  {
    Number: 'TN-13',
    City: 'Ambattur',
    State: 'Tamil Nadu',
    Phone: '+91-44-23450027',
    Email: '[email protected]',
    Address: 'West Park Street, Ambattur, Chennai - 600053',
  },
  {
    Number: 'TN-39Z',
    City: 'AVINASHI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'AVINASHI, Tamilnadu',
  },
  {
    Number: 'TN-07',
    City: 'Chennai South',
    State: 'Tamil Nadu',
    Phone: '+91-44-24450404 / 24457189',
    Email: '[email protected]',
    Address: 'Thiruvalluvar Nagar, East Coast Road, Thiruvanmiyur, Chennai -600041',
  },
  {
    Number: 'TN-05',
    City: 'Chennai North',
    State: 'Tamil Nadu',
    Phone: '+91-44-26732525',
    Email: '[email protected]',
    Address: 'MKB Nagar, Vysarbadi, Chennai - 600012',
  },
  {
    Number: 'TN-09',
    City: 'Chennai West',
    State: 'Tamil Nadu',
    Phone: '+91-44-24894466 / 24898240',
    Email: '[email protected]',
    Address: 'Mambalam Taluk Office Complex, KK Nagar, Chennai - 600078',
  },
  {
    Number: 'TN-25Z',
    City: 'ARANI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'ARANI, Tamilnadu',
  },
  {
    Number: 'TN-56',
    City: 'Perundurai',
    State: 'Tamil Nadu',
    Phone: '4294-222779',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Bhavani Road, Perundurai, Erode - 638052',
  },
  {
    Number: 'TN-15',
    City: 'Ulundurpet',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Ulundurpet, Villupuram, Tamil Nadu - 606107',
  },
  {
    Number: 'TN-18',
    City: 'Red Hills',
    State: 'Tamil Nadu',
    Phone: '+91-44-26310636',
    Email: '[email protected]',
    Address: 'Chamundi Complex, GNT Road, Redhills, Chennai - 600052',
  },
  {
    Number: 'TN-47',
    City: 'Karur',
    State: 'Tamil Nadu',
    Phone: '+91-4324-234699',
    Email: '[email protected]',
    Address: 'PLA Building, Karur, Tamil Nadu - 639002',
  },
  {
    Number: 'TN-02',
    City: 'Chennai North West',
    State: 'Tamil Nadu',
    Phone: '+91-44-26215969',
    Email: '[email protected]',
    Address: 'New Avadi Road, Anna Nagar East, Chennai - 600102',
  },
  {
    Number: 'TN-99',
    City: 'Coimbatore West',
    State: 'Tamil Nadu',
    Phone: '+91-422-2646677',
    Email: '[email protected]',
    Address: 'Coimbatore, Tamil Nadu',
  },
  {
    Number: 'TN-48Y',
    City: 'MUSIRI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'MUSIRI, Tamilnadu',
  },
  {
    Number: 'TN-85',
    City: 'Kunnathur',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Kunnathur, Kanchipuram, Chennai - 600069',
  },
  {
    Number: 'TN-21',
    City: 'Kanchipuram',
    State: 'Tamil Nadu',
    Phone: '+91-44-27264277',
    Email: '[email protected]',
    Address: 'Karapettai, Kanchipuram, Chennai - 631552',
  },
  {
    Number: 'TN-91Y',
    City: 'NEYVELI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'NEYVELI, Tamilnadu',
  },
  {
    Number: 'TN-70',
    City: 'Hosur',
    State: 'Tamil Nadu',
    Phone: '+91-4344-262255',
    Email: '[email protected]',
    Address: 'HCF Post, Hosur, Tamil Nadu - 635126',
  },
  {
    Number: 'TN-03',
    City: 'Chennai North East',
    State: 'Tamil Nadu',
    Phone: '+91-44-25914849 / 25911133',
    Email: '[email protected]',
    Address: 'Balakrishna Street, Thiruvetriyur High Road, Tondiarpet, Chennai -600081',
  },
  {
    Number: 'TN-83',
    City: 'Vaniyambadi',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Vaniyambadi, Vellore, Tamil Nadu - 635753',
  },
  {
    Number: 'TN-60',
    City: 'Theni',
    State: 'Tamil Nadu',
    Phone: '+91-4546-231565',
    Email: '[email protected]',
    Address: 'Periyakulam, Theni, Tamil Nadu - 625693',
  },
  {
    Number: 'TN-43',
    City: 'Ooty',
    State: 'Tamil Nadu',
    Phone: '+91-423-2443950',
    Email: '[email protected]',
    Address: 'Coonoor Road, Ooty, Tamil Nadu - 643001',
  },
  {
    Number: 'TN-32',
    City: 'Villupuram',
    State: 'Tamil Nadu',
    Phone: '4146-223626',
    Email: '-',
    Address: "The Regional Transport Officer ( RTO ), Opp. Collector's Office, Villupuram, Tamil Nadu - 605602",
  },
  {
    Number: 'TN-73',
    City: 'Ranipet',
    State: 'Tamil Nadu',
    Phone: '+91-4172-273087',
    Email: '[email protected]',
    Address: 'Barathi Nagar, Ranipet, Tamil Nadu - 632403',
  },
  {
    Number: 'TN-75',
    City: 'Marthandam',
    State: 'Tamil Nadu',
    Phone: '+91-4651-274977',
    Email: '[email protected]',
    Address: 'Vallee vilagam, Vilavancode, Kanyakumari - 629165',
  },
  {
    Number: 'TN-72',
    City: 'Tirunelveli',
    State: 'Tamil Nadu',
    Phone: '+91-462-2552555',
    Email: '[email protected]',
    Address: 'Tirunelveli, Tamil Nadu - 627007',
  },
  {
    Number: 'TN-04',
    City: 'Chennai East',
    State: 'Tamil Nadu',
    Phone: '44-26670663',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Power Mills Road, Pulianthoppu, Chennai - 600012',
  },
  {
    Number: 'TN-38',
    City: 'Coimbatore North',
    State: 'Tamil Nadu',
    Phone: '+91-422-2646677',
    Email: '[email protected]',
    Address: 'Near CTC Colony, Thudiyalur, Coimbatore, Tamil Nadu - 641018',
  },
  {
    Number: 'TN-54',
    City: 'Salem East',
    State: 'Tamil Nadu',
    Phone: '+91-427-2465346',
    Email: '[email protected]',
    Address: 'Sellanaickenpatty, Salem, Tamil Nadu - 636201',
  },
  {
    Number: 'TN-69',
    City: 'Tuticorin',
    State: 'Tamil Nadu',
    Phone: '+91-461-2341020',
    Email: '[email protected]',
    Address: 'Tuticorin, Tamil Nadu - 628003',
  },
  {
    Number: 'TN-25',
    City: 'Thiruvannamalai',
    State: 'Tamil Nadu',
    Phone: '+91-4175-232266',
    Email: '[email protected]',
    Address: 'Anna Salai, Thiruvannamalai, Chennai - 606601',
  },
  {
    Number: 'TN-06',
    City: 'Chennai South East',
    State: 'Tamil Nadu',
    Phone: '44-24610405',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Mandaveli, Chennai - 600028',
  },
  {
    Number: 'TN-45',
    City: 'Tiruchirapalli West',
    State: 'Tamil Nadu',
    Phone: '+91-431-2422175',
    Email: '[email protected]',
    Address: 'Mannarpuram, Trichy, Tamil Nadu - 620020',
  },
  {
    Number: 'TN-87',
    City: 'SRIPERUMBUDUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'SRIPERUMBUDUR, Tamilnadu',
  },
  {
    Number: 'TN-23',
    City: 'Vellore',
    State: 'Tamil Nadu',
    Phone: '+91-416-2252040',
    Email: '[email protected]',
    Address: 'Sathuvacherry, Vellore, Tamil Nadu - 632009',
  },
  {
    Number: 'TN-81',
    City: 'Tiruchirapalli East',
    State: 'Tamil Nadu',
    Phone: '+91-431-2403333',
    Email: '[email protected]',
    Address: 'Trichy Dindigul Main Road, Trichy - 620009',
  },
  {
    Number: 'TN-583',
    City: 'TIRUVERANBUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'TIRUVERANBUR, Tamilnadu',
  },
  {
    Number: 'TN-63',
    City: 'Sivagangai',
    State: 'Tamil Nadu',
    Phone: '+91-4575-240339',
    Email: '[email protected]',
    Address: 'Sivagangai, Tamil Nadu - 630560',
  },
  {
    Number: 'TN-48',
    City: 'Srirangam',
    State: 'Tamil Nadu',
    Phone: '+91-',
    Email: '[email protected]',
    Address: 'Thiruvanaikoil, Tiruchirappalli, Tamil Nadu - 620006',
  },
  {
    Number: 'TN-36Z',
    City: 'SATHYAMANGALAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'SATHYAMANGALAM, Tamilnadu',
  },
  {
    Number: 'TN-16Z',
    City: 'GINGEE UO',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'GINGEE UO, Tamilnadu',
  },
  {
    Number: 'TN-20',
    City: 'Tiruvallur',
    State: 'Tamil Nadu',
    Phone: '+91-44-27663333',
    Email: '[email protected]',
    Address: 'JN Road, Collectorate Complex Annex, Thiruvallur, Chennai - 602 001',
  },
  {
    Number: 'TN-78Z',
    City: 'UDUMALPET',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'UDUMALPET, Tamilnadu',
  },
  {
    Number: 'TN-48X',
    City: 'UO LALGUDI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'LALGUDI, Tamil Nadu',
  },
  {
    Number: 'TN-59V',
    City: 'Vadipatti',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'Vadipatti, Tamilnadu',
  },
  {
    Number: 'TN-51',
    City: 'Nagapattinam',
    State: 'Tamil Nadu',
    Phone: '+91-4365-249477',
    Email: '[email protected]',
    Address: 'Kadambadi, Nagapattinam, Tamil Nadu - 611106',
  },
  {
    Number: 'TN-50',
    City: 'Tiruvarur',
    State: 'Tamil Nadu',
    Phone: '+91-4366-221261',
    Email: '[email protected]',
    Address: 'Collectorate Building, Thiruvarur, Tamil Nadu - 610002',
  },
  {
    Number: 'TN-42',
    City: 'Tiruppur South',
    State: 'Tamil Nadu',
    Phone: '+91-421-2215151',
    Email: '[email protected]',
    Address: 'Thiruppur, Tamil Nadu - 641063',
  },
  {
    Number: 'TN-67',
    City: 'Virudhunagar',
    State: 'Tamil Nadu',
    Phone: '+91-4562-252089',
    Email: '[email protected]',
    Address: 'Virudhunagar, Tamil Nadu - 626003',
  },
  {
    Number: 'TN-72V',
    City: 'VALLIYUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'VALLIYUR, Tamilnadu',
  },
  {
    Number: 'TN-76',
    City: 'Tenkasi',
    State: 'Tamil Nadu',
    Phone: '+91-4633-280149',
    Email: '[email protected]',
    Address: 'Killpalayam, Tenkasi, Tirunelveli - 627811',
  },
  {
    Number: 'TN-96',
    City: 'KOVILPATTI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'KOVILPATTI, Tamilnadu',
  },
  {
    Number: 'TN-83Z',
    City: 'TIRUPATTUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'TIRUPATTUR, Tamilnadu',
  },
  {
    Number: 'TN-28',
    City: 'Namakkal North',
    State: 'Tamil Nadu',
    Phone: '+91-4286-280885',
    Email: '[email protected]',
    Address: 'Tiruchengodu Road, Namakkal, Tamil Nadu - 637003',
  },
  {
    Number: 'TN-88Z',
    City: 'PARAMATHI VELUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'PARAMATHI VELUR, Tamilnadu',
  },
  {
    Number: 'TN-49',
    City: 'Thanjavur',
    State: 'Tamil Nadu',
    Phone: '4362-227358',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Pillaiyurpatty Post, Thanjavur, Tamil Nadu - 613403',
  },
  {
    Number: 'TN-18Y',
    City: 'GUMIDIPOONDI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'GUMIDIPOONDI, Tamil Nadu',
  },
  {
    Number: 'TN-20X',
    City: 'TIRUTANNI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'TIRUTANNI, Tamilnadu',
  },
  {
    Number: 'TN-37Z',
    City: 'Sulur',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'Sulur, Tamil Nadu',
  },
  {
    Number: 'TN-19Y',
    City: 'Thirukazhukundram',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'Thirukazhukundram, Tamilnadu',
  },
  {
    Number: 'TN-34',
    City: 'Thiruchengode',
    State: 'Tamil Nadu',
    Phone: '+91-4288-282322',
    Email: '[email protected]',
    Address: 'Varagambatty, Thiruchengode, Erode, Tamil Nadu - 637211',
  },
  {
    Number: 'TN-48Z',
    City: 'THURAIYUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'THURAIYUR, Tamil Nadu',
  },
  {
    Number: 'TN-11',
    City: 'Tambaram',
    State: 'Tamil Nadu',
    Phone: '+91-44-22267666',
    Email: '[email protected]',
    Address: 'Tambaram, Chennai - 600045',
  },
  {
    Number: 'TN-94',
    City: 'PALANI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'PALANI, Tamilnadu',
  },
  {
    Number: 'TN-88',
    City: 'Namakkal South',
    State: 'Tamil Nadu',
    Phone: '+91-4286-280885',
    Email: '[email protected]',
    Address: 'Namakkal South,Tamil Nadu - 637003',
  },
  {
    Number: 'TN-55Y',
    City: 'ILLUPPUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'ILLUPPUR, Tamilnadu',
  },
  {
    Number: 'TN-78',
    City: 'Dharapuram',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Dharapuram, Erode - 638656',
  },
  {
    Number: 'TN-29',
    City: 'Dharmapuri',
    State: 'Tamil Nadu',
    Phone: '+91-4342-230907',
    Email: '[email protected]',
    Address: 'Dharmapuri, Tamil Nadu - 636705',
  },
  {
    Number: 'TN-10',
    City: 'Chennai South West',
    State: 'Tamil Nadu',
    Phone: '+91-44-24797722',
    Email: '[email protected]',
    Address: 'Sai Nagar, Virugambakkam, Chennai - 600092',
  },
  {
    Number: 'TN-92',
    City: 'THIRUCHENDUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'THIRUCHENDUR, Tamilnadu',
  },
  {
    Number: 'TN-77',
    City: 'Attur',
    State: 'Tamil Nadu',
    Phone: '4282-251616',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Therkku Nagar, Attur, Salem - 636102',
  },
  {
    Number: 'TN-15Z',
    City: 'KALLAKURICHI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'KALLAKURICHI, Tamilnadu',
  },
  {
    Number: 'TN-63Z',
    City: 'KARAIKUDI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'KARAIKUDI, Tamilnadu',
  },
  {
    Number: 'TN-57',
    City: 'Dindigul',
    State: 'Tamil Nadu',
    Phone: '+91-451-2460223',
    Email: '[email protected]',
    Address: 'Dindigul, Tamil Nadu - 624004',
  },
  {
    Number: 'TN-83Y',
    City: 'AMBUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'AMBUR, Tamilnadu',
  },
  {
    Number: 'TN-84',
    City: 'Srivilliputhur',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '[email protected]',
    Address: 'Srivilliputhur, Virudhunagar, Tamil Nadu - 626125',
  },
  {
    Number: 'TN-25Y',
    City: 'CHEYYAR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'CHEYYAR, Tamilnadu',
  },
  {
    Number: 'TN-60Z',
    City: 'UTHAMAPALAYAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'UTHAMAPALAYAM, Tamilnadu',
  },
  {
    Number: 'TN-33',
    City: 'Erode',
    State: 'Tamil Nadu',
    Phone: '+91-424-2402611',
    Email: '[email protected]',
    Address: 'Lakkapuram Post, Erode, Tamil Nadu - 638002',
  },
  {
    Number: 'TN-74',
    City: 'Nagercoil',
    State: 'Tamil Nadu',
    Phone: '+91-4652-265056',
    Email: '[email protected]',
    Address: 'Pattasalianvilai, Nagercoil, Tamil Nadu - 629001',
  },
  {
    Number: 'TN-97Z',
    City: 'UO Cheyyar',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'UO Cheyyar, Tamil Nadu',
  },
  {
    Number: 'TN-29W',
    City: 'PALACODE',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'PALACODE, Tamilnadu',
  },
  {
    Number: 'TN-95',
    City: 'SIVAKASI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'SIVAKASI, Tamilnadu',
  },
  {
    Number: 'TN-14',
    City: 'Sholinganallur',
    State: 'Tamil Nadu',
    Phone: '+91-44-24503939',
    Email: '[email protected]',
    Address: 'Old Mahabalipuram Road, Sholinganallur, Chennai - 600119',
  },
  {
    Number: 'TN-68',
    City: 'Kumbakonam',
    State: 'Tamil Nadu',
    Phone: '+91-435-2412412',
    Email: '[email protected]',
    Address: 'Arokiasamy Nagar, Kumbakonam, Thanjavur - 612001',
  },
  {
    Number: 'TN-36',
    City: 'Gobichettipalayam',
    State: 'Tamil Nadu',
    Phone: '4285-222922',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Pudupalayam, Gobichettipalayam, Erode, Tamil Nadu - 638476',
  },
  {
    Number: 'TN-65Z',
    City: 'PARAMAKUDI',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'PARAMAKUDI, Tamilnadu',
  },
  {
    Number: 'TN-55',
    City: 'Pudukottai',
    State: 'Tamil Nadu',
    Phone: '4322-221618',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Pudukottai, Tamil Nadu - 622001',
  },
  {
    Number: 'TN-58Z',
    City: 'THIRUMANGALAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'THIRUMANGALAM, Tamilnadu',
  },
  {
    Number: 'TN-42Y',
    City: 'SULUR',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'SULUR, Tamilnadu',
  },
  {
    Number: 'TN-41',
    City: 'Pollachi',
    State: 'Tamil Nadu',
    Phone: '+91-4259-225159',
    Email: '[email protected]',
    Address: 'Venkatesa Colony, Pollachi, Tamil Nadu - 642002',
  },
  {
    Number: 'TN-16',
    City: 'Tindivanam',
    State: 'Tamil Nadu',
    Phone: '4147-222098',
    Email: '-',
    Address: 'The Regional Transport Officer ( RTO ), Tindivanam, Villupuram, Tamil Nadu - 604001',
  },
  {
    Number: 'TN-64',
    City: 'Madurai Central',
    State: 'Tamil Nadu',
    Phone: '+91-452-2567835',
    Email: '[email protected]',
    Address: 'Melur Road, Madurai - 625000',
  },
  {
    Number: 'TN-37',
    City: 'Coimbatore South',
    State: 'Tamil Nadu',
    Phone: '+91-422-2562288 / 2564477',
    Email: '[email protected]',
    Address: 'Peelamedu, Coimbatore, Tamil Nadu - 641018',
  },
  {
    Number: 'TN-65',
    City: 'Ramanathapuram',
    State: 'Tamil Nadu',
    Phone: '+91-4567-230722',
    Email: '[email protected]',
    Address: 'Near Customs Office, Ramanathapuram, Tamil Nadu - 623503',
  },
  {
    Number: 'TN-90',
    City: 'Salem South',
    State: 'Tamil Nadu',
    Phone: '+91-427-2225588',
    Email: '[email protected]',
    Address: 'Salem, Tamil Nadu',
  },
  {
    Number: 'TN-91Z',
    City: 'VIRUDHACHALAM',
    State: 'Tamil Nadu',
    Phone: '-',
    Email: '-',
    Address: 'VIRUDHACHALAM, Tamilnadu',
  },
  // Telangana
  {
    Number: 'TS-01',
    City: 'Adilabad',
    State: 'Telangana',
    Phone: '+91-8732-226562',
    Email: '-',
    Address: 'Adilabad, Telangana - 504106',
  },
  {
    Number: 'TS-11',
    City: 'Hyderabad East',
    State: 'Telangana',
    Phone: '+91-40-23311269',
    Email: '-',
    Address: 'Malakpet, Hyderabad, Telangana - 500036',
  },
  {
    Number: 'TS-09',
    City: 'Hyderabad Central',
    State: 'Telangana',
    Phone: '+91-40-23311269',
    Email: '-',
    Address: 'Khairatabad, Hyderabad, Telangana - 500004',
  },
  {
    Number: 'TS-20',
    City: 'Komaram Bheem Asifabad',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Komaram Bheem Asifabad, Telangana - 504293',
  },
  {
    Number: 'TS-25',
    City: 'Jayashankar Bhupalpally',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Jayashankar Bhupalpally, Telangana - 506169',
  },
  {
    Number: 'TS-17',
    City: 'Kamareddy',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Kamareddy, Telangana - 503111',
  },
  {
    Number: 'TS-07',
    City: 'Ranga Reddy',
    State: 'Telangana',
    Phone: '+91-8413-23393051',
    Email: '-',
    Address: 'Ranga Reddy, Telangana - 500074',
  },
  {
    Number: 'TS-121',
    City: 'UNIT OFFICE KORUTLA',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE KORUTLA, Telangana',
  },
  {
    Number: 'TS-21',
    City: 'Jagtial',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Jagtial, Telangana - 505327',
  },
  {
    Number: 'TS-06',
    City: 'Mahbubnagar',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Mahbubnagar, Telangana - 509125',
  },
  {
    Number: 'TS-32',
    City: 'Wanarpathy',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Wanarpathy, Telangana - 509103',
  },
  {
    Number: 'TS-02',
    City: 'Karimnagar',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Karimnagar, Telangana - 505001',
  },
  {
    Number: 'TS-04',
    City: 'Khammam',
    State: 'Telangana',
    Phone: '+91-8742-228534',
    Email: '-',
    Address: 'Khammam,Telangana - 507001',
  },
  {
    Number: 'TS-10',
    City: 'Hyderabad North',
    State: 'Telangana',
    Phone: '+91-40-23311269',
    Email: '-',
    Address: 'Secunderabad, Hyderabad, Telangana - 500003',
  },
  {
    Number: 'TS-208',
    City: 'KUKATPALLY',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'KUKATPALLY, Telangana',
  },
  {
    Number: 'TS-107',
    City: 'IBRAHIMPATNAM',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'IBRAHIMPATNAM, Telangana',
  },
  {
    Number: 'TS-122',
    City: 'UNIT OFFICE RAMAGUNDAM',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE RAMAGUNDAM, Telangana',
  },
  {
    Number: 'TS-26',
    City: 'Mahabubabad',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Mahabubabad, Telangana - 506101',
  },
  {
    Number: 'TS-12',
    City: 'Hyderabad South',
    State: 'Telangana',
    Phone: '+91-40-23311269',
    Email: '-',
    Address: 'Kisanbagh, Hyderabad, Telangana - 500064',
  },
  {
    Number: 'TS-132',
    City: 'PEBBAIR',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'PEBBAIR, Telangana',
  },
  {
    Number: 'TS-13',
    City: 'Hyderabad West',
    State: 'Telangana',
    Phone: '+91-40-23311269',
    Email: '-',
    Address: 'Tolichowki, Hyderabad, Telangana - 500008',
  },
  {
    Number: 'TS-14',
    City: 'HYDERABAD',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'HYDERABAD, Telangana',
  },
  {
    Number: 'TS-33',
    City: 'Jogulamba Gadwal',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Jogulamba Gadwal, Telangana - 509125',
  },
  {
    Number: 'TS-128',
    City: 'UNIT OFFICE BHADRACHALAM',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE BHADRACHALAM, Telangana',
  },
  {
    Number: 'TS-18',
    City: 'Nirmal',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Nirmal, Telangana - 504106',
  },
  {
    Number: 'TS-27',
    City: 'Jangaon',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Jangaon, Telangana - 506167',
  },
  {
    Number: 'TS-415',
    City: 'PATANCHERUVU',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'PATANCHERUVU, Telangana',
  },
  {
    Number: 'TS-207',
    City: 'UNIT OFFICE SHADNAGAR',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE SHADNAGAR, Telangana',
  },
  {
    Number: 'TS-31',
    City: 'Nagarkurnool',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Nagarkurnool, Telangana - 509209',
  },
  {
    Number: 'TS-305',
    City: 'MIRYALAGUDA',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'MIRYALAGUDA, Telangana',
  },
  {
    Number: 'TS-34',
    City: 'Vikarabad',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Vikarabad, Telangana - 501101',
  },
  {
    Number: 'TS-19',
    City: 'Mancherial',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Mancherial, Telangana - 504208',
  },
  {
    Number: 'TS-215',
    City: 'UNIT OFFICE ZAHIRABAD',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE ZAHIRABAD, Telangana',
  },
  {
    Number: 'TS-35',
    City: 'Medak',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Medak, Telangana - 502110',
  },
  {
    Number: 'TS-03',
    City: 'Warangal',
    State: 'Telangana',
    Phone: '+91-8712-277972',
    Email: '-',
    Address: 'Adilabad, Telangana - 506003',
  },
  {
    Number: 'TS-15',
    City: 'Medak',
    State: 'Telangana',
    Phone: '+91-8455-256453',
    Email: '-',
    Address: 'Medak, Telangana - 502291',
  },
  {
    Number: 'TS-23',
    City: 'Sircilla',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Sircilla, Telangana - 505301',
  },
  {
    Number: 'TS-102',
    City: 'UNIT OFFICE HUZURABAD',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE HUZURABAD, Telangana',
  },
  {
    Number: 'TS-24',
    City: 'Warangal Rural',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Warangal Rural, Telangana - 506342',
  },
  {
    Number: 'TS-16',
    City: 'Nizamabad',
    State: 'Telangana',
    Phone: '+91-8462-232193',
    Email: '-',
    Address: 'Nizamabad, Telangana - 503002',
  },
  {
    Number: 'TS-08',
    City: 'Ranga Reddy',
    State: 'Telangana',
    Phone: '+91-8413-23393051',
    Email: '-',
    Address: 'Ranga Reddy, Telangana - 500074',
  },
  {
    Number: 'TS-28',
    City: 'Bhadradri Kothagudem',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Bhadradri Kothagudem, Telangana - 581336',
  },
  {
    Number: 'TS-129',
    City: 'UNIT OFFICE KODAD',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UNIT OFFICE KODAD, Telangana',
  },
  {
    Number: 'TS-05',
    City: 'Nalgonda',
    State: 'Telangana',
    Phone: '+91-8682-244346',
    Email: '-',
    Address: 'Nalgonda, Telangana - 508247',
  },
  {
    Number: 'TS-38',
    City: 'Narayanpet',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Narayanpet, Telangana',
  },
  {
    Number: 'TS-22',
    City: 'Peddapalli',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Peddapalli, Telangana - 505172',
  },
  {
    Number: 'TS-30',
    City: 'Yadadri Bhuvanagiri',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Yadadri Bhuvanagiri, Telangana - 508101',
  },
  {
    Number: 'TS-29',
    City: 'Suryapet',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Suryapet, Telangana - 508213',
  },
  {
    Number: 'TS-36',
    City: 'Siddipet',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'Siddipet, Telangana - 502103',
  },
  {
    Number: 'TS-216',
    City: 'BHODHAN',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'BHODHAN, Telangana',
  },
  {
    Number: 'TS-108',
    City: 'UPPAL',
    State: 'Telangana',
    Phone: '-',
    Email: '-',
    Address: 'UPPAL, Telangana',
  },

  // Tripura
  {
    Number: 'TR-01',
    City: 'Agartala',
    State: 'Tripura',
    Phone: '+91-381-2324601',
    Email: '-',
    Address: 'Agartala, West Tripura, Tripura - 799001',
  },
  {
    Number: 'TR-05',
    City: 'Ambassa',
    State: 'Tripura',
    Phone: '+91-3826-222214',
    Email: '-',
    Address: 'Ambassa, Tripura - 799289',
  },
  {
    Number: 'TR-04',
    City: 'Dharamanagar',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Dharmanagar, North Tripura, Tripura - 799250',
  },
  {
    Number: 'TR-02',
    City: 'Kailashahar',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Kailashahar, North Tripura, Tripura - 799277',
  },
  {
    Number: 'TR-08',
    City: 'South Tripura Dto',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Tripura',
  },
  {
    Number: 'TR-07',
    City: 'Sepahijala Dto',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Tripura',
  },
  {
    Number: 'TR-99',
    City: 'Sta Tripura',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Tripura',
  },
  {
    Number: 'TR-06',
    City: 'Khowai Dto',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Tripura',
  },
  {
    Number: 'TR-A4',
    City: 'Dhalai Dto',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Tripura',
  },
  {
    Number: 'TR-03',
    City: 'Gomati Dto',
    State: 'Tripura',
    Phone: '-',
    Email: '-',
    Address: 'Tripura',
  },
  // Uttar pradesh
  {
    Number: 'UP-80',
    City: 'Agra',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Agra, Uttar Pradesh - 282002',
  },
  {
    Number: 'UP-60',
    City: 'Ballia',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ballia, Uttar Pradesh - 221712',
  },
  {
    Number: 'UP-81',
    City: 'Aligarh',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Aligarh, Uttar Pradesh - 202001',
  },
  {
    Number: 'UP-24',
    City: 'Badaun',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Badaun, Uttar Pradesh - 243601',
  },
  {
    Number: 'UP-70',
    City: 'Allahabad',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Allahabad, Uttar Pradesh - 211002',
  },
  {
    Number: 'UP-67',
    City: 'Chandauli',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-01',
    City: 'Almora',
    State: 'Uttar Pradesh',
    Phone: '+91-5962-254009',
    Email: '-',
    Address: 'Almora, Uttarakhand - 263601',
  },
  {
    Number: 'UP-55',
    City: 'Siddharth Nagar',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Siddharth Nagar, Uttar Pradesh - 272153',
  },
  {
    Number: 'UP-76',
    City: 'Farrukhabad',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Farrukhabad, Uttar Pradesh - 209601',
  },
  {
    Number: 'UP-50',
    City: 'Azamgarh',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Azamgarh, Uttar Pradesh - 276001',
  },
  {
    Number: 'UP-82',
    City: 'Etah',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Etah, Uttar Pradesh - 207001',
  },
  {
    Number: 'UP-07',
    City: 'Dehradun',
    State: 'Uttar Pradesh',
    Phone: '+91-135-2743432',
    Email: '-',
    Address: 'Dehradun, Uttarakhand - 248001',
  },
  {
    Number: 'UP-42',
    City: 'Faizabad',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Faizabad, Uttar Pradesh - 224001',
  },
  {
    Number: 'UP-14',
    City: 'Ghaziabad',
    State: 'Uttar Pradesh',
    Phone: '+91-575-2703884',
    Email: '-',
    Address: 'Ghaziabad, Uttar Pradesh - 201002',
  },
  {
    Number: 'UP-25',
    City: 'Bareilly',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Bareilly, Uttar Pradesh - 243001',
  },
  {
    Number: 'UP-36',
    City: 'Lucknow',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Lucknow, Uttar Pradesh - 226001',
  },
  {
    Number: 'UP-13',
    City: 'Bulandshahr',
    State: 'Uttar Pradesh',
    Phone: '+91-5732-221370',
    Email: '-',
    Address: 'Bulandshahr, Uttar Pradesh - 203001',
  },
  {
    Number: 'UP-47',
    City: 'Balrampur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-44',
    City: 'Sultanpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sultanpur, Uttar Pradesh - 228001',
  },
  {
    Number: 'UP-37',
    City: 'Hapur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Hapur, Ghaziabad, Uttar Pradesh - 245101',
  },
  {
    Number: 'UP-91',
    City: 'Hamirpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Hamirpur, Uttar Pradesh - 210301',
  },
  {
    Number: 'UP-53',
    City: 'Gorakhpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Gorakhpur, Uttar Pradesh - 273001',
  },
  {
    Number: 'UP-31',
    City: 'Kheri',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kheri, Uttar Pradesh - 262701',
  },
  {
    Number: 'UP-04',
    City: 'UDHAM SINGH NGR',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'UDHAM SINGH NGR, Uttar Pradesh',
  },
  {
    Number: 'UP-26',
    City: 'Pilibhit',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Pilibhit, Uttar Pradesh - 262001',
  },
  {
    Number: 'UP-27',
    City: 'Shahjahanpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Shahjahanpur, Uttar Pradesh - 242001',
  },
  {
    Number: 'UP-19',
    City: 'Yet to be alloted',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-28',
    City: 'AYODHYA',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'AYODHYA, Uttar Pradesh',
  },
  {
    Number: 'UP-93',
    City: 'Jhansi',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Jhansi, Uttar Pradesh - 284001',
  },
  {
    Number: 'UP-77',
    City: 'Kanpur Dehat (Rural)',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kanpur Dehat, Uttar Pradesh - 208001',
  },
  {
    Number: 'UP-64',
    City: 'Sonbhadra',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sonbhadra, Uttar Pradesh - 231216',
  },
  {
    Number: 'UP-86',
    City: 'Mahamaya Nagar',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mahamaya Nagar, Uttar Pradesh - 204101',
  },
  {
    Number: 'UP-12',
    City: 'Muzaffarnagar',
    State: 'Uttar Pradesh',
    Phone: '+91-131-2433841',
    Email: '-',
    Address: 'Muzaffarnagar, Uttar Pradesh - 251001',
  },
  {
    Number: 'UP-52',
    City: 'Deoria',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Deoria, Uttar Pradesh - 274001',
  },
  {
    Number: 'UP-96',
    City: 'Chitrakoot',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-65',
    City: 'Varanasi',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Varanasi, Uttar Pradesh - 221002',
  },
  {
    Number: 'UP-51',
    City: 'Basti',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Basti, Uttar Pradesh - 272001',
  },
  {
    Number: 'UP-73',
    City: 'Kaushambi',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kaushambi, Uttar Pradesh - 212207',
  },
  {
    Number: 'UP-45',
    City: 'Ambedkar Nagar',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ambedkar Nagar, Uttar Pradesh - 224122',
  },
  {
    Number: 'UP-32',
    City: 'Lucknow',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Lucknow, Uttar Pradesh - 226001',
  },
  {
    Number: 'UP-83',
    City: 'Firozabad',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Firozabad, Uttar Pradesh - 283203',
  },
  {
    Number: 'UP-21',
    City: 'Moradabad',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Moradabad, Uttar Pradesh - 244001',
  },
  {
    Number: 'UP-46',
    City: 'Shravasti',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-17',
    City: 'Bagpat',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Bagpat, Uttar Pradesh - 250609',
  },
  {
    Number: 'UP-05',
    City: 'CHAMOLI',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'CHAMOLI, Uttar Pradesh',
  },
  {
    Number: 'UP-79',
    City: 'Auraiya',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Auraiya, Uttar Pradesh - 206244',
  },
  {
    Number: 'UP-35',
    City: 'Unnao',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Unnao, Uttar Pradesh - 209801',
  },
  {
    Number: 'UP-02',
    City: 'Haldwani',
    State: 'Uttar Pradesh',
    Phone: '+91-1334-260121',
    Email: '-',
    Address: 'Haridwar, Uttarakhand - 247663',
  },
  {
    Number: 'UP-20',
    City: 'Bijnor',
    State: 'Uttar Pradesh',
    Phone: '+91-1342-261325',
    Email: '-',
    Address: 'Bijnor, Uttar Pradesh - 246701',
  },
  {
    Number: 'UP-56',
    City: 'Maharajganj',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-03',
    City: 'PITHORAGARH',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'PITHORAGARH, Uttar Pradesh',
  },
  {
    Number: 'UP-66',
    City: 'Bhadohi',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Bhadohi, Sant Ravidas Nagar, Uttar Pradesh - 221401',
  },
  {
    Number: 'UP-75',
    City: 'Etawah',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Etawah, Uttar Pradesh',
  },
  {
    Number: 'UP-63',
    City: 'Mirzapur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mirzapur, Uttar Pradesh - 231001',
  },
  {
    Number: 'UP-61',
    City: 'Ghazipur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Ghazipur, Uttar Pradesh - 233001',
  },
  {
    Number: 'UP-94',
    City: 'Lalitpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Lalitpur, Uttar Pradesh - 284403',
  },
  {
    Number: 'UP-92',
    City: 'Jalaun',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Jalaun, Uttar Pradesh',
  },
  {
    Number: 'UP-41',
    City: 'Barabanki',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Barabanki, Uttar Pradesh - 225001',
  },
  {
    Number: 'UP-90',
    City: 'Banda',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Banda, Uttar Pradesh - 210001',
  },
  {
    Number: 'UP-15',
    City: 'Meerut',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Meerut, Uttar Pradesh - 250002',
  },
  {
    Number: 'UP-22',
    City: 'Rampur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Rampur, Uttar Pradesh - 244901',
  },
  {
    Number: 'UP-08',
    City: 'TEHRI (DEFUNCT)',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'TEHRI (DEFUNCT), Uttar Pradesh',
  },
  {
    Number: 'UP-10',
    City: 'HARIDWAR',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'HARIDWAR, Uttar Pradesh',
  },
  {
    Number: 'UP-30',
    City: 'Hardoi',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Hardoi, Uttar Pradesh - 241001',
  },
  {
    Number: 'UP-09',
    City: 'UTTARKASHI',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'UTTARKASHI, Uttar Pradesh',
  },
  {
    Number: 'UP-40',
    City: 'Bahraich',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Bahraich, Uttar Pradesh - 271801',
  },
  {
    Number: 'UP-85',
    City: 'Mathura',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mathura, Uttar Pradesh - 281001',
  },
  {
    Number: 'UP-74',
    City: 'Kannauj',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kannauj, Uttar Pradesh - 209721',
  },
  {
    Number: 'UP-84',
    City: 'Mainpuri',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mainpuri, Uttar Pradesh - 205001',
  },
  {
    Number: 'UP-95',
    City: 'Mahoba',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Mahoba, Uttar Pradesh - 210426',
  },
  {
    Number: 'UP-33',
    City: 'Raebareli',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Raebareli, Uttar Pradesh - 229001',
  },
  {
    Number: 'UP-72',
    City: 'Pratapgarh',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Pratapgarh, Uttar Pradesh - 230001',
  },
  {
    Number: 'UP-23',
    City: 'Jyotiba Phule Nagar',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Jyotiba Phule Nagar, Uttar Pradesh - 244221',
  },
  {
    Number: 'UP-38',
    City: 'Yet to be alloted',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Pradesh',
  },
  {
    Number: 'UP-78',
    City: 'Kanpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kanpur Nagar, Uttar Pradesh - 208002',
  },
  {
    Number: 'UP-57',
    City: 'Padrauna',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Padrauna, Kushinagar, Uttar Pradesh - 274304',
  },
  {
    Number: 'UP-06',
    City: 'PAURI (DEFUNCT)',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'PAURI (DEFUNCT), Uttar Pradesh',
  },
  {
    Number: 'UP-87',
    City: 'Kanshiram Nagar',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Kanshiram Nagar, Uttar Pradesh - 207123',
  },
  {
    Number: 'UP-62',
    City: 'Jaunpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Jaunpur, Uttar Pradesh - 222001',
  },
  {
    Number: 'UP-11',
    City: 'Saharanpur',
    State: 'Uttar Pradesh',
    Phone: '+91-132-2614788',
    Email: '-',
    Address: 'Saharanpur, Uttar Pradesh - 247001',
  },
  {
    Number: 'UP-71',
    City: 'Fatehpur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Fatehpur, Uttar Pradesh - 212601',
  },
  {
    Number: 'UP-18',
    City: 'PRABUDDHA NAGAR',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'PRABUDDHA NAGAR, Uttar Pradesh',
  },
  {
    Number: 'UP-58',
    City: 'Sant Kabir Nagar',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sant Kabir Nagar, Uttar Pradesh - 272176',
  },
  {
    Number: 'UP-43',
    City: 'Gonda',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Gonda, Uttar Pradesh - 271001',
  },
  {
    Number: 'UP-16',
    City: 'Noida',
    State: 'Uttar Pradesh',
    Phone: '+91-120-2505556',
    Email: '-',
    Address: 'Noida, Uttar Pradesh - 201308',
  },
  {
    Number: 'UP-34',
    City: 'Sitapur',
    State: 'Uttar Pradesh',
    Phone: '-',
    Email: '-',
    Address: 'Sitapur, Uttar Pradesh - 261001',
  },
  // Uttarakhand
  {
    Number: 'UK-01',
    City: 'Almora Rto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-16',
    City: 'Vikas Nagar Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-19',
    City: 'Ramnagar Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-12',
    City: 'Pauri Rto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-15',
    City: 'Kotdwar Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-04',
    City: 'Haldwani Rto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-07',
    City: 'Dehra Dun',
    State: 'Uttarakhand',
    Phone: '+91-135-2743432',
    Email: '-',
    Address: 'Dehradun, Uttarakhand - 248001',
  },
  {
    Number: 'UK-17',
    City: 'Roorkee',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Roorkee, Haridwar, Uttarakhand - 247667',
  },
  {
    Number: 'UK-08',
    City: 'Haridwar',
    State: 'Uttarakhand',
    Phone: '+91-1334-260121',
    Email: '-',
    Address: 'Haridwar, Uttarakhand - 247663',
  },
  {
    Number: 'UK-20',
    City: 'Ranikhet Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-11',
    City: 'Karanprayag Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-13',
    City: 'Rudraprayag Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-02',
    City: 'Bageshwar',
    State: 'Uttarakhand',
    Phone: '+91-5963-220099',
    Email: '-',
    Address: 'Bageshwar, Uttarakhand - 263679',
  },
  {
    Number: 'UK-03',
    City: 'Champawat',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Champawat, Uttarakhand - 262523',
  },
  {
    Number: 'UK-14',
    City: 'Rishikesh',
    State: 'Uttarakhand',
    Phone: '+91-135-2430623',
    Email: '-',
    Address: 'Rishikesh, Dehradun, Uttarakhand - 249201',
  },
  {
    Number: 'UK-05',
    City: 'Pithoragarh Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-18',
    City: 'Kashipur',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Kashipur, Udham Singh Nagar, Uttarakhand - 244713',
  },
  {
    Number: 'UK-09',
    City: 'Tehri Arto',
    State: 'Uttarakhand',
    Phone: '-',
    Email: '-',
    Address: 'Uttarakhand',
  },
  {
    Number: 'UK-10',
    City: 'Uttarkashi',
    State: 'Uttarakhand',
    Phone: '+91-1374-211174',
    Email: '-',
    Address: 'Uttarkashi, Uttarakhand - 249171',
  },
  {
    Number: 'UK-06',
    City: 'Udham Singh Nagar',
    State: 'Uttarakhand',
    Phone: '+91-5944-242555',
    Email: '-',
    Address: 'Udham Singh Nagar, Uttarakhand - 244713',
  },
  {
    Number: 'WB-69',
    City: 'Alipore',
    State: 'West Bengal',
    Phone: '03564-256391',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motorvehicles Department Alipurduar Court,alipurduar',
  },
  {
    Number: 'WB-62',
    City: 'Balurghat',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Dakshin Dinajpur District Hq',
  },
  {
    Number: 'WB-58',
    City: 'Murshidabad',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Murshidabad District Hq',
  },
  {
    Number: 'WB-56',
    City: 'Puruliya',
    State: 'West Bengal',
    Phone: '03252-222018',
    Email: '-',
    Address: 'Postmaster, Purulia H.o, Puruliya, West Bengal',
  },
  {
    Number: 'WB-59',
    City: 'North-Dinajpur',
    State: 'West Bengal',
    Phone: '03523-252483',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Karnajhora,uttardinajpur',
  },
  {
    Number: 'WB-52',
    City: 'Nadia',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'The Regional Transport Officer ( Rto )',
  },
  {
    Number: 'WB-94',
    City: 'Murshidabad',
    State: 'West Bengal',
    Phone: '03242-251650',
    Email: '-',
    Address: 'New Administrative Building Distrit Murshidabaad',
  },
  {
    Number: 'WB-57',
    City: 'Murshidabad',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department,berhampur,murshidabad',
  },
  {
    Number: 'WB-22',
    City: 'Alipore',
    State: 'West Bengal',
    Phone: '033-24791644',
    Email: '-',
    Address: 'Postmaster, Alipore H.o, Kolkata, West Bengal',
  },
  {
    Number: 'WB-98',
    City: 'Diamond Harbour',
    State: 'West Bengal',
    Phone: '03174-255672',
    Email: '-',
    Address: 'Postmaster, Post Office Diamond Harbour (head Office), South 24 Parganas, West Bengal (wb)',
  },
  {
    Number: 'WB-79',
    City: 'Kalimpong',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Sub-divisional Office In Darjeeling',
  },
  {
    Number: 'WB-03',
    City: 'Barrackpore',
    State: 'West Bengal',
    Phone: '033-25920276',
    Email: '-',
    Address: 'Postmaster, Post Office Barrackpore (head Office), North 24 Parganas',
  },
  {
    Number: 'WB-06',
    City: 'Kolkata Ruby',
    State: 'West Bengal',
    Phone: '+91-',
    Email: '-',
    Address: 'Ruby, Kolkata, West Bengal - 700101',
  },
  {
    Number: 'WB-65',
    City: 'Malda',
    State: 'West Bengal',
    Phone: '03512-252059',
    Email: '-',
    Address: 'O/o The District Magistrate Motorvehicles Department,new Collectorate Bldgs,malda Po&dt',
  },
  {
    Number: 'WB-96',
    City: 'Baruipur',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address:
      'The Postmaster, Baruipur Head Post Office, Baruipur, South 24 Parganas, South Presidency, Kolkata, West Bengal [wb]',
  },
  {
    Number: 'WB-86',
    City: 'Mathabhanga',
    State: 'West Bengal',
    Phone: '03583-255260',
    Email: '-',
    Address: 'Vill. - Shikarpur, P.o. - Mathabhanga, Cooch Behar',
  },
  {
    Number: 'WB-95',
    City: 'Baruipur',
    State: 'West Bengal',
    Phone: '9830190277',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,baruipur',
  },
  {
    Number: 'WB-33',
    City: 'Midnapore',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Midnapore,paschimmedinipur',
  },
  {
    Number: 'WB-01',
    City: 'Kolkata',
    State: 'West Bengal',
    Phone: '24749263',
    Email: '-',
    Address: 'Office Of The Director 38 Beltala Road Kolkata',
  },
  {
    Number: 'WB-54',
    City: 'Birbhum',
    State: 'West Bengal',
    Phone: '91-03462-255222',
    Email: '-',
    Address: 'Office Of The District Magistrate & Collector , Birbhum',
  },
  {
    Number: 'WB-17',
    City: 'Hooghly',
    State: 'West Bengal',
    Phone: '9830225245',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,srirampore',
  },
  {
    Number: 'WB-42',
    City: 'Burdwan',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Burdwan, Bardhaman, West Bengal',
  },
  {
    Number: 'WB-39',
    City: 'Durgapur',
    State: 'West Bengal',
    Phone: '0343-',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motorvehicles Department Durhapur,burdwan',
  },
  {
    Number: 'WB-14',
    City: 'Howrah',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Belgachia Mansatala (sub Office), Howrah',
  },
  {
    Number: 'WB-78',
    City: 'Kalimpong',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Sub-divisional Office In Darjeeling',
  },
  {
    Number: 'WB-43',
    City: 'Kalna',
    State: 'West Bengal',
    Phone: '9434647091',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,kalna',
  },
  {
    Number: 'WB-89',
    City: 'Kalyani',
    State: 'West Bengal',
    Phone: '9433255559',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,kalyani',
  },
  {
    Number: 'WB-36',
    City: 'Midnapore',
    State: 'West Bengal',
    Phone: '03222-275659',
    Email: '-',
    Address: 'Postmaster, Post Office Midnapore (head Office)',
  },
  {
    Number: 'WB-74',
    City: 'Siliguri',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Sub-divisional Office In Darjeeling',
  },
  {
    Number: 'WB-15',
    City: 'Barasat',
    State: 'West Bengal',
    Phone: '033-26802411',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Chinsurah,hooghly',
  },
  {
    Number: 'WB-48',
    City: 'Birbhum',
    State: 'West Bengal',
    Phone: '91-03462-255222',
    Email: '-',
    Address: 'Office Of The District Magistrate & Collector , Birbhum',
  },
  {
    Number: 'WB-30',
    City: 'Tamluk',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Tamluk (head Office), East Midnapore',
  },
  {
    Number: 'WB-70',
    City: 'ALIPUR DWAR',
    State: 'West Bengal',
    Phone: '03244-265103',
    Email: '-',
    Address: 'ALIPUR DWAR, West Bengal',
  },
  {
    Number: 'WB-92',
    City: 'Islampur',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Islampur North Dinajpur (sub Office), North Dinajpur, West Bengal (wb)',
  },
  {
    Number: 'WB-76',
    City: 'Darjeeling',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Hq In Darjeeling Distirct',
  },
  {
    Number: 'WB-24',
    City: 'Barrackpore',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Barrackpore, North 24 Parganas, West Bengal',
  },
  {
    Number: 'WB-04',
    City: 'KOLKATA(PASS.)',
    State: 'West Bengal',
    Phone: '033-25920276',
    Email: '-',
    Address: 'KOLKATA(PASS.), West Bengal',
  },
  {
    Number: 'WB-51',
    City: 'Nadia',
    State: 'West Bengal',
    Phone: '03472-252853',
    Email: '-',
    Address: 'O/o The District Magistrate Motorvehicles Department Collectorate Bldg,kirshnanagar',
  },
  {
    Number: 'WB-60',
    City: 'North-Dinajpur',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Uttar Dinajpur District Hq',
  },
  {
    Number: 'WB-66',
    City: 'Malda',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Baluchar (sub Office), Malda, West Bengal (wb)',
  },
  {
    Number: 'WB-93',
    City: 'Jangipur',
    State: 'West Bengal',
    Phone: '9735075695',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,jangipur',
  },
  {
    Number: 'WB-82',
    City: 'Raghunathpur',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Raghunathpur (branch Office), North 24 Parganas, West Bengal (wb)',
  },
  {
    Number: 'WB-45',
    City: 'Rampurhat',
    State: 'West Bengal',
    Phone: '9434203421',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,rampurhat',
  },
  {
    Number: 'WB-81',
    City: 'Raghunathpur',
    State: 'West Bengal',
    Phone: '9434665090',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,raghunathpur',
  },
  {
    Number: 'WB-07',
    City: 'Saltlake Arto',
    State: 'West Bengal',
    Phone: '9434203421',
    Email: '-',
    Address: 'West Bengal',
  },
  {
    Number: 'WB-88',
    City: 'Bishnupur',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Bishnupur Bankura (sub Office), Bankura, West Bengal (wb)',
  },
  {
    Number: 'WB-37',
    City: 'Asansol',
    State: 'West Bengal',
    Phone: '0341-2258000',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motorvehicles Department Asansole,burdwan',
  },
  {
    Number: 'WB-71',
    City: 'Jalpaiguri',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department,new Collectoratebldg,jalpaiguri',
  },
  {
    Number: 'WB-91',
    City: 'Islampur',
    State: 'West Bengal',
    Phone: '9476388554',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,islampur',
  },
  {
    Number: 'WB-55',
    City: 'Puruliya',
    State: 'West Bengal',
    Phone: '03252-222186',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Collectoratebuilding,purulia',
  },
  {
    Number: 'WB-44',
    City: 'Asansol',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Asansol (head Office), Bardhaman, West Bengal (wb)',
  },
  {
    Number: 'WB-61',
    City: 'Balurghat',
    State: 'West Bengal',
    Phone: '03522-255684',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Balurghat,dakshindinajpur',
  },
  {
    Number: 'WB-41',
    City: 'Burdwan',
    State: 'West Bengal',
    Phone: '0342-2569519',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Collectoratebuilding,burdwan',
  },
  {
    Number: 'WB-25',
    City: 'Barasat',
    State: 'West Bengal',
    Phone: '033-25523882',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department North 24parganas,barasat',
  },
  {
    Number: 'WB-97',
    City: 'Diamond-Harbour',
    State: 'West Bengal',
    Phone: '9433162595',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer, Diamond Harbour',
  },
  {
    Number: 'WB-13',
    City: 'Howrah',
    State: 'West Bengal',
    Phone: '9830675762',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,uluberia,',
  },
  {
    Number: 'WB-90',
    City: 'Kalyani',
    State: 'West Bengal',
    Phone: '033-25828226',
    Email: '-',
    Address: 'Postmaster, Kalyani H.o, Nadia, West Bengal',
  },
  {
    Number: 'WB-26',
    City: 'Barasat',
    State: 'West Bengal',
    Phone: '+91-',
    Email: '-',
    Address: 'Barasat, North 24 Parganas, West Bengal - 700124',
  },
  {
    Number: 'WB-64',
    City: 'Cooch-Behar',
    State: 'West Bengal',
    Phone: '03582-240919',
    Email: '-',
    Address: 'Postmaster, New Cooch Behar S.o, Cooch Behar, West Bengal',
  },
  {
    Number: 'WB-16',
    City: 'Hooghly',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Postmaster, Post Office Hooghly (sub Office), Hooghly, West Bengal',
  },
  {
    Number: 'WB-31',
    City: 'Contai',
    State: 'West Bengal',
    Phone: '03220-255219',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motorvehicles Department Contai,purba Medinipur',
  },
  {
    Number: 'WB-40',
    City: 'Durgapur',
    State: 'West Bengal',
    Phone: '0343-2550807',
    Email: '-',
    Address: 'Postmaster, Post Office Durgapur (head Office), Bardhaman, West Bengal',
  },
  {
    Number: 'WB-28',
    City: 'Bangaon',
    State: 'West Bengal',
    Phone: '03215-259034',
    Email: '-',
    Address: 'Postmaster, Bangaon S.o , North 24 Parganas, West Benga',
  },
  {
    Number: 'WB-19',
    City: 'Alipore',
    State: 'West Bengal',
    Phone: '033-24791943',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Dept,new Admin Bdg,g-flr.south24-parganas',
  },
  {
    Number: 'WB-12',
    City: 'Howrah',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Howrah, West Bengal',
  },
  {
    Number: 'WB-87',
    City: 'Bishnupur',
    State: 'West Bengal',
    Phone: '8900188919',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,bishnupur',
  },
  {
    Number: 'WB-47',
    City: 'Bolpur',
    State: 'West Bengal',
    Phone: '9434237824',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,bolpur',
  },
  {
    Number: 'WB-49',
    City: 'Jhargram',
    State: 'West Bengal',
    Phone: '94342025696',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,jhargram',
  },
  {
    Number: 'WB-83',
    City: 'Chanchal',
    State: 'West Bengal',
    Phone: '9434423537',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,chanchal',
  },
  {
    Number: 'WB-02',
    City: 'Kolkata',
    State: 'West Bengal',
    Phone: '2479-1943',
    Email: '-',
    Address: 'Motor Vehicle Section, Office Of The District Magistrate, 24-pgs(s), Alipur.',
  },
  {
    Number: 'WB-27',
    City: 'Bangaon',
    State: 'West Bengal',
    Phone: '9433098398',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,bongaon',
  },
  {
    Number: 'WB-32',
    City: 'Contai',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Sub-divisional Office In East Midnapore',
  },
  {
    Number: 'WB-05',
    City: 'Kolkata',
    State: 'West Bengal',
    Phone: '9830371081',
    Email: '-',
    Address: 'Office Of The Arto, Cstc Depot Kasba, Kolkata',
  },
  {
    Number: 'WB-68',
    City: 'Bankura',
    State: 'West Bengal',
    Phone: '03244-265103',
    Email: '-',
    Address: 'Postmaster, Akui S.o, Bankura, West Bengal,',
  },
  {
    Number: 'WB-23',
    City: 'Barrackpore',
    State: 'West Bengal',
    Phone: '033-25920616',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motor Vehicles Department Barrackpore',
  },
  {
    Number: 'WB-21',
    City: 'Basirhat',
    State: 'West Bengal',
    Phone: '9433106714',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,basirhat',
  },
  {
    Number: 'WB-46',
    City: 'Rampurhat',
    State: 'West Bengal',
    Phone: '03461-255150',
    Email: '-',
    Address: 'Postmaster, Post Office Rampurhat (head Office), Birbhum',
  },
  {
    Number: 'WB-50',
    City: 'Jhargram',
    State: 'West Bengal',
    Phone: '3225255145',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Mv Sectionghatal Paschim Medinipur, West Bengal',
  },
  {
    Number: 'WB-53',
    City: 'Birbhum',
    State: 'West Bengal',
    Phone: '3462255517',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department Prasashanbhavan,suri, Birbhum',
  },
  {
    Number: 'WB-77',
    City: 'Darjeeling',
    State: 'West Bengal',
    Phone: '0354-2254306',
    Email: '-',
    Address: 'O/o The District Magistrate Otor Vehiclesdepartment Darjeeling',
  },
  {
    Number: 'WB-34',
    City: 'Midnapore',
    State: 'West Bengal',
    Phone: '03222-275659',
    Email: '-',
    Address: 'Postmaster, Post Office Midnapore (head Office)',
  },
  {
    Number: 'WB-10',
    City: 'BEHALA',
    State: 'West Bengal',
    Phone: '033-25920276',
    Email: '-',
    Address: 'BEHALA, West Bengal',
  },
  {
    Number: 'WB-85',
    City: 'Mathabhanga',
    State: 'West Bengal',
    Phone: '9434131890',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,mathabhanga',
  },
  {
    Number: 'WB-72',
    City: 'Jalpaiguri',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'Hq In Jalpaiguri Distirct',
  },
  {
    Number: 'WB-75',
    City: 'Katwa Arto',
    State: 'West Bengal',
    Phone: '9830371081',
    Email: '-',
    Address: 'West Bengal',
  },
  {
    Number: 'WB-08',
    City: 'Kolkata Salt Lake',
    State: 'West Bengal',
    Phone: '+91-',
    Email: '-',
    Address: 'Salt Lake, Kolkata, West Bengal - 700091',
  },
  {
    Number: 'WB-35',
    City: 'Kharagpur',
    State: 'West Bengal',
    Phone: '9831124684',
    Email: '-',
    Address: 'Motor Vehicles Department O/o Sub Divisional Officer,kharagpur',
  },
  {
    Number: 'WB-38',
    City: 'Asansol',
    State: 'West Bengal',
    Phone: '0341-2303661',
    Email: '-',
    Address: 'Postmaster, Post Office Asansol (head Office), Bardhaman, West Bengal',
  },
  {
    Number: 'WB-67',
    City: 'Bankura',
    State: 'West Bengal',
    Phone: '9433098398',
    Email: '-',
    Address: 'O/o The District Magistrate Motorvehicles Dept, Collectorat,tamlibandh,bankura',
  },
  {
    Number: 'WB-11',
    City: 'Barasat',
    State: 'West Bengal',
    Phone: '24612435',
    Email: '-',
    Address: 'O/o The District Magistrate Motor Vehicles Department,new Collectratebldgs,howrah,wb',
  },
  {
    Number: 'WB-09',
    City: 'Behala Arto',
    State: 'West Bengal',
    Phone: '9830190277',
    Email: '-',
    Address: 'West Bengal',
  },
  {
    Number: 'WB-63',
    City: 'Cooch-Behar',
    State: 'West Bengal',
    Phone: '03582-227125',
    Email: '-',
    Address: 'O/o The District Magistrate Sagar Dighicampus Coochbehar',
  },
  {
    Number: 'WB-29',
    City: 'Tamluk',
    State: 'West Bengal',
    Phone: '9830225245',
    Email: '-',
    Address: 'O/o The District Magistrate Motorvehicles Department Tamluk,purba Medinipur',
  },
  {
    Number: 'WB-20',
    City: 'South-24-Parganas',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'South 24 Parganas Hq',
  },
  {
    Number: 'WB-73',
    City: 'Siliguri',
    State: 'West Bengal',
    Phone: '9434203421',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motorvehicles Department Siliguri,darjeeling',
  },
  {
    Number: 'WB-18',
    City: 'Hooghly',
    State: 'West Bengal',
    Phone: '-',
    Email: '-',
    Address: 'O/o The Subdivisional Officer Motor Vehicles Department Arambagh,hooglywest Bengal',
  },
]
export default RTODetailsData
